var _polygon, _polygon2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTravelI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.68 257.66 214.49 250.63 246.99 231.86 259.17 238.9 226.68 257.66",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "96.69 332.71 84.51 325.67 117 306.91 129.19 313.94 96.69 332.71",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-5",
    cx: 249.48,
    cy: 352.94,
    rx: 244.24,
    ry: 135.79,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M301.43,264.85c4.81,2.81,4.81,7.36,0,10.17s-12.62,2.81-17.43,0-4.81-7.36,0-10.17S296.62,262,301.43,264.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M401.1,278.13c14.13,8.24,14.13,21.62,0,29.86s-37,8.25-51.15,0-14.13-21.62,0-29.86S387,269.88,401.1,278.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M457.38,296c15.39,9,15.39,23.56,0,32.55s-40.37,9-55.76,0-15.4-23.56,0-32.55S442,287.05,457.38,296Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M56.13,406.47c4.82,2.81,4.82,7.36,0,10.17s-12.61,2.81-17.42,0-4.82-7.36,0-10.17S51.32,403.66,56.13,406.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M182.29,475.16,49,398.22C44,395.3,44,390.51,49,387.59L251.36,270.78a8.43,8.43,0,0,1,7.58,0l141.4,81.64c.6.34.6.9,0,1.25L189.88,475.16A8.39,8.39,0,0,1,182.29,475.16Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.49,391a11,11,0,0,0,5.13,8.53l113,65.26a11.33,11.33,0,0,0,10.27,0L388.85,351.13a9.66,9.66,0,0,0,0-17.06l-113-65.26a11.33,11.33,0,0,0-10.27,0L68.62,382.5A11,11,0,0,0,63.49,391Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.62,388.43l113,65.26a11.33,11.33,0,0,0,10.27,0L388.85,340c2.83-1.64,2.83-4.3,0-5.93l-113-65.26a11.33,11.33,0,0,0-10.27,0L68.62,382.5C65.79,384.14,65.79,386.79,68.62,388.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.79,454.93V466a10.5,10.5,0,0,1-5.14-1.22l-113-65.26a9.63,9.63,0,0,1-.52-16.73c-2.3,1.65-2.12,4.07.52,5.6l113,65.27A10.61,10.61,0,0,0,186.79,454.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67,382.68c-2.66-1.53-2.52-4.13-2.52-7.4V220.81a11.35,11.35,0,0,1,5.14-8.9L258.21,98.22a11,11,0,0,1,10-.18c2.66,1.53,2.51,4.13,2.51,7.4V259.91a11.37,11.37,0,0,1-5.13,8.9L68.62,382.5A11,11,0,0,1,58.67,382.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.69,105.44c0-3.27-2.31-4.6-5.14-3L68.62,216.17A10.43,10.43,0,0,0,65,220l-7.33-4.26h0a10.54,10.54,0,0,1,3.64-3.84L258.21,98.22a11,11,0,0,1,10-.19C270.82,99.57,270.69,102.17,270.69,105.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,382.81a11.05,11.05,0,0,1-9.35-.13c-2.66-1.53-2.52-4.13-2.52-7.4V220.8a10.34,10.34,0,0,1,1.51-5.05L65,220h0a10.54,10.54,0,0,0-1.5,5.05V379.54C63.49,382.57,65.47,383.94,68,382.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,222.09,261.25,112.51c1.7-1,3.08-.19,3.08,1.78V258.47a6.81,6.81,0,0,1-3.08,5.34L71.39,373.39c-1.71,1-3.09.19-3.09-1.78V227.43A6.82,6.82,0,0,1,71.39,222.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,222.09,261.25,112.51c1.7-1,3.08-.19,3.08,1.78V258.47a6.81,6.81,0,0,1-3.08,5.34L71.39,373.39c-1.71,1-3.09.19-3.09-1.78V227.43A6.82,6.82,0,0,1,71.39,222.09Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.84,382.8,265.63,277.27a5.66,5.66,0,0,1,5.13,0l3.05,1.67c1.41.82,1.41,2.15,0,3L91,387.42a5.68,5.68,0,0,1-5.14,0l-3-1.65C81.42,385,81.42,383.62,82.84,382.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.17,391.33,280,285.8a5.22,5.22,0,0,1,4.69-.26L332.23,313c1.17.68,1,1.89-.44,2.71L149.21,421.11a5.24,5.24,0,0,1-4.7.26L96.74,394C95.56,393.36,95.76,392.15,97.17,391.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,330.12l5.72-3.3c.25-.14.27-.36.05-.48l-5.47-3.16a.9.9,0,0,0-.83,0l-5.73,3.31c-.24.14-.26.35-.05.48l5.48,3.16A.94.94,0,0,0,255.56,330.12Zm-8.36-11.43-5.72,3.3c-.24.14-.26.36,0,.48l5.48,3.16a.9.9,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35,0-.48L248,318.66A1,1,0,0,0,247.2,318.69Zm-18.48,10.67L219,335c-.24.14-.27.35-.05.48l5.48,3.16a.94.94,0,0,0,.83,0L235,333c.25-.14.27-.36.05-.48l-5.47-3.17A.94.94,0,0,0,228.72,329.36Zm10.12-5.84-5.72,3.3c-.25.14-.27.36-.05.48l5.47,3.16a.9.9,0,0,0,.83,0l5.73-3.3c.24-.14.26-.35.05-.48l-5.48-3.16A.91.91,0,0,0,238.84,323.52Zm-22.45,13-5.72,3.3c-.25.15-.27.36,0,.48l5.47,3.17a.94.94,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35,0-.48l-5.47-3.16A.94.94,0,0,0,216.39,336.48ZM208,341.31l-5.72,3.3c-.24.14-.26.36-.05.48l5.48,3.16a.9.9,0,0,0,.83,0l5.72-3.31c.24-.14.27-.35.05-.48l-5.47-3.16A1,1,0,0,0,208,341.31Zm21.46,12.9,5.73-3.31c.24-.14.26-.35,0-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.31c-.25.14-.27.35,0,.48l5.47,3.16A.94.94,0,0,0,229.48,354.21ZM221.12,359l5.72-3.31c.25-.14.27-.35,0-.48l-5.47-3.16a.94.94,0,0,0-.83,0l-5.73,3.3c-.24.15-.26.36-.05.48l5.48,3.17A.94.94,0,0,0,221.12,359Zm-8.36,4.83,5.72-3.31c.24-.14.26-.35.05-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.3c-.24.14-.27.36-.05.48l5.47,3.17A1,1,0,0,0,212.76,363.87Zm-8.37,4.83,5.72-3.31c.25-.14.27-.35,0-.48l-5.47-3.16a.94.94,0,0,0-.83,0l-5.73,3.3c-.24.14-.26.36,0,.48l5.48,3.16A.9.9,0,0,0,204.39,368.7ZM247.2,335l5.72-3.3c.24-.14.26-.36.05-.48L247.49,328a.9.9,0,0,0-.83,0l-5.72,3.31c-.24.14-.27.35-.05.48l5.47,3.16A1,1,0,0,0,247.2,335Zm-9.35,14.43L250.62,342c.24-.14.26-.36,0-.48l-13.29-7.68a.94.94,0,0,0-.83,0l-6.61,3.81c-.24.14-.26.36-.05.48l7,4.07c.22.12.2.34,0,.48l-5.28,3c-.24.14-.26.35-.05.48l5.48,3.16A.94.94,0,0,0,237.85,349.38Zm-38.19-3.24-5.72,3.3c-.25.14-.27.36-.05.48l5.47,3.16a.9.9,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35.05-.48l-5.48-3.16A.94.94,0,0,0,199.66,346.14ZM191.3,351l-5.73,3.3c-.24.14-.26.36,0,.48l5.48,3.16a.9.9,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35,0-.48l-5.47-3.16A.94.94,0,0,0,191.3,351ZM145,402.53a.94.94,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36.05-.48l-5.47-3.16a.9.9,0,0,0-.83,0l-5.73,3.31c-.24.14-.26.35-.05.48ZM124.38,389.6l-5.72,3.31c-.25.14-.27.35,0,.48l5.47,3.16a.94.94,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35.05-.48l-5.48-3.16A.94.94,0,0,0,124.38,389.6ZM135,399.28a.9.9,0,0,0,.83,0l5.72-3.31c.24-.14.26-.35.05-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.3c-.24.14-.27.36-.05.48Zm23.07,5.19,5.73-3.3c.24-.14.26-.35.05-.48l-5.48-3.16a.9.9,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.36-.05.48l5.47,3.16A.88.88,0,0,0,158.06,404.47Zm-9.19,4.86a.91.91,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36.05-.48L150,402.36a.93.93,0,0,0-.84,0l-5.72,3.3c-.24.14-.26.36-.05.48Zm-16.13-24.56L127,388.08c-.24.14-.26.35,0,.48l5.48,3.16a.94.94,0,0,0,.83,0l5.72-3.3c.24-.14.27-.36.05-.48l-5.47-3.17A1,1,0,0,0,132.74,384.77Zm41.83-24.14-5.73,3.3c-.24.14-.26.36-.05.48l5.48,3.16a.9.9,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36.05-.48l-5.47-3.16A.9.9,0,0,0,174.57,360.63Zm-33.46,19.31-5.72,3.31c-.25.14-.27.35,0,.48l5.47,3.16a.94.94,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36,0-.48l-5.47-3.17A.94.94,0,0,0,141.11,379.94Zm41.82-24.14-5.72,3.3c-.25.14-.27.36-.05.48l5.47,3.16a.88.88,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.16A.91.91,0,0,0,182.93,355.8Zm-16.73,9.66-5.72,3.3c-.24.14-.27.36,0,.48l5.47,3.16a.93.93,0,0,0,.84,0l5.72-3.3c.24-.14.26-.36,0-.48L167,365.43A.91.91,0,0,0,166.2,365.46Zm-8.36,4.82-5.73,3.31c-.24.14-.26.35-.05.48l5.48,3.16a.9.9,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36,0-.48l-5.47-3.16A.9.9,0,0,0,157.84,370.28Zm-8.37,4.83-5.72,3.31c-.24.14-.27.35-.05.48l5.48,3.16a.94.94,0,0,0,.83,0l5.72-3.3c.24-.14.27-.36.05-.48l-5.48-3.16A.9.9,0,0,0,149.47,375.11Zm38.19,3.24,5.73-3.3c.24-.14.26-.36,0-.48L188,371.41a.9.9,0,0,0-.83,0l-5.73,3.3c-.24.14-.26.36,0,.48l5.47,3.16A.9.9,0,0,0,187.66,378.35Zm78-70.34L260,311.32c-.24.14-.26.35-.05.48L265.4,315a.94.94,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36.05-.48L266.53,308A1,1,0,0,0,265.69,308Zm-10.12,5.85-5.72,3.3c-.25.14-.27.36,0,.48l5.47,3.16a.9.9,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35.05-.48l-5.48-3.16A.94.94,0,0,0,255.57,313.86Zm18.49-10.68-5.72,3.31c-.25.14-.27.35,0,.48l5.47,3.16a.94.94,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.16A.9.9,0,0,0,274.06,303.18Zm-46.23,42.95,5.72-3.3c.24-.14.26-.36,0-.48l-5.48-3.16a.91.91,0,0,0-.83,0l-5.72,3.3c-.24.14-.27.36,0,.48l5.47,3.16A.93.93,0,0,0,227.83,346.13Zm55.43-47.8a.92.92,0,0,0-.84,0l-5.72,3.31c-.24.14-.26.35-.05.48l5.48,3.16a.91.91,0,0,0,.83,0l5.72-3.3c.24-.14.27-.36.05-.48ZM196,373.53l5.72-3.31c.24-.14.26-.35.05-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.3c-.24.14-.27.36-.05.48l5.48,3.16A.9.9,0,0,0,196,373.53ZM298.6,314.3l5.72-3.3c.25-.14.27-.36.05-.48l-5.47-3.16a.9.9,0,0,0-.83,0l-5.73,3.3c-.24.14-.26.36,0,.48l5.48,3.16A.9.9,0,0,0,298.6,314.3Zm-16.18.32,5.72-3.31c.24-.14.26-.35.05-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.36-.05.48l5.47,3.17A1,1,0,0,0,282.42,314.62Zm8.66-11.78a.94.94,0,0,0-.83,0l-5.73,3.31c-.24.14-.26.35,0,.47l5.48,3.17a.94.94,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35.05-.48Zm1.76-1,13.29,7.67a.93.93,0,0,0,.84,0l5.72-3.3c.24-.14.26-.35.05-.48L299.44,298a.94.94,0,0,0-.83,0l-5.72,3.31C292.64,301.49,292.62,301.7,292.84,301.83Zm-19.32,10.7-5.73,3.3c-.24.14-.26.36-.05.48l5.48,3.16a.9.9,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35.05-.48l-5.47-3.16A.94.94,0,0,0,273.52,312.53Zm-63,36.35-5.72,3.3c-.24.14-.27.36-.05.48l5.48,3.16a.91.91,0,0,0,.83,0l5.72-3.3c.24-.14.27-.36.05-.48l-5.48-3.16A.91.91,0,0,0,210.56,348.88Zm78.85-29.72a.91.91,0,0,0,.83,0l5.72-3.3c.24-.14.27-.36.05-.48l-5.48-3.16a.91.91,0,0,0-.83,0l-5.72,3.3c-.24.14-.27.36-.05.48Zm-70.48,24.89-5.73,3.3c-.24.14-.26.36,0,.48l5.47,3.16a.9.9,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36,0-.48L219.76,344A.9.9,0,0,0,218.93,344.05ZM153.37,397.7a.94.94,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36,0-.48l-5.48-3.16a.9.9,0,0,0-.83,0L148,394.06c-.25.14-.27.35,0,.48Zm-9.72-10.19-5.73,3.3c-.24.14-.26.36,0,.48l5.47,3.16a.9.9,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35,0-.48l-5.47-3.16A.94.94,0,0,0,143.65,387.51Zm18.92,5.33,5.72-3.3c.24-.14.27-.36.05-.48l-5.47-3.16a.9.9,0,0,0-.84,0l-5.72,3.3c-.24.14-.26.35-.05.48l5.48,3.16A.94.94,0,0,0,162.57,392.84Zm8.36-4.83,5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.16a.9.9,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.36-.05.48L170.1,388A.9.9,0,0,0,170.93,388Zm8.37-4.83,5.72-3.3c.24-.14.27-.36,0-.48l-5.48-3.16a.91.91,0,0,0-.83,0l-5.72,3.3c-.24.14-.27.36,0,.48l5.48,3.16A.91.91,0,0,0,179.3,383.18Zm-27.29-.5-5.72,3.3c-.24.14-.27.36,0,.48l5.47,3.17a1,1,0,0,0,.84,0l5.72-3.31c.24-.14.26-.35,0-.48l-5.48-3.16A.94.94,0,0,0,152,382.68Zm8.37-4.83-5.73,3.3c-.24.15-.26.36-.05.49l5.48,3.16a.94.94,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35.05-.48l-5.47-3.16A.94.94,0,0,0,160.38,377.85Zm33.45-19.32-5.72,3.31c-.24.14-.26.35-.05.48l5.48,3.16a.94.94,0,0,0,.83,0l5.72-3.3c.24-.14.27-.36,0-.48l-5.47-3.16A.92.92,0,0,0,193.83,358.53Zm-8.36,4.83-5.72,3.31c-.25.14-.27.35-.05.48l5.47,3.16a.94.94,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.17A.94.94,0,0,0,185.47,363.36Zm16.73-9.66L196.48,357c-.25.14-.27.35,0,.48l5.47,3.16a.94.94,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36,0-.48L203,353.68A.9.9,0,0,0,202.2,353.7ZM168.74,373,163,376.33c-.25.14-.27.35-.05.48l5.47,3.16a.94.94,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35.05-.48L169.57,373A.94.94,0,0,0,168.74,373Zm8.36-4.83-5.72,3.31c-.24.14-.26.35,0,.48l5.48,3.16a.94.94,0,0,0,.83,0l5.72-3.3c.25-.15.27-.36,0-.48l-5.47-3.17A1,1,0,0,0,177.1,368.19Zm-10.67,31.46,5.72-3.31c.24-.14.27-.35,0-.48l-5.47-3.16a1,1,0,0,0-.84,0l-5.72,3.3c-.24.14-.26.36,0,.48l5.48,3.16A.9.9,0,0,0,166.43,399.65Zm-44.11-2.09-5.47-3.16a1,1,0,0,0-.84,0l-5.72,3.31c-.24.14-.26.35-.05.48l5.48,3.16a.94.94,0,0,0,.83,0l5.72-3.31C122.52,397.9,122.54,397.69,122.32,397.56Zm10.9,2.74-5.47-3.16a.94.94,0,0,0-.83,0l-8.81,5.08c-.24.14-.26.36,0,.48l5.48,3.16a.9.9,0,0,0,.83,0l8.81-5.08C133.42,400.64,133.44,400.43,133.22,400.3Zm-19.07-9-5.48-3.16a.91.91,0,0,0-.83,0l-7,4.06c-.24.14-.27.36,0,.48l5.47,3.17a1,1,0,0,0,.84,0l7-4.07C114.34,391.66,114.36,391.45,114.15,391.32Zm5.4-3.12a.91.91,0,0,0,.83,0l5.72-3.3c.25-.14.27-.35.05-.48l-5.47-3.16a.9.9,0,0,0-.83,0l-5.73,3.3c-.24.14-.26.36-.05.48Zm23.7,15.35-5.48-3.17a.94.94,0,0,0-.83,0l-11,6.36c-.24.14-.26.35,0,.48l5.47,3.16a.94.94,0,0,0,.83,0l11-6.35C143.44,403.89,143.46,403.67,143.25,403.55Zm3.86,6.8-5.48-3.16a.91.91,0,0,0-.83,0l-7,4.06c-.25.14-.27.36,0,.48l5.47,3.16a.9.9,0,0,0,.83,0l7.05-4.07C147.3,410.69,147.32,410.47,147.11,410.35Zm34.63-58.05a.94.94,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35.05-.48l-5.47-3.16a.94.94,0,0,0-.83,0l-5.73,3.31c-.24.14-.26.35-.05.48ZM165,362a.94.94,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35,0-.48L166.14,355a.94.94,0,0,0-.83,0l-5.73,3.3c-.24.14-.26.36,0,.48Zm-37.1,21.41a.9.9,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35.05-.48L129,376.4a.94.94,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.36,0,.48Zm45.47-26.24a.94.94,0,0,0,.83,0l5.72-3.31c.24-.14.26-.35,0-.48l-5.48-3.16a.94.94,0,0,0-.83,0L168,353.49c-.24.14-.27.35,0,.48Zm-16.73,9.66a.94.94,0,0,0,.83,0l5.72-3.31c.24-.14.27-.35.05-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.3c-.24.14-.26.36-.05.48Zm-5.44,43.9a.91.91,0,0,0-.83,0l-8.8,5.08c-.24.14-.27.35-.05.48l5.47,3.16a1,1,0,0,0,.84,0l8.8-5.08c.24-.14.27-.36.05-.48Zm-6.57-37a.94.94,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35.05-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.36-.05.48Zm-8.36,4.82a.9.9,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35,0-.48l-5.47-3.16a1,1,0,0,0-.84,0l-5.72,3.3c-.24.14-.26.36,0,.48Zm169.9-57.32a.9.9,0,0,0-.83,0l-14.09,8.13c-.24.14-.27.36-.05.48l5.48,3.16a.91.91,0,0,0,.83,0l14.08-8.13c.25-.14.27-.35,0-.48Zm-18.49,10.67a.94.94,0,0,0-.83,0l-5.73,3.31c-.24.14-.26.35-.05.48l5.48,3.16a.94.94,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36.05-.48Zm-112.9,62.93,5.73-3.31c.24-.14.26-.35,0-.48l-5.47-3.16a.94.94,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.36,0,.48l5.47,3.16A.9.9,0,0,0,174.79,394.82ZM271,341.55a.94.94,0,0,0-.83,0l-5.73,3.31c-.24.14-.26.35,0,.48l5.47,3.16a.94.94,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35.05-.48Zm43.58-25.16a.94.94,0,0,0-.83,0l-5.72,3.3c-.24.14-.27.36-.05.48l5.47,3.16a.92.92,0,0,0,.84,0L320,320c.24-.14.26-.35,0-.48Zm13.84-1.67L315.08,307a.94.94,0,0,0-.83,0l-5.72,3.31c-.24.14-.26.35,0,.48l13.3,7.67a.9.9,0,0,0,.83,0l5.72-3.31C328.58,315.06,328.6,314.85,328.38,314.72ZM239.7,359.6a.91.91,0,0,0-.83,0l-7,4.06c-.25.14-.27.36-.05.48l5.47,3.17a.94.94,0,0,0,.83,0l7-4.07c.24-.14.26-.36.05-.48Zm21.13-12.2a.91.91,0,0,0-.83,0l-8.8,5.08c-.25.14-.27.36,0,.48l5.47,3.16a.9.9,0,0,0,.83,0l8.81-5.08c.24-.14.26-.36.05-.48Zm-40.5,23.38a.94.94,0,0,0-.83,0L172.4,398c-.25.14-.27.35-.05.48l5.47,3.16a.94.94,0,0,0,.83,0l47.11-27.2c.24-.14.26-.35.05-.48ZM170.59,399.5a1,1,0,0,0-.84,0l-7,4.07c-.24.14-.27.35-.05.48l5.48,3.16a.94.94,0,0,0,.83,0l7-4.07c.24-.14.27-.35.05-.48ZM230,365.19a.94.94,0,0,0-.83,0l-7.05,4.07c-.24.14-.26.35,0,.48l5.48,3.16a.94.94,0,0,0,.83,0l7-4.07c.25-.14.27-.35.05-.48ZM160.9,405.1a.9.9,0,0,0-.83,0l-7,4.07c-.24.14-.26.36,0,.48l5.47,3.16a.9.9,0,0,0,.83,0l7.05-4.06c.24-.14.26-.36,0-.48ZM249.39,354a.9.9,0,0,0-.83,0l-7.05,4.06c-.24.14-.26.36,0,.48l5.48,3.16a.9.9,0,0,0,.83,0l7-4.07c.25-.14.27-.36.05-.48Zm29.93-17.29a.94.94,0,0,0-.83,0l-5.72,3.31c-.24.14-.27.35,0,.48l5.47,3.16a1,1,0,0,0,.84,0l5.72-3.3c.24-.15.26-.36.05-.49Zm18.74-13.07,5.72-3.31c.25-.14.27-.35.05-.48l-5.47-3.16a1,1,0,0,0-.84,0L291.8,320c-.24.14-.26.35-.05.48l5.48,3.16A.94.94,0,0,0,298.06,323.65Zm-34.13,1.64,5.72-3.3c.24-.14.26-.36.05-.48l-5.48-3.16a.88.88,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.35-.05.48l5.47,3.16A.93.93,0,0,0,263.93,325.29Zm-22.22,30.89,16.73-9.66c.24-.14.26-.35.05-.48L253,342.88a.94.94,0,0,0-.83,0l-16.73,9.66c-.24.14-.26.36,0,.48l5.48,3.16A.91.91,0,0,0,241.71,356.18Zm47.15-27.67a.94.94,0,0,0,.83,0l5.73-3.31c.24-.14.26-.35.05-.48L290,321.53a.94.94,0,0,0-.83,0l-5.72,3.31c-.25.14-.27.35-.05.48Zm-7-4.55,5.73-3.3c.24-.14.26-.36,0-.48L282.17,317a.88.88,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.35-.05.48L281,324A.9.9,0,0,0,281.87,324ZM233.34,361l5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.16a.9.9,0,0,0-.83,0l-5.72,3.31c-.25.14-.27.35-.05.48l5.47,3.16A.94.94,0,0,0,233.34,361Zm37-21.83a.9.9,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.16a.91.91,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.36-.05.48Zm-78.85,46,5.73-3.31c.24-.14.26-.35,0-.48l-5.47-3.16a.94.94,0,0,0-.83,0l-5.73,3.31c-.24.14-.26.35,0,.48l5.48,3.16A.94.94,0,0,0,191.52,385.16Zm8.37-4.83,5.72-3.31c.24-.14.26-.35,0-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.31c-.24.14-.27.35,0,.48l5.48,3.16A.94.94,0,0,0,199.89,380.33ZM183.16,390l5.72-3.31c.24-.14.27-.35.05-.48L183.45,383a.94.94,0,0,0-.83,0l-5.72,3.3c-.24.14-.26.36-.05.48l5.48,3.17A.94.94,0,0,0,183.16,390Zm33.46-19.32,5.72-3.3c.24-.14.26-.36,0-.48l-5.48-3.17a.94.94,0,0,0-.83,0l-5.72,3.31c-.25.14-.27.35-.05.48l5.47,3.16A1,1,0,0,0,216.62,370.67Zm-8.37,4.83,5.72-3.3c.25-.14.27-.36.05-.48l-5.47-3.17a.94.94,0,0,0-.83,0L202,371.89c-.24.14-.26.35-.05.48l5.48,3.16A.94.94,0,0,0,208.25,375.5ZM225,365.84l5.72-3.3c.25-.14.27-.36.05-.48l-5.47-3.16a.9.9,0,0,0-.83,0l-5.73,3.31c-.24.14-.26.35-.05.48l5.48,3.16A.94.94,0,0,0,225,365.84Zm45.64-67.18a1,1,0,0,0,.84,0l5.72-3.3c.24-.14.26-.36.05-.48l-1.46-.84a.9.9,0,0,0-.83,0l-5.72,3.31c-.25.14-.27.35-.05.48ZM229.05,325a.9.9,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36,0-.48L230.18,318a.9.9,0,0,0-.83,0l-5.73,3.3c-.24.14-.26.36-.05.48Zm16.73-9.66a.9.9,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35,0-.48l-5.47-3.16a.94.94,0,0,0-.83,0l-5.73,3.3c-.24.14-.26.36,0,.48Zm-26.94,15.56a.94.94,0,0,0,.83,0l5.72-3.3c.24-.14.27-.36.05-.48L220,323.91a.92.92,0,0,0-.84,0l-5.72,3.31c-.24.14-.26.35,0,.48Zm18.58-10.73a.88.88,0,0,0,.83,0l5.72-3.3c.24-.14.26-.35.05-.48l-5.48-3.16a.91.91,0,0,0-.83,0l-5.72,3.3c-.24.14-.27.36-.05.48Zm-35.31,20.39a.94.94,0,0,0,.83,0l5.72-3.31c.25-.14.27-.35.05-.48l-5.47-3.16a1,1,0,0,0-.84,0l-5.72,3.31c-.24.14-.26.35-.05.48Zm8.36-4.83a.94.94,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.17a.94.94,0,0,0-.83,0l-5.72,3.31c-.25.14-.27.35-.05.48Zm43.43-27.39a.94.94,0,0,0,.83,0l5.72-3.3c.24-.14.27-.36.05-.48l-1.46-.85a.94.94,0,0,0-.83,0L252.49,307c-.25.14-.27.35-.05.48ZM279,293.83a.94.94,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36,0-.48l-1.45-.84a.92.92,0,0,0-.84,0l-5.72,3.31c-.24.14-.26.35-.05.48Zm11.5,6.64a.9.9,0,0,0,.83,0l5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.16a.9.9,0,0,0-.83,0l-5.72,3.3c-.25.14-.27.36-.05.48Zm15.93,18.35,5.73-3.3c.24-.14.26-.36.05-.48l-5.48-3.17a.94.94,0,0,0-.83,0l-5.72,3.31c-.25.14-.27.35-.05.48l5.47,3.16A.94.94,0,0,0,306.42,318.82Zm-44.16-15.33a.94.94,0,0,0,.83,0l5.72-3.3c.25-.14.27-.36.05-.48l-1.45-.84a.92.92,0,0,0-.84,0l-5.72,3.31c-.24.14-.26.35-.05.48Zm-68.52,41.88a.94.94,0,0,0,.83,0L200.3,342c.24-.14.26-.35,0-.48l-5.48-3.16a.94.94,0,0,0-.83,0l-5.72,3.31c-.25.14-.27.35,0,.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.01 390.41 218.18 391.09 249.35 409.08 304.78 377.08 305.93 376.42 273.59 357.75 217.01 390.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.18 391.09 249.35 409.08 304.78 377.08 273.59 359.09 218.18 391.09",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hotel--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "285.5 115.95 285.5 118.23 270.69 109.68 270.69 107.4 285.5 115.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.5 128.44 285.5 130.72 270.69 122.17 270.69 119.89 285.5 128.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--percentage-box--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.82,111.58l-13.87-8a.68.68,0,0,0-.69-.07l-2.74,1.58a.69.69,0,0,0-.28.63V190.4a2.15,2.15,0,0,0,1,1.69l13.87,8a.71.71,0,0,0,.69.07l2.74-1.59a.68.68,0,0,0,.29-.63V113.27A2.16,2.16,0,0,0,298.82,111.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.82,111.58l-13.87-8a.68.68,0,0,0-.69-.07l-2.74,1.58a.69.69,0,0,0-.28.63V190.4a2.15,2.15,0,0,0,1,1.69l13.87,8a.71.71,0,0,0,.69.07l2.74-1.59a.68.68,0,0,0,.29-.63V113.27A2.16,2.16,0,0,0,298.82,111.58Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.8,113.27V198a.68.68,0,0,1-.29.63l-2.72,1.57a.68.68,0,0,0,.27-.62V114.86a1.94,1.94,0,0,0-.29-1l2.74-1.59A2,2,0,0,1,299.8,113.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.21,192.09l13.87,8c.54.31,1,.06,1-.57V114.86a2.16,2.16,0,0,0-1-1.69l-13.87-8c-.54-.31-1-.06-1,.56V190.4A2.15,2.15,0,0,0,282.21,192.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.21,192.09l13.87,8c.54.31,1,.06,1-.57V114.86a2.16,2.16,0,0,0-1-1.69l-13.87-8c-.54-.31-1-.06-1,.56V190.4A2.15,2.15,0,0,0,282.21,192.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.36,127.5v-5L287,120.63v5L285,124.39V112.07l2.06,1.19v4.6l3.33,1.92v-4.6l2.06,1.19v12.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.41,134.08c0-3.75,1.84-5.31,4.28-3.9S293,135.27,293,139s-1.83,5.32-4.28,3.91S284.41,137.83,284.41,134.08Zm6.46,3.73c0-2-.86-4.06-2.18-4.82s-2.18.29-2.18,2.3.85,4.06,2.18,4.83S290.87,139.8,290.87,137.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.67,158.28v-9.55l-2.24-1.3v-2.77l6.53,3.78v2.77l-2.23-1.29v9.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.88,173.41V161.09l5.87,3.39v2.77l-3.81-2.2V167l3.72,2.15v2.77l-3.72-2.14v2.08l3.81,2.2v2.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.24,189.79V177.46l2.06,1.19v9.56l3.22,1.85v2.78Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stairs--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.16 343.64 148.17 350.66 135.98 343.63 135.98 329.55 142.05 333.06 142.05 340.12 148.16 343.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.97 292.03 135.98 329.56 142.05 333.06 207.05 295.54 200.97 292.03",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.05 302.6 142.05 340.12 148.16 343.64 213.16 306.07 207.05 302.6",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.05 295.54 142.05 333.06 142.05 340.12 207.05 302.6 207.05 295.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.16 306.07 148.16 343.64 148.17 350.66 213.16 313.14 213.16 306.07",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "245.04 155.62 245.04 228.36 208.48 249.47 208.48 176.72 245.04 155.62",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.04 155.62 245.04 228.36 208.48 249.47 208.48 176.72 245.04 155.62",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.66 225.45 208.48 244.03 208.48 176.72 240.66 158.15 240.66 225.45",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.66 225.45 208.48 244.03 208.48 176.72 240.66 158.15 240.66 225.45",
    style: {
      fill: "#fff",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "245.04 155.62 240.66 158.15 240.66 225.45 245.04 228.36 245.04 155.62"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "204.42 251.81 249.1 226.01 251.11 227.17 206.43 252.97 204.42 251.81",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.42 251.81 249.1 226.01 251.11 227.17 206.43 252.97 204.42 251.81",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.43 252.97 206.43 257.66 251.11 231.87 251.11 227.17 206.43 252.97",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.43 252.97 206.43 257.66 251.11 231.87 251.11 227.17 206.43 252.97",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.42 251.81 204.42 256.5 206.43 257.66 206.43 252.97 204.42 251.81",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.42 251.81 204.42 256.5 206.43 257.66 206.43 252.97 204.42 251.81",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.73 234.65 224.73 167.34 227.09 165.98 227.09 233.28 224.73 234.65",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.73 234.65 224.73 167.34 227.09 165.98 227.09 233.28 224.73 234.65",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "210.49 250.63 210.49 274.14 247.13 253.01 246.99 229.55 210.49 250.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "261.17 237.74 259.18 250.66 226.68 269.42 226.68 257.66 261.17 237.74",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.17 237.74 259.18 250.66 226.68 269.42 226.68 257.66 261.17 237.74",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.49 249.47 214.49 262.39 226.68 269.42 226.68 257.66 212.49 249.47",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.49 249.47 214.49 262.39 226.68 269.42 226.68 257.66 212.49 249.47",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-5",
    points: "260.59 241.51 260.08 244.78 226.68 264.07 213.58 256.51 213.07 253.24 216.04 251.52 226.68 257.66 257.62 239.79 260.59 241.51",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.49 250.63 246.99 229.55 263.17 238.9 263.17 241.21 226.68 262.28 210.49 252.93 210.49 250.63",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.49 250.63 246.99 229.55 263.17 238.9 263.17 241.21 226.68 262.28 210.49 252.93 210.49 250.63",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.17 238.9 246.99 229.55 210.49 250.63 226.68 259.97 263.17 238.9",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.17 238.9 246.99 229.55 210.49 250.63 226.68 259.97 263.17 238.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.99 231.86 259.17 238.9 226.68 257.66 214.49 250.63 246.99 231.86",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.68 259.97 226.68 262.28 210.49 252.93 210.49 250.63 226.68 259.97",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.68 259.97 226.68 262.28 210.49 252.93 210.49 250.63 226.68 259.97",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.99 231.86 246.99 245.93 259.17 238.9 246.99 231.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.11 240.09 247 234.25 216.55 251.82 226.68 257.66 257.11 240.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flowers--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243,237.55c.39-1.89-.75-2.71-3.35-3.07a3.44,3.44,0,0,0,.34,2.29A2.36,2.36,0,0,0,243,237.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,237.55c.39-1.89-.75-2.71-3.35-3.07a3.44,3.44,0,0,0,.34,2.29A2.36,2.36,0,0,0,243,237.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.09,234.87c.7.47,2.44,1.58,2.89,2.68l.08-.43S242.77,236.14,240.09,234.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,237.8c-1.54-1.16-2.77-.48-4.21,1.71a3.47,3.47,0,0,0,2.22.68A2.36,2.36,0,0,0,242.53,237.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,237.8c-1.54-1.16-2.77-.48-4.21,1.71a3.47,3.47,0,0,0,2.22.68A2.36,2.36,0,0,0,242.53,237.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.87,239.26c.73-.42,2.47-1.52,3.66-1.46l-.35-.25S241.17,237.39,238.87,239.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.46,235.61c-.39-1.89.75-2.71,3.35-3.07a3.44,3.44,0,0,1-.34,2.29A2.36,2.36,0,0,1,256.46,235.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.46,235.61c-.39-1.89.75-2.71,3.35-3.07a3.44,3.44,0,0,1-.34,2.29A2.36,2.36,0,0,1,256.46,235.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,232.93c-.7.48-2.44,1.58-2.89,2.68l-.08-.42S256.67,234.2,259.35,232.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,235.86c1.53-1.16,2.76-.48,4.2,1.71a3.44,3.44,0,0,1-2.21.68A2.35,2.35,0,0,1,256.91,235.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.91,235.86c1.53-1.16,2.76-.48,4.2,1.71a3.44,3.44,0,0,1-2.21.68A2.35,2.35,0,0,1,256.91,235.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.57,237.32c-.73-.42-2.48-1.52-3.66-1.46l.35-.25S258.27,235.45,260.57,237.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.46,231.56a1.84,1.84,0,0,0-1,.77c-.09.14-.52,1.13-.37,1.24-.58-.45-1.69-1-2.37-.54-.49.35-.85,1.7-.17,2.06-.35-.19-.79-.37-1.12-.14a.77.77,0,0,0,0,1.1,2.1,2.1,0,0,0,1.11.53c-.31-.16-.68.18-.7.53a1.85,1.85,0,0,0,.35,1,1.23,1.23,0,0,1,.2,1,4,4,0,0,0-1.42-.36,1.4,1.4,0,0,0-1.26.61.87.87,0,0,0,.36,1.23.84.84,0,1,0,.67,1.41,1.35,1.35,0,0,0-.53,1.8,1.36,1.36,0,0,0,1.82.46,1.17,1.17,0,0,0,2.18.82c.15.48-.34.91-.79,1.11s-1,.39-1.18.86a1,1,0,0,0,.67,1.22,2,2,0,0,0,1.49-.19,1,1,0,0,0,1.65,1.07c-.15.22-.43.48-.42.78a1,1,0,0,0,.67.79,2.64,2.64,0,0,0,1.31,0,2.24,2.24,0,0,0-.31,1.55,1.18,1.18,0,0,0,1.16.93.72.72,0,0,0,.4,1.06,1,1,0,0,0,1.13-.49,2,2,0,0,0,.2-1.29c.3.2.72-.11.8-.46a3.51,3.51,0,0,0,0-1.07c0-.24,0-.67.27-.8s.75.19,1.09.17c.61,0,1.22-.65,1-1.23a1,1,0,0,0,1.61.54,1.72,1.72,0,0,0,.51-1.84,5.06,5.06,0,0,0-1.05-1.73,1.66,1.66,0,1,0,1-3.15,3,3,0,0,0,1.26.18,1.07,1.07,0,0,0,.94-.76c.08-.43-.34-.9-.75-.77a2.77,2.77,0,0,0,.79-1.77,1.31,1.31,0,0,0-1.19-1.33,1.49,1.49,0,0,0-.9-2.81,4,4,0,0,0-.36-2.37,2.61,2.61,0,0,0-1.88-1.4,1.91,1.91,0,0,0-2,1.07,1.74,1.74,0,0,0-1.11-1.43c-.61-.17-1.38.35-1.28,1A2.07,2.07,0,0,0,247.46,231.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.46,231.56a1.84,1.84,0,0,0-1,.77c-.09.14-.52,1.13-.37,1.24-.58-.45-1.69-1-2.37-.54-.49.35-.85,1.7-.17,2.06-.35-.19-.79-.37-1.12-.14a.77.77,0,0,0,0,1.1,2.1,2.1,0,0,0,1.11.53c-.31-.16-.68.18-.7.53a1.85,1.85,0,0,0,.35,1,1.23,1.23,0,0,1,.2,1,4,4,0,0,0-1.42-.36,1.4,1.4,0,0,0-1.26.61.87.87,0,0,0,.36,1.23.84.84,0,1,0,.67,1.41,1.35,1.35,0,0,0-.53,1.8,1.36,1.36,0,0,0,1.82.46,1.17,1.17,0,0,0,2.18.82c.15.48-.34.91-.79,1.11s-1,.39-1.18.86a1,1,0,0,0,.67,1.22,2,2,0,0,0,1.49-.19,1,1,0,0,0,1.65,1.07c-.15.22-.43.48-.42.78a1,1,0,0,0,.67.79,2.64,2.64,0,0,0,1.31,0,2.24,2.24,0,0,0-.31,1.55,1.18,1.18,0,0,0,1.16.93.72.72,0,0,0,.4,1.06,1,1,0,0,0,1.13-.49,2,2,0,0,0,.2-1.29c.3.2.72-.11.8-.46a3.51,3.51,0,0,0,0-1.07c0-.24,0-.67.27-.8s.75.19,1.09.17c.61,0,1.22-.65,1-1.23a1,1,0,0,0,1.61.54,1.72,1.72,0,0,0,.51-1.84,5.06,5.06,0,0,0-1.05-1.73,1.66,1.66,0,1,0,1-3.15,3,3,0,0,0,1.26.18,1.07,1.07,0,0,0,.94-.76c.08-.43-.34-.9-.75-.77a2.77,2.77,0,0,0,.79-1.77,1.31,1.31,0,0,0-1.19-1.33,1.49,1.49,0,0,0-.9-2.81,4,4,0,0,0-.36-2.37,2.61,2.61,0,0,0-1.88-1.4,1.91,1.91,0,0,0-2,1.07,1.74,1.74,0,0,0-1.11-1.43c-.61-.17-1.38.35-1.28,1A2.07,2.07,0,0,0,247.46,231.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.64,233.55c-.35-.15-2.16,0-2,.74a1.57,1.57,0,0,0-2.46-.81,1.69,1.69,0,0,0-2-1.21,1.65,1.65,0,0,0-1,2.1,1.77,1.77,0,0,0-1.68,3.06,1.6,1.6,0,0,0-.08,3.2,1.83,1.83,0,0,0,1,3.46,1.56,1.56,0,0,0-.31,2.08A1.2,1.2,0,0,0,246,246a1.37,1.37,0,0,0,2.48,1.09,1.53,1.53,0,1,0,2.64.34,3.35,3.35,0,0,0,1.38,1.26,1.81,1.81,0,0,0,1.8-.16,1.25,1.25,0,0,0,.27-1.68,1.28,1.28,0,1,0,1.22-2.14,1.93,1.93,0,0,0,.65-3.43,1.43,1.43,0,0,0-.9-2.72,1.94,1.94,0,0,0,.23-2.57,1.69,1.69,0,0,0-2.5-.08A1.62,1.62,0,0,0,252.64,233.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.64,233.55c-.35-.15-2.16,0-2,.74a1.57,1.57,0,0,0-2.46-.81,1.69,1.69,0,0,0-2-1.21,1.65,1.65,0,0,0-1,2.1,1.77,1.77,0,0,0-1.68,3.06,1.6,1.6,0,0,0-.08,3.2,1.83,1.83,0,0,0,1,3.46,1.56,1.56,0,0,0-.31,2.08A1.2,1.2,0,0,0,246,246a1.37,1.37,0,0,0,2.48,1.09,1.53,1.53,0,1,0,2.64.34,3.35,3.35,0,0,0,1.38,1.26,1.81,1.81,0,0,0,1.8-.16,1.25,1.25,0,0,0,.27-1.68,1.28,1.28,0,1,0,1.22-2.14,1.93,1.93,0,0,0,.65-3.43,1.43,1.43,0,0,0-.9-2.72,1.94,1.94,0,0,0,.23-2.57,1.69,1.69,0,0,0-2.5-.08A1.62,1.62,0,0,0,252.64,233.55Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,239.92a3.7,3.7,0,0,0,.66.07,3.16,3.16,0,0,0-.93.7,1.1,1.1,0,0,0-.23,1.09,1.12,1.12,0,0,0,.9.6,3.24,3.24,0,0,0,1.11-.12,1,1,0,0,0,1.32,1.56,1.68,1.68,0,0,0-.13,1.53c.33.5,1.07.48,1.67.4a1.24,1.24,0,0,0,0,1.39c.34.46.81.44,1.33.49a.78.78,0,0,0-.68.93.79.79,0,0,0,1,.51,6,6,0,0,1-.7.62.88.88,0,0,0-.32.84.74.74,0,0,0,1,.36,1.41,1.41,0,0,0,.67-.93.92.92,0,0,0,1-.54c.24-.62-.25-1-.77-1.24a1.34,1.34,0,1,0-.64-2.6c-.06-.21-.13-.43-.2-.64a4.1,4.1,0,0,0,1.6,0,1.36,1.36,0,0,0,1-1.08c.06-.54-.5-1.09-1-.91a1.09,1.09,0,0,0,1.23-.75.92.92,0,0,0,1.3-.56,1.25,1.25,0,0,0-.65-1.37,2,2,0,0,0-1.59-.05c0-.38-.48-.57-.85-.49s-.67.33-1,.41-.85-.1-.85-.47a3.3,3.3,0,0,0,1.13-1.16,1.24,1.24,0,0,0-.25-1.48c-.43-.33-1.22-.06-1.23.48a1,1,0,0,0-1.68-.78,3.12,3.12,0,0,0,.18-1.38,1.14,1.14,0,0,0-.89-1c-.81-.09-.78.74-.74,1.27a1.07,1.07,0,0,0-.83-.38.7.7,0,0,0-.65.57.53.53,0,0,0,.57.57c-.37.25-1,.09-1.23.47a.65.65,0,0,0,.18.8,2,2,0,0,0,.83.33,2.66,2.66,0,0,0-1,.3.9.9,0,0,0-.46.91.88.88,0,0,0,.58.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,239.92a3.7,3.7,0,0,0,.66.07,3.16,3.16,0,0,0-.93.7,1.1,1.1,0,0,0-.23,1.09,1.12,1.12,0,0,0,.9.6,3.24,3.24,0,0,0,1.11-.12,1,1,0,0,0,1.32,1.56,1.68,1.68,0,0,0-.13,1.53c.33.5,1.07.48,1.67.4a1.24,1.24,0,0,0,0,1.39c.34.46.81.44,1.33.49a.78.78,0,0,0-.68.93.79.79,0,0,0,1,.51,6,6,0,0,1-.7.62.88.88,0,0,0-.32.84.74.74,0,0,0,1,.36,1.41,1.41,0,0,0,.67-.93.92.92,0,0,0,1-.54c.24-.62-.25-1-.77-1.24a1.34,1.34,0,1,0-.64-2.6c-.06-.21-.13-.43-.2-.64a4.1,4.1,0,0,0,1.6,0,1.36,1.36,0,0,0,1-1.08c.06-.54-.5-1.09-1-.91a1.09,1.09,0,0,0,1.23-.75.92.92,0,0,0,1.3-.56,1.25,1.25,0,0,0-.65-1.37,2,2,0,0,0-1.59-.05c0-.38-.48-.57-.85-.49s-.67.33-1,.41-.85-.1-.85-.47a3.3,3.3,0,0,0,1.13-1.16,1.24,1.24,0,0,0-.25-1.48c-.43-.33-1.22-.06-1.23.48a1,1,0,0,0-1.68-.78,3.12,3.12,0,0,0,.18-1.38,1.14,1.14,0,0,0-.89-1c-.81-.09-.78.74-.74,1.27a1.07,1.07,0,0,0-.83-.38.7.7,0,0,0-.65.57.53.53,0,0,0,.57.57c-.37.25-1,.09-1.23.47a.65.65,0,0,0,.18.8,2,2,0,0,0,.83.33,2.66,2.66,0,0,0-1,.3.9.9,0,0,0-.46.91.88.88,0,0,0,.58.62Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowers--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.66,236.89s-.06-.95-.81-1c0,0-.61-.1-.94.84a2,2,0,0,0-1.76.21,1.08,1.08,0,0,0,.81,1.21,1.38,1.38,0,0,0-.31,1.49s1.53.51,1.9-.44c0,0,.13.85,1.62.85a1.42,1.42,0,0,0,0-1.69s1.05,0,1.22-.81C250.39,237.5,249.68,236.31,248.66,236.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.73,237a.86.86,0,0,0-.9.69s0,.56.76.64.87-.48.87-.48A.87.87,0,0,0,247.73,237Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.21,235.62s-.33-.68-.88-.75a1.52,1.52,0,0,0-.54,1,1.34,1.34,0,0,0-1.19.29,1.29,1.29,0,0,0,.76.88,1.64,1.64,0,0,0,0,1.24,1.47,1.47,0,0,0,1.42-.8,1.36,1.36,0,0,0,1.46.38,1.09,1.09,0,0,0-.39-1.27,1.17,1.17,0,0,0,.59-1A1.66,1.66,0,0,0,254.21,235.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.6,236a.65.65,0,0,0-.59.61s.07.4.64.38.59-.45.59-.45A.66.66,0,0,0,253.6,236Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.76,246.21s-.23-.47-.62-.52a1.07,1.07,0,0,0-.38.68,1,1,0,0,0-.84.2.92.92,0,0,0,.54.62,1.19,1.19,0,0,0,0,.87,1,1,0,0,0,1-.56,1,1,0,0,0,1,.27.78.78,0,0,0-.27-.9.82.82,0,0,0,.41-.71A1.17,1.17,0,0,0,252.76,246.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.33,246.49a.45.45,0,0,0-.41.43s0,.29.44.27.42-.31.42-.31S252.7,246.48,252.33,246.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.71,244.06s-.33-.68-.88-.75a1.52,1.52,0,0,0-.54,1,1.34,1.34,0,0,0-1.19.29,1.29,1.29,0,0,0,.76.88,1.64,1.64,0,0,0,0,1.24,1.47,1.47,0,0,0,1.42-.8,1.36,1.36,0,0,0,1.46.38,1.09,1.09,0,0,0-.39-1.27,1.17,1.17,0,0,0,.59-1A1.66,1.66,0,0,0,247.71,244.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,244.46a.68.68,0,0,0-.65.62s.07.4.68.37.65-.46.65-.46A.66.66,0,0,0,247.11,244.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61,234.14s-.21-.6-.6-.4-.26.59.08.68c0,0-.74.24-.53.63s.84,0,1-.22c0,0,.14.6.66.39s0-.74,0-.74.79-.31.36-.67S249.61,234.14,249.61,234.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.66,243s-.21-.6-.61-.39-.25.58.09.67c0,0-.74.24-.53.64s.84,0,1-.23c0,0,.14.61.65.39s0-.73,0-.73.79-.31.36-.67S253.66,243,253.66,243Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.42,239.86s.07-.63-.38-.61-.48.43-.2.65c0,0-.77-.09-.75.36s.78.33,1,.2c0,0-.13.61.43.63s.31-.67.31-.67.84,0,.6-.46S254.42,239.86,254.42,239.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.13,241.49s.06-.63-.39-.61-.47.43-.19.65c0,0-.78-.09-.75.36s.77.33,1,.2c0,0-.12.61.44.63s.3-.67.3-.67.85,0,.61-.46S249.13,241.49,249.13,241.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.14,240.49s-.51-.67-.13-.84.56.42.56.42.39-.46.57-.13-.29.67-.29.67.54.29.23.58-.68-.17-.68-.17-.21.52-.53.37S242.75,240.66,243.14,240.49Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowers--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226,252.9s-.28-.52-1.22-.34a2.24,2.24,0,0,0-1.37.8,2,2,0,0,0,1.89.73C226.42,253.79,226,252.9,226,252.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,252.9s-.28-.52-1.22-.34a2.24,2.24,0,0,0-1.37.8,2,2,0,0,0,1.89.73C226.42,253.79,226,252.9,226,252.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.33,254.09c.67-.18.78-.59.76-.88a3.63,3.63,0,0,0-2.65.15A2,2,0,0,0,225.33,254.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.88,252.75s.41-.42,0-1.26a2.24,2.24,0,0,0-1.18-1.06,2,2,0,0,0-.12,2A.85.85,0,0,0,226.88,252.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.88,252.75s.41-.42,0-1.26a2.24,2.24,0,0,0-1.18-1.06,2,2,0,0,0-.12,2A.85.85,0,0,0,226.88,252.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,252.45c.38.58.8.56,1.07.46a3.62,3.62,0,0,0-.95-2.48A2,2,0,0,0,225.53,252.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.43,252.67s.42-1.07.88-.73-.1.93-.1.93.81.13.56.57-1,.14-1,.14,0,.82-.5.66-.28-.89-.28-.89-.74.11-.8-.36S226,252.33,226.43,252.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.29,247.39s-.11-1.22-2-1.63a4.71,4.71,0,0,0-3.27.42s.71,2.6,3,2.92S228.29,247.39,228.29,247.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.29,247.39s-.11-1.22-2-1.63a4.71,4.71,0,0,0-3.27.42s.71,2.6,3,2.92S228.29,247.39,228.29,247.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,249.1c1.42.2,1.95-.49,2.16-1-1.66-2-5.19-1.87-5.19-1.87S223.68,248.78,226,249.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.53,246.37s-.75-1,.38-2.59a4.72,4.72,0,0,1,2.67-1.94s1.27,2.39-.2,4.21A1.77,1.77,0,0,1,230.53,246.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.53,246.37s-.75-1,.38-2.59a4.72,4.72,0,0,1,2.67-1.94s1.27,2.39-.2,4.21A1.77,1.77,0,0,1,230.53,246.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.38,246.05a1.76,1.76,0,0,1-2.3.71c-.13-2.56,2.5-4.92,2.5-4.92S234.85,244.23,233.38,246.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.12,248.9a2.15,2.15,0,0,0-.4,2.61,5.44,5.44,0,0,0,3,1.8s1-2-.18-3.53A2.43,2.43,0,0,0,229.12,248.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.12,248.9a2.15,2.15,0,0,0-.4,2.61,5.44,5.44,0,0,0,3,1.8s1-2-.18-3.53A2.43,2.43,0,0,0,229.12,248.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72,251.51a5.44,5.44,0,0,0,3,1.8c-.18-2.18-2.64-4.41-2.64-4.41A2.15,2.15,0,0,0,228.72,251.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.1,246.57s-.1-1.28-1.11-1.41c0,0-.83-.13-1.27,1.16a2.63,2.63,0,0,0-2.38.29,1.48,1.48,0,0,0,1.11,1.64,1.86,1.86,0,0,0-.39,2s2.06.67,2.55-.61c0,0,.2,1.14,2.21,1.12a1.9,1.9,0,0,0,0-2.28s1.42-.06,1.64-1.12C233.44,247.37,232.47,245.78,231.1,246.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,246.78a1.4,1.4,0,0,0-1.51,1s0,.75,1.29.84,1.47-.65,1.47-.65A1.26,1.26,0,0,0,229.86,246.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.58,252s-.49-.95-2.19-.64a4.06,4.06,0,0,0-2.49,1.42,3.58,3.58,0,0,0,3.4,1.36A1.54,1.54,0,0,0,217.58,252Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.58,252s-.49-.95-2.19-.64a4.06,4.06,0,0,0-2.49,1.42,3.58,3.58,0,0,0,3.4,1.36A1.54,1.54,0,0,0,217.58,252Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3,254.12c1.21-.31,1.42-1.05,1.4-1.57-2-1-4.8.21-4.8.21A3.58,3.58,0,0,0,216.3,254.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,252.89a1.74,1.74,0,0,0-.32,2.12,4.33,4.33,0,0,0,2.46,1.46,2.93,2.93,0,0,0-.14-2.87A2,2,0,0,0,219,252.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,252.89a1.74,1.74,0,0,0-.32,2.12,4.33,4.33,0,0,0,2.46,1.46,2.93,2.93,0,0,0-.14-2.87A2,2,0,0,0,219,252.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,255a4.33,4.33,0,0,0,2.46,1.46c-.14-1.77-2.14-3.58-2.14-3.58A1.74,1.74,0,0,0,218.66,255Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66,250.54s-.46-.91-1.2-1a2.06,2.06,0,0,0-.72,1.32,1.85,1.85,0,0,0-1.61.41,1.72,1.72,0,0,0,1,1.17,2.3,2.3,0,0,0,.06,1.69,2,2,0,0,0,1.92-1.09,1.86,1.86,0,0,0,2,.49,1.49,1.49,0,0,0-.54-1.72,1.57,1.57,0,0,0,.78-1.39A2.25,2.25,0,0,0,219.66,250.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.86,251.08a1.06,1.06,0,0,0-1,.87s.09.54,1,.47,1-.64,1-.64A.93.93,0,0,0,218.86,251.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,257.5s-.35-.91.91-1.89a3.76,3.76,0,0,1,2.5-.85,3.28,3.28,0,0,1-1.15,3.17A1.42,1.42,0,0,1,223,257.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,257.5s-.35-.91.91-1.89a3.76,3.76,0,0,1,2.5-.85,3.28,3.28,0,0,1-1.15,3.17A1.42,1.42,0,0,1,223,257.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,257.93c-1,.64-1.59.34-1.93,0,.51-2,3.08-3.17,3.08-3.17A3.28,3.28,0,0,1,225.23,257.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,245.41s.38-.4,0-1.18a2.07,2.07,0,0,0-1.1-1,1.83,1.83,0,0,0-.11,1.88A.79.79,0,0,0,236.35,245.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,245.41s.38-.4,0-1.18a2.07,2.07,0,0,0-1.1-1,1.83,1.83,0,0,0-.11,1.88A.79.79,0,0,0,236.35,245.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.1,245.13c.35.54.74.52,1,.43a3.35,3.35,0,0,0-.88-2.31A1.83,1.83,0,0,0,235.1,245.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.5,245.35s-.18-.82,1-1.48a3.23,3.23,0,0,1,2.22-.39,2.81,2.81,0,0,1-1.37,2.52A1.21,1.21,0,0,1,237.5,245.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.5,245.35s-.18-.82,1-1.48a3.23,3.23,0,0,1,2.22-.39,2.81,2.81,0,0,1-1.37,2.52A1.21,1.21,0,0,1,237.5,245.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.35,246a1.2,1.2,0,0,1-1.63-.24c.69-1.61,3-2.28,3-2.28A2.81,2.81,0,0,1,239.35,246Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.48,247.29a1.68,1.68,0,0,0-1,1.82,4.29,4.29,0,0,0,1.76,2.13,2.82,2.82,0,0,0,.82-2.65A1.91,1.91,0,0,0,236.48,247.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.48,247.29a1.68,1.68,0,0,0-1,1.82,4.29,4.29,0,0,0,1.76,2.13,2.82,2.82,0,0,0,.82-2.65A1.91,1.91,0,0,0,236.48,247.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.49,249.11a4.29,4.29,0,0,0,1.76,2.13c.45-1.65-.77-4-.77-4A1.68,1.68,0,0,0,235.49,249.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.17,245.37s.42-.85,1.1-1a1.87,1.87,0,0,1,.69,1.22,1.73,1.73,0,0,1,1.51.35,1.59,1.59,0,0,1-.95,1.11,2.15,2.15,0,0,1,0,1.58,1.87,1.87,0,0,1-1.8-1,1.75,1.75,0,0,1-1.84.5,1.38,1.38,0,0,1,.48-1.61,1.47,1.47,0,0,1-.75-1.28A2.1,2.1,0,0,1,236.17,245.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.93,245.86a1,1,0,0,1,.95.79s-.08.51-1,.46-.95-.58-.95-.58A.87.87,0,0,1,236.93,245.86Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91,240.87s.06-.59-.83-1a2.22,2.22,0,0,0-1.58-.09,2,2,0,0,0,1.17,1.65A.85.85,0,0,0,236.91,240.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91,240.87s.06-.59-.83-1a2.22,2.22,0,0,0-1.58-.09,2,2,0,0,0,1.17,1.65A.85.85,0,0,0,236.91,240.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.67,241.47a.85.85,0,0,0,1.12-.3,3.66,3.66,0,0,0-2.29-1.35A2,2,0,0,0,235.67,241.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.35,240.57s-.27-.82-.81-.54-.35.79.11.91c0,0-1,.32-.73.85s1.14,0,1.33-.29c0,0,.18.82.88.53s0-1,0-1,1.07-.41.5-.9S237.35,240.57,237.35,240.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.56,250.15s-.32-1.1-.81-.81,0,.94,0,.94-.81.05-.61.51,1,.23,1,.23-.12.81.44.71.36-.86.36-.86.73.18.84-.29S224.05,249.86,223.56,250.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.76,251s-.2-.57-.57-.37-.24.55.09.63c0,0-.7.23-.5.6s.79,0,.92-.22c0,0,.14.57.62.36s0-.69,0-.69.75-.29.34-.63S233.76,251,233.76,251Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.53,254.21s.06-.67-.41-.64-.49.45-.2.68c0,0-.81-.08-.78.39s.81.34,1,.2c0,0-.12.64.47.65s.31-.7.31-.7.89,0,.63-.49S229.53,254.21,229.53,254.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.38,247.24s.07-.86-.53-.82-.64.58-.26.88c0,0-1.05-.11-1,.49s1,.45,1.33.27c0,0-.16.82.6.84s.4-.91.4-.91,1.15,0,.81-.63S241.38,247.24,241.38,247.24Z",
    style: {
      fill: "#fafafa"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "192.94 200.37 192.94 296.64 144.12 324.83 144.1 228.57 192.94 200.37",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.94 200.37 192.94 296.64 144.12 324.83 144.1 228.57 192.94 200.37",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.94 200.37 189.08 202.6 189.08 294.05 192.94 296.64 192.94 200.37",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.08 294.05 192.94 296.64 144.12 324.83 144.12 320.01 189.08 294.05",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.08 294.05 192.94 296.64 144.12 324.83 144.12 320.01 189.08 294.05",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.08 294.05 144.12 320.01 144.1 228.57 189.08 202.6 189.08 294.05",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.08 294.05 144.12 320.01 144.1 228.57 189.08 202.61 189.08 294.05",
    style: {
      fill: "#fff",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.08 202.61 189.07 210.13 144.1 236.09 144.1 228.57 189.08 202.61",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.53 214.45 166.84 215.43 166.84 311.71 168.53 310.73 168.53 214.45",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.53 214.45 166.84 215.43 166.84 311.71 168.53 310.73 168.53 214.45",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.84 215.43 166.84 311.71 165.14 310.74 165.14 216.4 166.84 215.43",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.84 215.43 166.84 311.71 165.14 310.74 165.14 216.4 166.84 215.43",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.94 296.64 194.59 297.58 194.59 199.42 192.94 200.37 192.94 296.64",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.94 296.64 194.59 297.58 194.59 199.42 192.94 200.37 192.94 296.64",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.59 297.58 201.1 293.82 201.1 188.14 137.59 224.81 137.59 330.49 144.1 326.73 144.1 228.57 194.59 199.42 194.59 297.58",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.1 188.14 137.59 224.81 135.97 223.87 199.49 187.2 201.1 188.14",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.1 188.14 137.59 224.81 135.97 223.87 199.49 187.2 201.1 188.14",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.59 330.49 137.59 224.81 135.97 223.87 135.97 329.56 137.59 330.49",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "135.97 223.87 135.97 329.56 137.59 330.49 137.59 224.81",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "115.06 230.66 115.06 303.4 78.5 324.51 78.5 251.77 115.06 230.66",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.06 230.66 115.06 303.4 78.5 324.51 78.5 251.77 115.06 230.66",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.67 300.49 78.5 319.07 78.5 251.77 110.67 233.19 110.67 300.49",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.67 300.49 78.5 319.07 78.5 251.77 110.67 233.19 110.67 300.49",
    style: {
      fill: "#fff",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.06 230.66 110.67 233.19 110.67 300.49 115.06 303.4 115.06 230.66"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "74.43 326.86 119.12 301.06 121.13 302.22 76.44 328.01 74.43 326.86",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.43 326.86 119.12 301.06 121.13 302.22 76.44 328.01 74.43 326.86",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.44 328.01 76.44 332.71 121.13 306.91 121.13 302.22 76.44 328.01",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.44 328.01 76.44 332.71 121.13 306.91 121.13 302.22 76.44 328.01",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.43 326.86 74.43 331.55 76.44 332.71 76.44 328.01 74.43 326.86",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.43 326.86 74.43 331.55 76.44 332.71 76.44 328.01 74.43 326.86",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.75 309.69 94.75 242.39 97.1 241.03 97.1 308.33 94.75 309.69",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.75 309.69 94.75 242.39 97.1 241.03 97.1 308.33 94.75 309.69",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "80.5 325.67 80.5 349.18 117.14 328.06 117 304.6 80.5 325.67",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.19 312.79 129.19 325.71 96.69 344.47 96.69 332.71 131.19 312.79",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.19 312.79 129.19 325.71 96.69 344.47 96.69 332.71 131.19 312.79",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.51 324.51 84.51 337.43 96.69 344.47 96.69 332.71 82.51 324.51",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.51 324.51 84.51 337.43 96.69 344.47 96.69 332.71 82.51 324.51",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-5",
    points: "130.61 316.56 130.1 319.83 96.69 339.12 83.6 331.56 83.09 328.28 86.06 326.57 96.69 332.71 127.64 314.84 130.61 316.56",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.5 325.67 117 304.6 133.19 313.94 133.19 316.25 96.69 337.32 80.5 327.98 80.5 325.67",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.5 325.67 117 304.6 133.19 313.94 133.19 316.25 96.69 337.32 80.5 327.98 80.5 325.67",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.19 313.94 117 304.6 80.51 325.67 96.69 335.02 133.19 313.94",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.19 313.94 117 304.6 80.51 325.67 96.69 335.02 133.19 313.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117 306.91 129.19 313.94 96.69 332.71 84.51 325.67 117 306.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.69 335.02 96.69 337.32 80.5 327.98 80.51 325.67 96.69 335.02",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.69 335.02 96.69 337.32 80.5 327.98 80.51 325.67 96.69 335.02",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117 306.91 117 320.98 129.19 313.94 117 306.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.13 315.13 117.01 309.29 86.57 326.86 96.69 332.71 127.13 315.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowers--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.73,326.28c.39-1.89-.75-2.71-3.35-3.06a3.44,3.44,0,0,0,.34,2.29A2.36,2.36,0,0,0,88.73,326.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.73,326.28c.39-1.89-.75-2.71-3.35-3.06a3.44,3.44,0,0,0,.34,2.29A2.36,2.36,0,0,0,88.73,326.28Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.84,323.6c.69.48,2.44,1.58,2.89,2.68l.07-.42S88.52,324.88,85.84,323.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,326.54c-1.54-1.17-2.77-.49-4.21,1.7a3.38,3.38,0,0,0,2.21.68A2.36,2.36,0,0,0,88.28,326.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,326.54c-1.54-1.17-2.77-.49-4.21,1.7a3.38,3.38,0,0,0,2.21.68A2.36,2.36,0,0,0,88.28,326.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,328c.73-.42,2.47-1.52,3.66-1.45l-.35-.25S86.92,326.13,84.62,328Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.2,324.34c-.39-1.89.75-2.71,3.35-3.06a3.38,3.38,0,0,1-.34,2.29A2.36,2.36,0,0,1,102.2,324.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.2,324.34c-.39-1.89.75-2.71,3.35-3.06a3.38,3.38,0,0,1-.34,2.29A2.36,2.36,0,0,1,102.2,324.34Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.09,321.66c-.69.48-2.43,1.58-2.89,2.68l-.07-.42S102.42,322.94,105.09,321.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.66,324.6c1.53-1.17,2.76-.49,4.2,1.7a3.38,3.38,0,0,1-2.21.68A2.35,2.35,0,0,1,102.66,324.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.66,324.6c1.53-1.17,2.76-.49,4.2,1.7a3.38,3.38,0,0,1-2.21.68A2.35,2.35,0,0,1,102.66,324.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.31,326.05c-.72-.42-2.47-1.52-3.65-1.45l.34-.25S104,324.19,106.31,326.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.21,320.29a2,2,0,0,0-1,.77c-.08.14-.51,1.13-.37,1.25-.57-.46-1.69-1-2.37-.55-.49.35-.84,1.71-.16,2.06-.35-.18-.79-.36-1.12-.14a.77.77,0,0,0,0,1.1,2.27,2.27,0,0,0,1.11.54c-.3-.16-.68.18-.69.52a1.88,1.88,0,0,0,.35,1,1.17,1.17,0,0,1,.19,1,4.31,4.31,0,0,0-1.41-.36,1.41,1.41,0,0,0-1.26.61,1.68,1.68,0,0,1-.35,2.43.89.89,0,0,0,1.38.21,1.3,1.3,0,1,0,1.29,2.26,1.17,1.17,0,0,0,2.18.82c.15.48-.34.91-.8,1.12s-1,.39-1.17.86a1,1,0,0,0,.66,1.21,1.93,1.93,0,0,0,1.5-.18,1,1,0,0,0,1.65,1.06c-.16.23-.43.49-.43.78a1,1,0,0,0,.68.8,2.64,2.64,0,0,0,1.31,0,2.25,2.25,0,0,0-.31,1.55,1.16,1.16,0,0,0,1.15.93.73.73,0,0,0,.4,1.06,1,1,0,0,0,1.14-.49,2,2,0,0,0,.2-1.29c.3.2.71-.1.8-.45a3.57,3.57,0,0,0,0-1.08c0-.23,0-.66.26-.8s.75.19,1.1.18c.61,0,1.21-.66,1-1.23a1.05,1.05,0,0,0,1.62.53,1.7,1.7,0,0,0,.5-1.84,5,5,0,0,0-1.05-1.73,1.66,1.66,0,1,0,1-3.14,3.26,3.26,0,0,0,1.27.18,1.06,1.06,0,0,0,.93-.77c.08-.42-.34-.9-.74-.77a2.82,2.82,0,0,0,.79-1.77,1.31,1.31,0,0,0-1.19-1.33,1.48,1.48,0,0,0-.9-2.8,4,4,0,0,0-.36-2.38,2.61,2.61,0,0,0-1.89-1.4,1.94,1.94,0,0,0-2,1.07,1.71,1.71,0,0,0-1.1-1.42c-.62-.17-1.38.34-1.28,1A2.09,2.09,0,0,0,93.21,320.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.21,320.29a2,2,0,0,0-1,.77c-.08.14-.51,1.13-.37,1.25-.57-.46-1.69-1-2.37-.55-.49.35-.84,1.71-.16,2.06-.35-.18-.79-.36-1.12-.14a.77.77,0,0,0,0,1.1,2.27,2.27,0,0,0,1.11.54c-.3-.16-.68.18-.69.52a1.88,1.88,0,0,0,.35,1,1.17,1.17,0,0,1,.19,1,4.31,4.31,0,0,0-1.41-.36,1.41,1.41,0,0,0-1.26.61,1.68,1.68,0,0,1-.35,2.43.89.89,0,0,0,1.38.21,1.3,1.3,0,1,0,1.29,2.26,1.17,1.17,0,0,0,2.18.82c.15.48-.34.91-.8,1.12s-1,.39-1.17.86a1,1,0,0,0,.66,1.21,1.93,1.93,0,0,0,1.5-.18,1,1,0,0,0,1.65,1.06c-.16.23-.43.49-.43.78a1,1,0,0,0,.68.8,2.64,2.64,0,0,0,1.31,0,2.25,2.25,0,0,0-.31,1.55,1.16,1.16,0,0,0,1.15.93.73.73,0,0,0,.4,1.06,1,1,0,0,0,1.14-.49,2,2,0,0,0,.2-1.29c.3.2.71-.1.8-.45a3.57,3.57,0,0,0,0-1.08c0-.23,0-.66.26-.8s.75.19,1.1.18c.61,0,1.21-.66,1-1.23a1.05,1.05,0,0,0,1.62.53,1.7,1.7,0,0,0,.5-1.84,5,5,0,0,0-1.05-1.73,1.66,1.66,0,1,0,1-3.14,3.26,3.26,0,0,0,1.27.18,1.06,1.06,0,0,0,.93-.77c.08-.42-.34-.9-.74-.77a2.82,2.82,0,0,0,.79-1.77,1.31,1.31,0,0,0-1.19-1.33,1.48,1.48,0,0,0-.9-2.8,4,4,0,0,0-.36-2.38,2.61,2.61,0,0,0-1.89-1.4,1.94,1.94,0,0,0-2,1.07,1.71,1.71,0,0,0-1.1-1.42c-.62-.17-1.38.34-1.28,1A2.09,2.09,0,0,0,93.21,320.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.39,322.28c-.35-.15-2.16,0-2,.74a1.58,1.58,0,0,0-2.47-.8,1.69,1.69,0,0,0-2-1.21,1.65,1.65,0,0,0-1,2.1,1.77,1.77,0,0,0-1.68,3.05,1.6,1.6,0,0,0-.07,3.2,1.83,1.83,0,0,0,1,3.46,1.55,1.55,0,0,0-.31,2.08,1.2,1.2,0,0,0,1.94-.16,1.37,1.37,0,0,0,2.48,1.1,1.52,1.52,0,1,0,2.63.33,3.28,3.28,0,0,0,1.38,1.26,1.81,1.81,0,0,0,1.8-.15,1.26,1.26,0,0,0,.28-1.69,1.28,1.28,0,1,0,1.21-2.14,1.92,1.92,0,0,0,.66-3.42,1.5,1.5,0,0,0,.86-1.8,1.48,1.48,0,0,0-1.77-.92,2,2,0,0,0,.24-2.58,1.7,1.7,0,0,0-2.5-.08A1.62,1.62,0,0,0,98.39,322.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.39,322.28c-.35-.15-2.16,0-2,.74a1.58,1.58,0,0,0-2.47-.8,1.69,1.69,0,0,0-2-1.21,1.65,1.65,0,0,0-1,2.1,1.77,1.77,0,0,0-1.68,3.05,1.6,1.6,0,0,0-.07,3.2,1.83,1.83,0,0,0,1,3.46,1.55,1.55,0,0,0-.31,2.08,1.2,1.2,0,0,0,1.94-.16,1.37,1.37,0,0,0,2.48,1.1,1.52,1.52,0,1,0,2.63.33,3.28,3.28,0,0,0,1.38,1.26,1.81,1.81,0,0,0,1.8-.15,1.26,1.26,0,0,0,.28-1.69,1.28,1.28,0,1,0,1.21-2.14,1.92,1.92,0,0,0,.66-3.42,1.5,1.5,0,0,0,.86-1.8,1.48,1.48,0,0,0-1.77-.92,2,2,0,0,0,.24-2.58,1.7,1.7,0,0,0-2.5-.08A1.62,1.62,0,0,0,98.39,322.28Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.74,328.65a3.6,3.6,0,0,0,.66.07,3.25,3.25,0,0,0-.93.7,1.12,1.12,0,0,0-.23,1.1,1.09,1.09,0,0,0,.89.59,3.26,3.26,0,0,0,1.12-.11,1,1,0,0,0-.09,1.41,1.06,1.06,0,0,0,1.41.14,1.62,1.62,0,0,0-.13,1.53c.33.51,1.07.48,1.67.4a1.25,1.25,0,0,0,0,1.4c.34.46.81.43,1.33.48a.75.75,0,1,0,.35,1.44,8.29,8.29,0,0,1-.7.63.88.88,0,0,0-.32.84.72.72,0,0,0,1,.35,1.37,1.37,0,0,0,.68-.93.9.9,0,0,0,1-.53c.24-.62-.25-1.05-.77-1.24a1.39,1.39,0,0,0,1-1.62,1.41,1.41,0,0,0-1.62-1c-.07-.21-.14-.42-.2-.64a3.87,3.87,0,0,0,1.59,0,1.37,1.37,0,0,0,1.06-1.08c0-.53-.5-1.09-1-.9a1.09,1.09,0,0,0,1.23-.75.93.93,0,0,0,1.3-.56,1.27,1.27,0,0,0-.66-1.37,2,2,0,0,0-1.59-.06c0-.37-.47-.57-.84-.49s-.67.33-1,.42-.85-.11-.85-.48a3.09,3.09,0,0,0,1.12-1.15,1.23,1.23,0,0,0-.24-1.49c-.43-.33-1.22-.06-1.23.48a1,1,0,0,0-1.69-.78,3,3,0,0,0,.18-1.38,1.14,1.14,0,0,0-.89-1c-.8-.09-.77.74-.73,1.27a1.07,1.07,0,0,0-.83-.37.7.7,0,0,0-.65.57.51.51,0,0,0,.57.56c-.37.26-1,.1-1.23.47a.63.63,0,0,0,.18.8,1.85,1.85,0,0,0,.82.33,2.63,2.63,0,0,0-1,.31.91.91,0,0,0-.47.9.93.93,0,0,0,.59.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.74,328.65a3.6,3.6,0,0,0,.66.07,3.25,3.25,0,0,0-.93.7,1.12,1.12,0,0,0-.23,1.1,1.09,1.09,0,0,0,.89.59,3.26,3.26,0,0,0,1.12-.11,1,1,0,0,0-.09,1.41,1.06,1.06,0,0,0,1.41.14,1.62,1.62,0,0,0-.13,1.53c.33.51,1.07.48,1.67.4a1.25,1.25,0,0,0,0,1.4c.34.46.81.43,1.33.48a.75.75,0,1,0,.35,1.44,8.29,8.29,0,0,1-.7.63.88.88,0,0,0-.32.84.72.72,0,0,0,1,.35,1.37,1.37,0,0,0,.68-.93.9.9,0,0,0,1-.53c.24-.62-.25-1.05-.77-1.24a1.39,1.39,0,0,0,1-1.62,1.41,1.41,0,0,0-1.62-1c-.07-.21-.14-.42-.2-.64a3.87,3.87,0,0,0,1.59,0,1.37,1.37,0,0,0,1.06-1.08c0-.53-.5-1.09-1-.9a1.09,1.09,0,0,0,1.23-.75.93.93,0,0,0,1.3-.56,1.27,1.27,0,0,0-.66-1.37,2,2,0,0,0-1.59-.06c0-.37-.47-.57-.84-.49s-.67.33-1,.42-.85-.11-.85-.48a3.09,3.09,0,0,0,1.12-1.15,1.23,1.23,0,0,0-.24-1.49c-.43-.33-1.22-.06-1.23.48a1,1,0,0,0-1.69-.78,3,3,0,0,0,.18-1.38,1.14,1.14,0,0,0-.89-1c-.8-.09-.77.74-.73,1.27a1.07,1.07,0,0,0-.83-.37.7.7,0,0,0-.65.57.51.51,0,0,0,.57.56c-.37.26-1,.1-1.23.47a.63.63,0,0,0,.18.8,1.85,1.85,0,0,0,.82.33,2.63,2.63,0,0,0-1,.31.91.91,0,0,0-.47.9.93.93,0,0,0,.59.63Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowers--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.41,325.62s-.07-.95-.81-1.05c0,0-.61-.1-.95.85a2,2,0,0,0-1.76.2,1.1,1.1,0,0,0,.82,1.22,1.38,1.38,0,0,0-.31,1.49s1.52.5,1.9-.44c0,0,.13.84,1.62.84a1.42,1.42,0,0,0,0-1.69s1,0,1.22-.81C96.14,326.23,95.43,325.05,94.41,325.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,325.77a.87.87,0,0,0-.9.7s0,.55.76.63.87-.47.87-.47S94.18,325.85,93.48,325.77Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,324.35s-.33-.67-.88-.75a1.52,1.52,0,0,0-.54,1,1.4,1.4,0,0,0-1.2.29,1.29,1.29,0,0,0,.76.88,1.72,1.72,0,0,0,0,1.25,1.48,1.48,0,0,0,1.43-.8,1.38,1.38,0,0,0,1.46.38,1.11,1.11,0,0,0-.39-1.28,1.15,1.15,0,0,0,.58-1A1.69,1.69,0,0,0,100,324.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.35,324.75a.64.64,0,0,0-.59.61s.06.41.63.38.6-.44.6-.44A.66.66,0,0,0,99.35,324.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.51,335s-.24-.47-.62-.53a1.06,1.06,0,0,0-.38.68,1,1,0,0,0-.84.21.87.87,0,0,0,.53.61,1.24,1.24,0,0,0,0,.88,1,1,0,0,0,1-.56s.27.41,1,.26a.76.76,0,0,0-.28-.89.81.81,0,0,0,.41-.72A1.17,1.17,0,0,0,98.51,335Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.08,335.23a.44.44,0,0,0-.41.43s0,.28.44.26.41-.31.41-.31S98.45,335.21,98.08,335.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.46,332.79s-.33-.67-.88-.75a1.52,1.52,0,0,0-.54,1,1.4,1.4,0,0,0-1.2.29,1.29,1.29,0,0,0,.76.88,1.72,1.72,0,0,0,0,1.25,1.48,1.48,0,0,0,1.43-.8,1.38,1.38,0,0,0,1.46.38,1.11,1.11,0,0,0-.39-1.28,1.15,1.15,0,0,0,.58-1A1.63,1.63,0,0,0,93.46,332.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.85,333.19a.68.68,0,0,0-.64.62s.06.4.68.37.64-.45.64-.45A.65.65,0,0,0,92.85,333.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.36,322.87s-.21-.6-.6-.39-.26.58.08.67c0,0-.74.24-.53.64s.84,0,1-.23c0,0,.14.61.65.39s0-.73,0-.73.79-.31.36-.67S95.36,322.87,95.36,322.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,331.7s-.2-.6-.6-.4-.26.59.09.67c0,0-.74.24-.54.64s.85,0,1-.22c0,0,.14.6.66.39s0-.74,0-.74.79-.31.36-.67S99.4,331.7,99.4,331.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.17,328.6s.06-.64-.38-.61-.48.42-.2.64c0,0-.78-.08-.75.36s.77.34,1,.21c0,0-.12.6.44.62s.3-.67.3-.67.85.05.61-.46S100.17,328.6,100.17,328.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.88,330.23s.06-.64-.39-.61-.48.42-.2.65c0,0-.77-.09-.75.35s.78.34,1,.21c0,0-.13.6.43.62s.31-.67.31-.67.85.05.6-.46S94.88,330.23,94.88,330.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.88,329.23s-.51-.68-.12-.84.55.42.55.42.39-.46.58-.14-.29.68-.29.68.53.29.23.57-.68-.16-.68-.16-.21.51-.53.37S88.5,329.39,88.88,329.23Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowers--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109,320.34s-.28-.52-1.22-.34a2.32,2.32,0,0,0-1.37.81,2,2,0,0,0,1.89.72A.85.85,0,0,0,109,320.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,320.34s-.28-.52-1.22-.34a2.32,2.32,0,0,0-1.37.81,2,2,0,0,0,1.89.72A.85.85,0,0,0,109,320.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3,321.53c.67-.18.78-.58.77-.87a3.65,3.65,0,0,0-2.66.15A2,2,0,0,0,108.3,321.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,320.2s.41-.43,0-1.26a2.24,2.24,0,0,0-1.18-1.06,2,2,0,0,0-.12,2A.85.85,0,0,0,109.85,320.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.85,320.2s.41-.43,0-1.26a2.24,2.24,0,0,0-1.18-1.06,2,2,0,0,0-.12,2A.85.85,0,0,0,109.85,320.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5,319.9c.38.58.8.56,1.07.46a3.62,3.62,0,0,0-.95-2.48A2,2,0,0,0,108.5,319.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,320.11s.42-1.06.88-.72-.1.93-.1.93.81.13.56.57-1,.14-1,.14,0,.81-.51.66-.28-.9-.28-.9-.74.12-.8-.36S108.94,319.78,109.4,320.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.26,314.84s-.11-1.23-2.05-1.64a4.71,4.71,0,0,0-3.27.42s.71,2.61,3,2.93S111.26,314.84,111.26,314.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.26,314.84s-.11-1.23-2.05-1.64a4.71,4.71,0,0,0-3.27.42s.71,2.61,3,2.93S111.26,314.84,111.26,314.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,316.55c1.42.2,2-.49,2.16-1.05-1.66-2-5.19-1.88-5.19-1.88S106.65,316.23,109,316.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,313.82s-.76-1,.37-2.6a4.67,4.67,0,0,1,2.67-1.93s1.27,2.38-.2,4.2A1.77,1.77,0,0,1,113.51,313.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,313.82s-.76-1,.37-2.6a4.67,4.67,0,0,1,2.67-1.93s1.27,2.38-.2,4.2A1.77,1.77,0,0,1,113.51,313.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.35,313.49a1.75,1.75,0,0,1-2.3.72c-.12-2.56,2.5-4.92,2.5-4.92S117.82,311.67,116.35,313.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,316.35a2.14,2.14,0,0,0-.4,2.6,5.44,5.44,0,0,0,3,1.8,3.62,3.62,0,0,0-.18-3.53A2.41,2.41,0,0,0,112.09,316.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,316.35a2.14,2.14,0,0,0-.4,2.6,5.44,5.44,0,0,0,3,1.8,3.62,3.62,0,0,0-.18-3.53A2.41,2.41,0,0,0,112.09,316.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.69,319a5.44,5.44,0,0,0,3,1.8c-.18-2.18-2.64-4.4-2.64-4.4A2.14,2.14,0,0,0,111.69,319Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.07,314s-.1-1.28-1.11-1.41c0,0-.82-.13-1.27,1.15a2.67,2.67,0,0,0-2.38.29,1.48,1.48,0,0,0,1.11,1.64,1.87,1.87,0,0,0-.39,2s2.06.67,2.56-.62c0,0,.19,1.15,2.2,1.13a1.92,1.92,0,0,0,0-2.29s1.42-.06,1.64-1.11C116.41,314.82,115.44,313.23,114.07,314Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,314.23a1.4,1.4,0,0,0-1.51.95s0,.75,1.29.85,1.47-.65,1.47-.65A1.26,1.26,0,0,0,112.83,314.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63,318s-.46-.91-1.19-1a2,2,0,0,0-.73,1.31,1.85,1.85,0,0,0-1.61.41,1.72,1.72,0,0,0,1,1.18,2.3,2.3,0,0,0,.06,1.69,2,2,0,0,0,1.92-1.1,1.87,1.87,0,0,0,2,.5,1.49,1.49,0,0,0-.54-1.72,1.58,1.58,0,0,0,.78-1.39A2.22,2.22,0,0,0,102.63,318Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.83,318.53a1.06,1.06,0,0,0-1,.86s.09.55,1.05.48,1-.64,1-.64A.92.92,0,0,0,101.83,318.53Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.88,323.23s.45-.88,2-.61a3.76,3.76,0,0,1,2.31,1.28,3.29,3.29,0,0,1-3.12,1.28A1.41,1.41,0,0,1,105.88,323.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.88,323.23s.45-.88,2-.61a3.76,3.76,0,0,1,2.31,1.28,3.29,3.29,0,0,1-3.12,1.28A1.41,1.41,0,0,1,105.88,323.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.08,325.18c-1.12-.27-1.31-.94-1.3-1.42,1.82-1,4.42.14,4.42.14A3.29,3.29,0,0,1,107.08,325.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.32,312.85s.39-.39,0-1.17a2.12,2.12,0,0,0-1.1-1,1.83,1.83,0,0,0-.11,1.88A.79.79,0,0,0,119.32,312.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.32,312.85s.39-.39,0-1.17a2.12,2.12,0,0,0-1.1-1,1.83,1.83,0,0,0-.11,1.88A.79.79,0,0,0,119.32,312.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.07,312.57c.35.54.74.53,1,.43a3.35,3.35,0,0,0-.88-2.31A1.83,1.83,0,0,0,118.07,312.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,312.8s-.18-.82,1-1.48a3.21,3.21,0,0,1,2.22-.4,2.82,2.82,0,0,1-1.37,2.53A1.21,1.21,0,0,1,120.47,312.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,312.8s-.18-.82,1-1.48a3.21,3.21,0,0,1,2.22-.4,2.82,2.82,0,0,1-1.37,2.53A1.21,1.21,0,0,1,120.47,312.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.32,313.45a1.2,1.2,0,0,1-1.63-.25c.69-1.61,3-2.28,3-2.28A2.82,2.82,0,0,1,122.32,313.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.45,314.73a1.68,1.68,0,0,0-1,1.82,4.28,4.28,0,0,0,1.76,2.14A2.84,2.84,0,0,0,121,316,1.91,1.91,0,0,0,119.45,314.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.45,314.73a1.68,1.68,0,0,0-1,1.82,4.28,4.28,0,0,0,1.76,2.14A2.84,2.84,0,0,0,121,316,1.91,1.91,0,0,0,119.45,314.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,316.55a4.28,4.28,0,0,0,1.76,2.14c.46-1.66-.77-4-.77-4A1.68,1.68,0,0,0,118.46,316.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.14,312.81s.42-.85,1.1-.95a1.86,1.86,0,0,1,.69,1.21,1.75,1.75,0,0,1,1.51.36,1.61,1.61,0,0,1-1,1.11,2.12,2.12,0,0,1,0,1.57,1.85,1.85,0,0,1-1.8-1,1.74,1.74,0,0,1-1.84.49,1.38,1.38,0,0,1,.48-1.61,1.45,1.45,0,0,1-.75-1.28A2.1,2.1,0,0,1,119.14,312.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9,313.31a1,1,0,0,1,.95.79s-.08.51-1,.46-1-.59-1-.59A.86.86,0,0,1,119.9,313.31Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.53,317.59s-.32-1.1-.81-.81,0,.94,0,.94-.81,0-.61.52,1,.23,1,.23-.12.81.44.71.37-.87.37-.87.72.18.83-.28S107,317.3,106.53,317.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.73,318.4s-.2-.56-.57-.37-.24.56.09.63c0,0-.7.24-.5.61s.8,0,.92-.22c0,0,.14.57.62.36s0-.69,0-.69.74-.3.33-.63S116.73,318.4,116.73,318.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,321.65s.06-.66-.41-.63-.49.45-.2.68c0,0-.81-.09-.78.38s.81.34,1,.2c0,0-.12.64.47.66s.31-.71.31-.71.89,0,.63-.49S112.5,321.65,112.5,321.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,314.69s.07-.86-.53-.82-.64.58-.26.87c0,0-1-.1-1,.5s1,.44,1.33.26c0,0-.16.82.6.84s.4-.91.4-.91,1.15.06.82-.63S124.35,314.69,124.35,314.69Z",
    style: {
      fill: "#fafafa"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Awning--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.46,219.21a9,9,0,0,1-4,7l0,0c-2.22,1.28-4,.23-4-2.33v-4.72l8.12-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22,228.6a8.94,8.94,0,0,1-4.05,7l0,0c-2.22,1.28-4,.23-4-2.34v-4.71l8.13-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,238a8.94,8.94,0,0,1-4,7l-.05,0c-2.22,1.28-4,.23-4-2.33v-4.72l8.13-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.72,247.33a9,9,0,0,1-4,7l0,0c-2.23,1.29-4,.25-4-2.32v-4.72l8.13-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.59,214.52a9,9,0,0,1-4,7l-.05,0c-2.22,1.28-4,.23-4-2.33v-4.72l8.13-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,223.9a9,9,0,0,1-4,7l0,0c-2.23,1.28-4,.23-4-2.33v-4.72l8.13-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,233.29a9,9,0,0,1-4,7l0,0c-2.22,1.28-4,.23-4-2.33v-4.72l8.12-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.84,242.64a9,9,0,0,1-4,7l0,0c-2.22,1.29-4,.25-4-2.32v-4.72l8.12-4.7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.46,219.21a9,9,0,0,1-4,7l0,0c-2.22,1.28-4,.23-4-2.33v-4.72l8.12-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22,228.6a8.94,8.94,0,0,1-4.05,7l0,0c-2.22,1.28-4,.23-4-2.34v-4.71l8.13-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,238a8.94,8.94,0,0,1-4,7l-.05,0c-2.22,1.28-4,.23-4-2.33v-4.72l8.13-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.72,247.33a9,9,0,0,1-4,7l0,0c-2.23,1.29-4,.25-4-2.32v-4.72l8.13-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.59,214.52a9,9,0,0,1-4,7l-.05,0c-2.22,1.28-4,.23-4-2.33v-4.72l8.13-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,223.9a9,9,0,0,1-4,7l0,0c-2.23,1.28-4,.23-4-2.33v-4.72l8.13-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,233.29a9,9,0,0,1-4,7l0,0c-2.22,1.28-4,.23-4-2.33v-4.72l8.12-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.84,242.64a9,9,0,0,1-4,7l0,0c-2.22,1.29-4,.25-4-2.32v-4.72l8.12-4.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136,228.6a9,9,0,0,0,4,7l.05,0c2.22,1.28,4,.23,4-2.34v-4.71L136,223.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.22,238a9,9,0,0,0,4,7l0,0c2.23,1.28,4,.23,4-2.34v-4.71l-8.12-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.47,247.33a9,9,0,0,0,4,7l0,0c2.23,1.29,4,.24,4-2.33v-4.72l-8.12-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,233.29a9,9,0,0,0,4,7l0,0c2.22,1.28,4,.23,4-2.34v-4.71l-8.12-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,242.64a9,9,0,0,0,4,7l0,0c2.22,1.29,4,.24,4-2.33v-4.72l-8.13-4.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136,228.6a9,9,0,0,0,4,7l.05,0c2.22,1.28,4,.23,4-2.34v-4.71L136,223.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.22,238a9,9,0,0,0,4,7l0,0c2.23,1.28,4,.23,4-2.34v-4.71l-8.12-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.47,247.34a9,9,0,0,0,4,7l.08,0c2.21,1.28,4,.24,4-2.31v-4.76l-8.12-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,233.29a9,9,0,0,0,4,7l0,0c2.22,1.28,4,.23,4-2.34v-4.71l-8.12-4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,242.64a9,9,0,0,0,4,7l0,0c2.22,1.29,4,.24,4-2.33v-4.72l-8.13-4.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.18,193.83c-5.89-3.47-34.83-20.07-40.67-23.48s-14-3-23,2.24C150.52,183,136,203.15,136,223.87l40.62,23.45,65-37.52C241.59,202.17,238,197.25,232.18,193.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.18,193.83c-5.89-3.47-34.83-20.07-40.67-23.48s-14-3-23,2.24C150.52,183,136,203.15,136,223.87l40.62,23.45,65-37.52C241.59,202.17,238,197.25,232.18,193.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,196c-18,10.36-32.5,30.56-32.5,51.28l65-37.52c0-7.63-3.59-12.55-9.41-16S218.12,190.82,209.09,196Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--trazado--inject-5",
    d: "M209.09,196c-18,10.36-32.5,30.56-32.5,51.28l65-37.52c0-7.63-3.59-12.55-9.41-16S218.12,190.82,209.09,196Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19,222.7v-4.13l-2.77,1.6v4.13l-1.72,1V215l1.72-1v3.83l2.77-1.6v-3.83l1.72-1v10.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.77,216.08c0-3.12,1.53-6.2,3.57-7.37s3.56.13,3.56,3.26-1.52,6.19-3.56,7.37S200.77,219.21,200.77,216.08Zm5.38-3.1c0-1.68-.71-2.57-1.81-1.93a4.75,4.75,0,0,0-1.82,4c0,1.67.71,2.57,1.82,1.92S206.15,214.64,206.15,213Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,215.86v-8L208.17,209v-2.31l5.45-3.14v2.31l-1.86,1.07v8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.44,213.32V203l4.89-2.82v2.31l-3.17,1.83V206l3.1-1.79v2.31l-3.1,1.79V210l3.17-1.83v2.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.33,209.92V199.64l1.72-1v8l2.68-1.54v2.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.34,225.59l.47,1a.11.11,0,0,0,.15.06l1-.4c.16-.07.23.17.11.39l-.76,1.43a.46.46,0,0,0-.06.27l.18,1.29c0,.2-.14.47-.29.45l-.94-.12a.27.27,0,0,0-.19.11l-.93,1.2c-.15.19-.32.12-.3-.12l.18-1.49a.21.21,0,0,0-.06-.2l-.75-.55c-.12-.09-.06-.4.11-.53l1.05-.8a.52.52,0,0,0,.15-.24l.47-1.53C199.05,225.55,199.27,225.43,199.34,225.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,221.8l.47,1a.12.12,0,0,0,.15.06l1-.4c.16-.07.23.17.11.39l-.76,1.42a.48.48,0,0,0,0,.28l.17,1.28c0,.21-.14.48-.29.46l-.94-.12a.24.24,0,0,0-.18.11l-.94,1.2c-.15.19-.32.12-.29-.12l.17-1.49a.23.23,0,0,0,0-.21l-.76-.54c-.12-.09-.06-.4.11-.53l1-.8a.58.58,0,0,0,.15-.24l.47-1.54C205.67,221.76,205.89,221.64,206,221.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.58,218l.47,1a.12.12,0,0,0,.15.06l1.05-.4c.17-.07.23.17.11.39l-.75,1.42a.49.49,0,0,0-.06.28l.18,1.28c0,.21-.15.48-.3.46l-.93-.12c-.06,0-.13,0-.19.11l-.94,1.2c-.15.19-.32.12-.29-.12l.18-1.49a.23.23,0,0,0-.06-.21l-.76-.54c-.12-.09-.05-.4.11-.53l1-.81a.54.54,0,0,0,.15-.23l.47-1.54C212.29,218,212.51,217.85,212.58,218Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.2,214.21l.47,1a.13.13,0,0,0,.16.06l1-.41c.17-.06.23.18.11.4l-.75,1.42a.48.48,0,0,0-.06.28l.18,1.28c0,.21-.15.47-.3.46l-.93-.12a.22.22,0,0,0-.19.11l-.94,1.2c-.15.19-.32.12-.29-.12l.18-1.49a.22.22,0,0,0-.06-.21l-.76-.54c-.12-.09-.05-.4.11-.53l1.05-.81a.46.46,0,0,0,.15-.23l.47-1.54C218.92,214.18,219.13,214.05,219.2,214.21Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Light--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.89,75.85a2.86,2.86,0,0,1,2.58,0,.88.88,0,0,1,.53.74V268.88a.9.9,0,0,1-.53.75,2.86,2.86,0,0,1-2.58,0,.93.93,0,0,1-.53-.75V76.59A.9.9,0,0,1,319.89,75.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.32,116.67c0-5.71,8.55-14.27,8.55-14.27h6.8s8.55,8.56,8.55,14.27h0c0,1.77-1.16,3.53-3.49,4.88-4.67,2.69-12.23,2.69-16.9,0-2.33-1.35-3.5-3.11-3.5-4.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.32,116.67c0-5.71,8.55-14.27,8.55-14.27h6.8s8.55,8.56,8.55,14.27h0c0,1.77-1.16,3.53-3.49,4.88-4.67,2.69-12.23,2.69-16.9,0-2.33-1.35-3.5-3.11-3.5-4.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.19,102.07a6.48,6.48,0,0,0-5.85,0c-1.61.93-1.61,2.45,0,3.38a6.48,6.48,0,0,0,5.85,0C343.81,104.52,343.81,103,342.19,102.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.19,102.07a6.48,6.48,0,0,0-5.85,0c-1.61.93-1.61,2.45,0,3.38a6.48,6.48,0,0,0,5.85,0C343.81,104.52,343.81,103,342.19,102.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.19,102.07a6.48,6.48,0,0,0-5.85,0c-1.61.93-1.61,2.45,0,3.38a6.48,6.48,0,0,0,5.85,0C343.81,104.52,343.81,103,342.19,102.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.93,82.39a.48.48,0,0,1,.57,0h0l14.72,8.45a6.23,6.23,0,0,1,3.08,5.35v7.58h0a.51.51,0,0,1-.31.43,1.65,1.65,0,0,1-1.5,0,.51.51,0,0,1-.31-.43V96.18a4.09,4.09,0,0,0-2-3.5l-14.75-8.5h0a.5.5,0,0,1-.26-.49A1.67,1.67,0,0,1,321.93,82.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.36,76.58c0,.57.82,1,1.82,1s1.82-.47,1.82-1-.81-1-1.82-1S319.36,76,319.36,76.58Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.77,271.16c-4.25-4.39-6.75-22.24-2.6-25.72h21.09c4.14,3.48,1.65,21.32-2.6,25.71l-.11.12-.15.15-.38.34-.11.08a2.72,2.72,0,0,1-.32.25,4.62,4.62,0,0,1-.55.35,13.84,13.84,0,0,1-12.65,0h0a4.31,4.31,0,0,1-.55-.36l-.3-.22-.12-.1a4,4,0,0,1-.37-.34l-.17-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.43,244c4.81,2.81,4.81,7.37,0,10.18s-12.62,2.81-17.43,0-4.81-7.37,0-10.18S296.62,241.23,301.43,244Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.43,244c4.81,2.81,4.81,7.37,0,10.18s-12.62,2.81-17.43,0-4.81-7.37,0-10.18S296.62,241.23,301.43,244Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.11,245.4c3.54,2.06,3.54,5.4,0,7.47a14,14,0,0,1-12.79,0c-3.54-2.07-3.54-5.41,0-7.47A14,14,0,0,1,299.11,245.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.32,248.94a14,14,0,0,1,12.79,0,5.89,5.89,0,0,1,2.12,2,5.91,5.91,0,0,1-2.12,2,14,14,0,0,1-12.79,0,5.91,5.91,0,0,1-2.12-2A5.89,5.89,0,0,1,286.32,248.94Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.18,212.53l-8,6.35,7.74-3.58a21.39,21.39,0,0,1-1.34,7.34,46.71,46.71,0,0,0-6,4.27l5.94-2.34a29.81,29.81,0,0,1-1.23,9.88c-.42,1.56-2.18,4.54-3.29,6.77a25.5,25.5,0,0,1-1.72,3l-.12.18c-1.36-.77-2.77-1.53-4.23-2.26a43.31,43.31,0,0,1-2.65-11c-1.71-15.54,10-24.44,19.49-27.43A28,28,0,0,0,302.18,212.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.18,212.53l-8,6.35,7.74-3.58a21.39,21.39,0,0,1-1.34,7.34,46.71,46.71,0,0,0-6,4.27l5.94-2.34a29.81,29.81,0,0,1-1.23,9.88c-.42,1.56-2.18,4.54-3.29,6.77a25.5,25.5,0,0,1-1.72,3l-.12.18c-1.36-.77-2.77-1.53-4.23-2.26a43.31,43.31,0,0,1-2.65-11c-1.71-15.54,10-24.44,19.49-27.43A28,28,0,0,0,302.18,212.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.48,213.18a15.09,15.09,0,0,0-3.32,6,31.56,31.56,0,0,0-1.43,6.72,29.17,29.17,0,0,0,1.7,13.49h0a.22.22,0,0,1-.13.29.23.23,0,0,1-.29-.13h0a29.53,29.53,0,0,1-1.5-13.69,31.73,31.73,0,0,1,1.54-6.73A15.15,15.15,0,0,1,295.48,213.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.52,220.67v0a117.36,117.36,0,0,1,8.37,11.75l8.12,1.31-6,1.05,3.22,5.09,8,1.66-6.24,1s1.73,6.1,6.2,8.64c2.47,1.4,3.67,1.61,4.41.91.52-.49.64-3.42,1.07-6a19.86,19.86,0,0,0-2-12,15.83,15.83,0,0,0-2.56-3.76C284.22,223.77,273,220.59,267.52,220.67Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.52,220.67v0a117.36,117.36,0,0,1,8.37,11.75l8.12,1.31-6,1.05,3.22,5.09,8,1.66-6.24,1s1.73,6.1,6.2,8.64c2.47,1.4,3.67,1.61,4.41.91.52-.49.64-3.42,1.07-6a19.86,19.86,0,0,0-2-12,15.83,15.83,0,0,0-2.56-3.76C284.22,223.77,273,220.59,267.52,220.67Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,223.33a33.32,33.32,0,0,1,11.3,7.81,22.54,22.54,0,0,1,3.87,5.74,21,21,0,0,1,1.76,6.68s0,0,0,0,0,0,0,0a26.85,26.85,0,0,0-2.13-6.49,25,25,0,0,0-3.73-5.7,33.81,33.81,0,0,0-11.05-8s0,0,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.92,224h0a18.81,18.81,0,0,0-2,.09,32.52,32.52,0,0,0-7.82,1.91c-.94.34-1.87.74-2.8,1.18-.46.22-.91.45-1.36.69a22.62,22.62,0,0,0-6,4.53,14.22,14.22,0,0,0-2.07,2.9l-.22.41h0c-.17.36-.33.71-.48,1.06a19.59,19.59,0,0,0-1.76,9.62c.08,2.33.88,5,1.33,5.43a1,1,0,0,0,.2.15c.67.43,1.73.18,3.7-.93,4-2.21,5.52-7.82,5.52-7.82l-5.51-.93,7.07-1.41,2.87-4.48-5.28-1,7.18-1.11A105.85,105.85,0,0,1,315.91,224Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.92,224h0a18.81,18.81,0,0,0-2,.09,32.52,32.52,0,0,0-7.82,1.91c-.94.34-1.87.74-2.8,1.18-.46.22-.91.45-1.36.69a22.62,22.62,0,0,0-6,4.53,14.22,14.22,0,0,0-2.07,2.9l-.22.41h0c-.17.36-.33.71-.48,1.06a19.59,19.59,0,0,0-1.76,9.62c.08,2.33.88,5,1.33,5.43a1,1,0,0,0,.2.15c.67.43,1.73.18,3.7-.93,4-2.21,5.52-7.82,5.52-7.82l-5.51-.93,7.07-1.41,2.87-4.48-5.28-1,7.18-1.11A105.85,105.85,0,0,1,315.91,224Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.88,224.12a32.52,32.52,0,0,0-7.82,1.91c-.94.34-1.87.74-2.8,1.18-.46.22-.91.45-1.36.69a22.62,22.62,0,0,0-6,4.53,14.22,14.22,0,0,0-2.07,2.9l-.22.41h0c-.17.36-.33.71-.48,1.06a19.59,19.59,0,0,0-1.76,9.62c.08,2.33.88,5,1.33,5.43a1,1,0,0,0,.2.15,1.11,1.11,0,0,0,.44.16c-.49-3.61,1.29-12.78,4-16.55,2.8-3.92,9.45-9.61,18.58-11.57h0A18.46,18.46,0,0,0,313.88,224.12Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.33,252.17a30.69,30.69,0,0,1,.52-8,25.71,25.71,0,0,1,2.65-7.58,22.46,22.46,0,0,1,5.37-6,30.25,30.25,0,0,1,6.88-4.12s0,0,0,0,0,0,0,0a39,39,0,0,0-6.62,4.43,28.72,28.72,0,0,0-2.91,2.71,17.44,17.44,0,0,0-2.43,3.12,25.19,25.19,0,0,0-2.74,7.45,30.67,30.67,0,0,0-.7,7.94s0,0,0,0A0,0,0,0,1,293.33,252.17Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.48,412.78c-4.25-4.39-6.75-22.24-2.61-25.71H58c4.14,3.47,1.65,21.31-2.6,25.7l-.12.12-.14.15c-.12.11-.25.23-.39.34l-.1.08a3.92,3.92,0,0,1-.32.25,4.62,4.62,0,0,1-.55.35,13.86,13.86,0,0,1-12.66,0h0a4.62,4.62,0,0,1-.55-.35l-.3-.23-.13-.1-.37-.34-.17-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.13,385.66c4.82,2.81,4.82,7.37,0,10.18s-12.61,2.81-17.42,0-4.82-7.37,0-10.17S51.32,382.86,56.13,385.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.13,385.66c4.82,2.81,4.82,7.37,0,10.18s-12.61,2.81-17.42,0-4.82-7.37,0-10.17S51.32,382.86,56.13,385.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.82,387c3.53,2.06,3.53,5.41,0,7.47a14,14,0,0,1-12.8,0c-3.53-2.06-3.53-5.41,0-7.47A14,14,0,0,1,53.82,387Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,390.56a14,14,0,0,1,12.8,0,6,6,0,0,1,2.12,2,6,6,0,0,1-2.12,2,14,14,0,0,1-12.8,0,6,6,0,0,1-2.12-2A6,6,0,0,1,41,390.56Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.88,354.15l-8,6.35,7.75-3.58a21.53,21.53,0,0,1-1.35,7.34,47.46,47.46,0,0,0-6,4.27l5.94-2.34A29.6,29.6,0,0,1,54,376.07c-.43,1.56-2.18,4.54-3.29,6.77a24.24,24.24,0,0,1-1.73,3,.94.94,0,0,1-.12.18c-1.35-.77-2.76-1.53-4.23-2.25a44,44,0,0,1-2.65-11c-1.7-15.54,10.05-24.44,19.49-27.43A28.25,28.25,0,0,0,56.88,354.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,354.15l-8,6.35,7.75-3.58a21.53,21.53,0,0,1-1.35,7.34,47.46,47.46,0,0,0-6,4.27l5.94-2.34A29.6,29.6,0,0,1,54,376.07c-.43,1.56-2.18,4.54-3.29,6.77a24.24,24.24,0,0,1-1.73,3,.94.94,0,0,1-.12.18c-1.35-.77-2.76-1.53-4.23-2.25a44,44,0,0,1-2.65-11c-1.7-15.54,10.05-24.44,19.49-27.43A28.25,28.25,0,0,0,56.88,354.15Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.19,354.8a15,15,0,0,0-3.33,6,32.16,32.16,0,0,0-1.42,6.72A29,29,0,0,0,47.14,381h0a.24.24,0,0,1-.13.29.22.22,0,0,1-.29-.13h0a29.37,29.37,0,0,1-1.5-13.68,31.08,31.08,0,0,1,1.54-6.74A15,15,0,0,1,50.19,354.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.22,362.3h0a120.43,120.43,0,0,1,8.37,11.75l8.13,1.31-6,1.05L36,381.51l8,1.66-6.25,1s1.74,6.1,6.21,8.64c2.46,1.4,3.67,1.61,4.41.91.52-.49.64-3.42,1.07-6a19.89,19.89,0,0,0-2-12A15.79,15.79,0,0,0,44.84,372C38.92,365.39,27.75,362.22,22.22,362.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.22,362.3h0a120.43,120.43,0,0,1,8.37,11.75l8.13,1.31-6,1.05L36,381.51l8,1.66-6.25,1s1.74,6.1,6.21,8.64c2.46,1.4,3.67,1.61,4.41.91.52-.49.64-3.42,1.07-6a19.89,19.89,0,0,0-2-12A15.79,15.79,0,0,0,44.84,372C38.92,365.39,27.75,362.22,22.22,362.3Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.72,365A33.22,33.22,0,0,1,42,372.76a22.29,22.29,0,0,1,3.87,5.74,21.12,21.12,0,0,1,1.77,6.68l0,0,0,0a26.87,26.87,0,0,0-2.14-6.49,24.57,24.57,0,0,0-3.73-5.7,33.53,33.53,0,0,0-11-8,0,0,0,0,1,0,0S30.71,365,30.72,365Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.63,365.65h0a19,19,0,0,0-2,.09,32.63,32.63,0,0,0-7.82,1.91c-.93.35-1.87.74-2.79,1.18-.46.22-.92.45-1.37.7a22.36,22.36,0,0,0-6,4.53A13.84,13.84,0,0,0,48.55,377l-.22.41h0c-.18.36-.33.71-.48,1.06A19.61,19.61,0,0,0,46.08,388c.09,2.33.88,5,1.34,5.43a1,1,0,0,0,.2.15c.66.43,1.72.18,3.7-.92,4-2.22,5.51-7.83,5.51-7.83l-5.5-.93,7.06-1.41,2.87-4.48-5.28-1L63.16,376a104.71,104.71,0,0,1,7.46-10.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.63,365.65h0a19,19,0,0,0-2,.09,32.63,32.63,0,0,0-7.82,1.91c-.93.35-1.87.74-2.79,1.18-.46.22-.92.45-1.37.7a22.36,22.36,0,0,0-6,4.53A13.84,13.84,0,0,0,48.55,377l-.22.41h0c-.18.36-.33.71-.48,1.06A19.61,19.61,0,0,0,46.08,388c.09,2.33.88,5,1.34,5.43a1,1,0,0,0,.2.15c.66.43,1.72.18,3.7-.92,4-2.22,5.51-7.83,5.51-7.83l-5.5-.93,7.06-1.41,2.87-4.48-5.28-1L63.16,376a104.71,104.71,0,0,1,7.46-10.32Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58,365.74a32.63,32.63,0,0,0-7.82,1.91c-.93.35-1.87.74-2.79,1.18-.46.22-.92.45-1.37.7a22.36,22.36,0,0,0-6,4.53A13.84,13.84,0,0,0,48.55,377l-.22.41h0c-.18.36-.33.71-.48,1.06A19.61,19.61,0,0,0,46.08,388c.09,2.33.88,5,1.34,5.43a1,1,0,0,0,.2.15,1.06,1.06,0,0,0,.43.16c-.48-3.61,1.29-12.78,4-16.55,2.8-3.92,9.44-9.61,18.58-11.57h0A18.53,18.53,0,0,0,68.58,365.74Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,393.79a31.13,31.13,0,0,1,.52-8,26,26,0,0,1,2.65-7.58,22.63,22.63,0,0,1,5.37-6,30.1,30.1,0,0,1,6.89-4.12s0,0,0,0a0,0,0,0,1,0,0,39,39,0,0,0-6.62,4.43A28.72,28.72,0,0,0,54,375.27a17.86,17.86,0,0,0-2.44,3.12,25.76,25.76,0,0,0-2.74,7.45,30.66,30.66,0,0,0-.69,7.94s0,0,0,0S48,393.8,48,393.79Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.89,111.91l2.81-5.28-2.26-6.52v-4l6.91,4v4l-3,5.14a.38.38,0,0,1-.2.18h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.89,111.91l2.81-5.28-2.26-6.52v-4l6.91,4v4l-3,5.14a.38.38,0,0,1-.2.18h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.48,66.8a4.59,4.59,0,0,1,2.08-3.59l1.68-1a4.6,4.6,0,0,1,4.15,0l21,12.11a4.57,4.57,0,0,1,2.07,3.59v28.47a4.55,4.55,0,0,1-2.07,3.59l-1.69,1a4.58,4.58,0,0,1-4.14,0L429,106.62l-3,5.14a.44.44,0,0,1-.8-.08l-3.13-9.05-6.55-3.77a4.56,4.56,0,0,1-2.08-3.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.48,106.41a4.55,4.55,0,0,1-2.07,3.59l-1.69,1a4.63,4.63,0,0,1-3.79.17c1,.36,1.72-.19,1.72-1.37V81.31a4.28,4.28,0,0,0-.6-2l5.83-3.37a4.28,4.28,0,0,1,.6,2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.55,66.21c.24-.87,1.05-1.16,2-.6l21,12.11A4.13,4.13,0,0,1,438,79.27l5.83-3.36a4.21,4.21,0,0,0-1.46-1.55l-21-12.12a4.58,4.58,0,0,0-4.14,0l-1.7,1A4.62,4.62,0,0,0,413.55,66.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.13,97.35l-.25,0a1.86,1.86,0,0,1-1.45-1.06l-3.73-7.93a1.87,1.87,0,1,1,3.39-1.59l2.5,5.31,8.6-10A1.88,1.88,0,0,1,435,84.48L424.55,96.7A1.9,1.9,0,0,1,423.13,97.35Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.92,160.17l-12.18-2.29,4.87,20.67a1.05,1.05,0,0,0,.4.41l6.39,3.69A1.13,1.13,0,0,0,95,182l5.27-18.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.68,21.48c-.25-.91-1.08-1.2-2.07-.63L63.74,91.21a4.25,4.25,0,0,0-1.51,1.6,4.36,4.36,0,0,0-.63,2.11v88.8c0,1.22.76,1.79,1.77,1.41h0a2,2,0,0,0,.36-.17l24.38-14.08L93,182.24a1.13,1.13,0,0,0,2-.2l5.27-18.19,85.3-49.25a4.73,4.73,0,0,0,2.15-3.71V22.09A2.6,2.6,0,0,0,187.68,21.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,21.55c.05,0,.09,0,.14.16a1.53,1.53,0,0,1,0,.38v88.8a3.76,3.76,0,0,1-1.65,2.85L99.8,163l-.35.2-.11.39-5.26,18.16a.11.11,0,0,1-.12.07.19.19,0,0,1-.09,0L89,170.49l-.44-1-1,.56L63.2,184.12l-.06,0-.12,0a.77.77,0,0,1-.24.05c-.18,0-.18-.51-.18-.53V94.92a3.46,3.46,0,0,1,.5-1.63,3.29,3.29,0,0,1,1.14-1.22L186.11,21.71a1,1,0,0,1,.46-.16m0-1a2,2,0,0,0-1,.3L63.74,91.21a4.25,4.25,0,0,0-1.51,1.6,4.36,4.36,0,0,0-.63,2.11v88.8c0,1,.48,1.53,1.18,1.53a1.68,1.68,0,0,0,.59-.12h0a2,2,0,0,0,.36-.17l24.38-14.08L93,182.24a1.1,1.1,0,0,0,1,.56A1.11,1.11,0,0,0,95,182l5.27-18.19,85.3-49.25a4.73,4.73,0,0,0,2.15-3.71V22.09a2.6,2.6,0,0,0-.07-.61,1.12,1.12,0,0,0-1.11-.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.57,180.24A4.75,4.75,0,0,0,57.71,184l1.75,1a4.78,4.78,0,0,0,3.92.17c-1,.38-1.78-.19-1.78-1.41V94.92a4.33,4.33,0,0,1,.63-2.11l-6-3.49a4.46,4.46,0,0,0-.62,2.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.68,21.48c-.25-.91-1.08-1.2-2.07-.63L63.74,91.21a4.25,4.25,0,0,0-1.51,1.6l-6-3.48a4.32,4.32,0,0,1,1.51-1.6L179.57,17.37a4.77,4.77,0,0,1,4.29,0l1.75,1A4.73,4.73,0,0,1,187.68,21.48Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Info--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.49,103.43a.17.17,0,0,1,.21,0,.37.37,0,0,1,.08.26v1.18a.94.94,0,0,1-.08.36.6.6,0,0,1-.21.25l-4.7,2.71a.15.15,0,0,1-.2,0,.35.35,0,0,1-.09-.27V97.26a.8.8,0,0,1,.09-.36.66.66,0,0,1,.2-.25l.87-.5a.16.16,0,0,1,.21,0,.41.41,0,0,1,.08.27v9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.72,98.32a4.23,4.23,0,0,1,.19-.86,6.51,6.51,0,0,1,.44-1,5.8,5.8,0,0,1,.7-1,4,4,0,0,1,1-.77,2.24,2.24,0,0,1,1-.35,1.07,1.07,0,0,1,.75.21,1.55,1.55,0,0,1,.49.8,4.65,4.65,0,0,1,.17,1.4v4.85a1,1,0,0,1-.08.37.6.6,0,0,1-.21.25l-.81.47a.15.15,0,0,1-.2,0,.33.33,0,0,1-.09-.26v-.55a5,5,0,0,1-.65,1.2,3.34,3.34,0,0,1-1.08,1,1.78,1.78,0,0,1-.82.28.79.79,0,0,1-.61-.18,1.31,1.31,0,0,1-.39-.6,3.25,3.25,0,0,1-.13-1,4.24,4.24,0,0,1,.53-2.09,6.22,6.22,0,0,1,1.4-1.69L80,97.35c0-.45-.1-.71-.29-.79a.85.85,0,0,0-.72.14,1.35,1.35,0,0,0-.42.35,5.06,5.06,0,0,0-.29.48,1.71,1.71,0,0,1-.17.29A1.19,1.19,0,0,1,78,98l-1,.58a.15.15,0,0,1-.18,0S76.7,98.44,76.72,98.32Zm1.79,3.62a2.75,2.75,0,0,0,.65-.53,3.3,3.3,0,0,0,.47-.7,3.21,3.21,0,0,0,.29-.76,2.73,2.73,0,0,0,.1-.73v-.17l-1.46,1.24a2.82,2.82,0,0,0-.63.71,1.38,1.38,0,0,0-.19.71c0,.23.07.36.23.38A.89.89,0,0,0,78.51,101.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.44,86.46c.89-.51,1.57-.58,2-.22a2.86,2.86,0,0,1,.69,2.26,7.29,7.29,0,0,1-.35,2.27,5.85,5.85,0,0,1-1.06,1.87l1.48,3.22a.51.51,0,0,1,0,.17.62.62,0,0,1-.07.29.46.46,0,0,1-.17.21l-.91.52c-.14.09-.25.09-.31,0a.69.69,0,0,1-.15-.21l-1.4-3-1.43.82v3.85a.8.8,0,0,1-.09.36.52.52,0,0,1-.2.25l-.87.5a.15.15,0,0,1-.2,0,.35.35,0,0,1-.09-.27V88.68a.81.81,0,0,1,.09-.37.52.52,0,0,1,.2-.25Zm-1.61,6.13,1.56-.89a3,3,0,0,0,1-.9,2.61,2.61,0,0,0,.37-1.46c0-.62-.13-1-.37-1a1.3,1.3,0,0,0-1,.25l-1.56.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.84,85.57a2.15,2.15,0,0,1,1.07-.33,1.25,1.25,0,0,1,.83.3,2,2,0,0,1,.55.83,4.28,4.28,0,0,1,.25,1.28c0,.1,0,.22,0,.38v.91c0,.15,0,.28,0,.38a7.68,7.68,0,0,1-.25,1.56,7.82,7.82,0,0,1-.55,1.47,6.79,6.79,0,0,1-.83,1.25,3.91,3.91,0,0,1-1.07.89,2.14,2.14,0,0,1-1.06.34,1.33,1.33,0,0,1-.83-.29,1.89,1.89,0,0,1-.55-.83,4.28,4.28,0,0,1-.25-1.28c0-.1,0-.22,0-.36s0-.3,0-.45,0-.31,0-.47,0-.29,0-.39a7,7,0,0,1,.24-1.56A7.84,7.84,0,0,1,93,87.73a5.85,5.85,0,0,1,.83-1.26A4.1,4.1,0,0,1,94.84,85.57Zm1.3,3a2.25,2.25,0,0,0-.15-.76.75.75,0,0,0-.31-.36.54.54,0,0,0-.4,0,1.46,1.46,0,0,0-.44.18,2.44,2.44,0,0,0-.44.32,2.36,2.36,0,0,0-.39.51,2.72,2.72,0,0,0-.31.71,4.2,4.2,0,0,0-.15.94,3,3,0,0,0,0,.34c0,.13,0,.27,0,.41s0,.29,0,.42a2.45,2.45,0,0,0,0,.32,2.31,2.31,0,0,0,.15.76.75.75,0,0,0,.31.36.58.58,0,0,0,.39,0,1.37,1.37,0,0,0,.44-.18,2.66,2.66,0,0,0,.44-.33,2,2,0,0,0,.4-.5A3.61,3.61,0,0,0,96,91a4.3,4.3,0,0,0,.15-.94,3,3,0,0,0,0-.33v-.84A3,3,0,0,0,96.14,88.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,87.85a.26.26,0,0,0-.33-.32,3.16,3.16,0,0,0-.5.09l-.8.19a1.64,1.64,0,0,1-.78,0,.85.85,0,0,1-.5-.29,1.33,1.33,0,0,1-.26-.6,4.45,4.45,0,0,1-.08-.87A4.66,4.66,0,0,1,98.7,85a5.16,5.16,0,0,1,.44-1.1,5.24,5.24,0,0,1,.69-1,3.41,3.41,0,0,1,.93-.77,2.42,2.42,0,0,1,.94-.36,1.26,1.26,0,0,1,.71.07,1,1,0,0,1,.45.42A1.85,1.85,0,0,1,103,83a.78.78,0,0,1-.08.36.57.57,0,0,1-.21.26l-.83.47a.23.23,0,0,1-.24,0l-.18-.1a.46.46,0,0,0-.25-.06,1.1,1.1,0,0,0-.49.19,2.09,2.09,0,0,0-.56.47,1,1,0,0,0-.25.68.49.49,0,0,0,.06.27.24.24,0,0,0,.22.09,2.41,2.41,0,0,0,.46-.06c.2,0,.46-.1.77-.19q1-.24,1.35.21A2.13,2.13,0,0,1,103.2,87,3.74,3.74,0,0,1,103,88.1a5.36,5.36,0,0,1-.47,1.11,4.93,4.93,0,0,1-.75,1,4.24,4.24,0,0,1-1,.8,2.68,2.68,0,0,1-1,.38,1.24,1.24,0,0,1-.74-.12,1,1,0,0,1-.46-.47,1.55,1.55,0,0,1-.17-.71.68.68,0,0,1,.08-.36.57.57,0,0,1,.21-.26l.82-.47c.11-.07.19-.07.24,0l.19.16a.45.45,0,0,0,.28.1,1.14,1.14,0,0,0,.55-.2l.33-.22.32-.29a2.62,2.62,0,0,0,.24-.34A.8.8,0,0,0,101.8,87.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.35,82.37a4.18,4.18,0,0,1,.2-.86,5.09,5.09,0,0,1,.44-1,5.22,5.22,0,0,1,.69-1,4,4,0,0,1,1-.78,2.38,2.38,0,0,1,1-.34,1.07,1.07,0,0,1,.75.21,1.51,1.51,0,0,1,.49.8,4.65,4.65,0,0,1,.17,1.4v4.85a.85.85,0,0,1-.08.37.66.66,0,0,1-.2.25l-.82.47a.15.15,0,0,1-.2,0,.33.33,0,0,1-.09-.26v-.55a5,5,0,0,1-.65,1.19,3.34,3.34,0,0,1-1.08,1,1.81,1.81,0,0,1-.82.29.83.83,0,0,1-.61-.18,1.22,1.22,0,0,1-.38-.6,2.93,2.93,0,0,1-.14-.95,4.24,4.24,0,0,1,.53-2.09,6.07,6.07,0,0,1,1.4-1.69l1.75-1.47c0-.45-.1-.71-.29-.79a.84.84,0,0,0-.72.13,1.52,1.52,0,0,0-.42.36,5.06,5.06,0,0,0-.29.48,1.71,1.71,0,0,1-.17.29,1.19,1.19,0,0,1-.18.15l-1,.57a.14.14,0,0,1-.18,0A.23.23,0,0,1,104.35,82.37ZM106.14,86a2.75,2.75,0,0,0,.65-.53,3.66,3.66,0,0,0,.76-1.46,2.78,2.78,0,0,0,.1-.73V83.1l-1.46,1.24a3,3,0,0,0-.63.7,1.41,1.41,0,0,0-.19.72c0,.23.07.36.23.38A.89.89,0,0,0,106.14,86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.86,68.9a.14.14,0,0,1,.2,0,.33.33,0,0,1,.09.26V79.85a.8.8,0,0,1-.09.36.47.47,0,0,1-.2.25L118,81a.15.15,0,0,1-.2,0,.35.35,0,0,1-.09-.27V76.32l-3.24,1.87v4.36a1,1,0,0,1-.08.37.6.6,0,0,1-.21.25l-.87.5a.16.16,0,0,1-.2,0,.34.34,0,0,1-.09-.27V72.72a.8.8,0,0,1,.09-.36.59.59,0,0,1,.2-.25l.87-.5a.16.16,0,0,1,.21,0,.4.4,0,0,1,.08.27v4.24l3.24-1.87V70a.84.84,0,0,1,.09-.37.52.52,0,0,1,.2-.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.18,69.21a2.12,2.12,0,0,1,1.07-.33,1.2,1.2,0,0,1,.82.3,1.9,1.9,0,0,1,.56.83,4,4,0,0,1,.24,1.28,3.63,3.63,0,0,1,0,.38v.91a3.79,3.79,0,0,1,0,.38,7.66,7.66,0,0,1-.24,1.56,7.21,7.21,0,0,1-.56,1.47,5.93,5.93,0,0,1-.82,1.24,4.31,4.31,0,0,1-1.07.9,2.14,2.14,0,0,1-1.07.34,1.27,1.27,0,0,1-.82-.3,1.85,1.85,0,0,1-.55-.82,4.34,4.34,0,0,1-.25-1.28c0-.1,0-.22,0-.36v-.92c0-.16,0-.29,0-.39a7,7,0,0,1,.24-1.56,8.21,8.21,0,0,1,.56-1.48,6.43,6.43,0,0,1,.82-1.25A4.31,4.31,0,0,1,123.18,69.21Zm1.3,3a2,2,0,0,0-.16-.76.69.69,0,0,0-.3-.36.54.54,0,0,0-.4,0,1.73,1.73,0,0,0-.44.17,3.15,3.15,0,0,0-.44.33,2.28,2.28,0,0,0-.39.5,2.79,2.79,0,0,0-.31.72,4.7,4.7,0,0,0-.16.94c0,.09,0,.2,0,.34s0,.27,0,.41,0,.29,0,.42,0,.24,0,.31a2.42,2.42,0,0,0,.16.76.73.73,0,0,0,.31.37.58.58,0,0,0,.39,0,1.37,1.37,0,0,0,.44-.18,2.66,2.66,0,0,0,.44-.33,2,2,0,0,0,.4-.5,3.09,3.09,0,0,0,.3-.71,3.76,3.76,0,0,0,.16-.94,3.12,3.12,0,0,0,0-.33V72.5A2.92,2.92,0,0,0,124.48,72.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.92,71.55a1.06,1.06,0,0,0,.18.71c.12.14.34.11.66-.07l.65-.38a.16.16,0,0,1,.21,0,.41.41,0,0,1,.08.27v1.09a.94.94,0,0,1-.08.36.54.54,0,0,1-.21.25l-.79.46c-.68.39-1.19.44-1.55.14s-.54-1-.54-2V68.85l-.71.41a.16.16,0,0,1-.21,0,.41.41,0,0,1-.08-.27V67.89a.94.94,0,0,1,.08-.36.54.54,0,0,1,.21-.25l.71-.41V64.18a1,1,0,0,1,.08-.37.6.6,0,0,1,.21-.25l.81-.47a.15.15,0,0,1,.2,0,.33.33,0,0,1,.09.26v2.69l1.38-.79a.16.16,0,0,1,.21,0,.35.35,0,0,1,.08.27v1.09a.78.78,0,0,1-.08.36.6.6,0,0,1-.21.25l-1.38.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.47,68.89a8.87,8.87,0,0,1,.19-1.85,8.49,8.49,0,0,1,.52-1.73,6.87,6.87,0,0,1,.83-1.43,4,4,0,0,1,1.09-1,1.78,1.78,0,0,1,1.09-.29,1.3,1.3,0,0,1,.83.43,2.38,2.38,0,0,1,.53,1,5.3,5.3,0,0,1,.19,1.5v.74a.87.87,0,0,1-.09.37.52.52,0,0,1-.2.25L132.87,69a1.46,1.46,0,0,0,.1.61.66.66,0,0,0,.27.33.6.6,0,0,0,.4.07,1.13,1.13,0,0,0,.46-.17,2.34,2.34,0,0,0,.56-.42,2.92,2.92,0,0,0,.35-.48,2.68,2.68,0,0,1,.2-.29.56.56,0,0,1,.2-.17l.86-.5a.18.18,0,0,1,.21,0,.36.36,0,0,1,.08.27,3,3,0,0,1-.17.69,5.63,5.63,0,0,1-.46,1,7.14,7.14,0,0,1-.77,1,4.4,4.4,0,0,1-1.06.86,1.86,1.86,0,0,1-1.09.3,1.19,1.19,0,0,1-.83-.43,2.73,2.73,0,0,1-.52-1.11A6.53,6.53,0,0,1,131.47,68.89Zm2.63-4a1.92,1.92,0,0,0-.53.45,2.92,2.92,0,0,0-.37.57,3.2,3.2,0,0,0-.23.63,3.72,3.72,0,0,0-.1.58l2.42-1.4a2.57,2.57,0,0,0-.08-.47.89.89,0,0,0-.19-.39.5.5,0,0,0-.36-.15A1.08,1.08,0,0,0,134.1,64.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.3,68.21a1,1,0,0,1-.08.37.51.51,0,0,1-.21.24l-.81.48a.15.15,0,0,1-.2,0,.33.33,0,0,1-.09-.26V58.18a.8.8,0,0,1,.09-.36.52.52,0,0,1,.2-.25l.81-.47a.16.16,0,0,1,.21,0,.41.41,0,0,1,.08.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.83,114.64,100,98.38c1.2-.69,2.16-.2,2.16,1.09a4.65,4.65,0,0,1-2.16,3.6L71.87,119.35c-1.2.69-2.17.19-2.18-1.11A4.6,4.6,0,0,1,71.83,114.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,93.53l11.92-6.88c1.2-.69,2.16-.2,2.16,1.1a4.62,4.62,0,0,1-2.16,3.59l-11.89,6.9c-1.19.69-2.17.2-2.18-1.1A4.63,4.63,0,0,1,108.39,93.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.89,124.18l.47,1a.11.11,0,0,0,.15.06l1-.4c.16-.06.23.17.11.39l-.76,1.43a.46.46,0,0,0-.06.27l.18,1.29c0,.2-.14.47-.29.45l-.94-.12a.27.27,0,0,0-.19.11l-.93,1.2c-.15.19-.32.12-.3-.12l.18-1.49a.21.21,0,0,0-.06-.2l-.75-.55c-.12-.09-.06-.4.11-.53l1-.8a.52.52,0,0,0,.15-.24l.47-1.53C71.6,124.14,71.82,124,71.89,124.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.51,120.39l.47,1a.12.12,0,0,0,.15.06l1.05-.4c.17-.07.23.17.11.39l-.76,1.42a.48.48,0,0,0,0,.28l.17,1.28c0,.21-.14.48-.29.46l-.94-.12a.28.28,0,0,0-.18.11l-.94,1.2c-.15.19-.32.12-.29-.12l.17-1.49a.2.2,0,0,0-.05-.2l-.76-.55c-.12-.09-.05-.4.11-.53l1-.8a.58.58,0,0,0,.15-.24l.47-1.53C78.22,120.35,78.44,120.23,78.51,120.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13,116.59l.47,1a.12.12,0,0,0,.15.06l1-.4c.17-.07.23.17.11.39l-.75,1.42a.49.49,0,0,0-.06.28l.18,1.28c0,.21-.15.48-.3.46l-.93-.12c-.06,0-.13,0-.19.11l-.94,1.2c-.15.19-.32.12-.29-.12l.18-1.49a.23.23,0,0,0-.06-.21l-.76-.54c-.12-.09,0-.4.11-.53l1.05-.81a.42.42,0,0,0,.15-.23l.47-1.54C84.84,116.56,85.06,116.44,85.13,116.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,112.8l.46,1a.13.13,0,0,0,.16.06l1-.4c.17-.07.23.17.11.39l-.75,1.42a.48.48,0,0,0-.06.28l.18,1.28c0,.21-.15.47-.3.46l-.93-.12a.22.22,0,0,0-.19.11l-.94,1.2c-.15.19-.32.12-.29-.12l.18-1.49a.22.22,0,0,0-.06-.21l-.76-.54c-.12-.09,0-.4.11-.53l1-.81a.46.46,0,0,0,.15-.23l.47-1.54C91.47,112.77,91.68,112.65,91.76,112.8Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.68,158.63a.47.47,0,0,1-.25-.07.49.49,0,0,1-.25-.43V134.68a.5.5,0,0,1,.25-.43l52.71-30.44a.55.55,0,0,1,.5,0,.5.5,0,0,1,.25.44v23.4a.5.5,0,0,1-.25.43L69.93,158.56A.43.43,0,0,1,69.68,158.63Zm.5-23.66v22.29l51.71-29.9V105.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,134.77a0,0,0,0,1,.05,0,.14.14,0,0,1,0,.06v.26a.31.31,0,0,1,0,.08.12.12,0,0,1-.05.05l-1,.59h0s0,0,0-.06v-2.32a.13.13,0,0,1,0-.08.1.1,0,0,1,0,0l1-.58h0a.08.08,0,0,1,0,.06V133a.19.19,0,0,1,0,.08.1.1,0,0,1,0,.06l-.75.43v.57l.7-.4a0,0,0,0,1,0,0,.08.08,0,0,1,0,.06v.25a.19.19,0,0,1,0,.08.1.1,0,0,1,0,.06l-.7.4v.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.23,134.14l-.27.68s0,.07,0,.08l0,0-.18.1h-.05s0,0,0-.06v-.06l.42-1-.4-.54a.1.1,0,0,1,0,0,.19.19,0,0,1,0-.08.11.11,0,0,1,0,0l.18-.11.06,0,0,0,.26.35.26-.65a.36.36,0,0,1,0-.09l0,0,.18-.1a0,0,0,0,1,0,0s0,0,0,.06a.13.13,0,0,1,0,.06l-.4,1,.41.55s0,0,0,0a.19.19,0,0,1,0,.08s0,.05,0,.06l-.18.1,0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.28,133.07a.53.53,0,0,0,0,.13.41.41,0,0,0,0,.12.4.4,0,0,0,0,.17l.06.09a.1.1,0,0,0,.09,0l.1,0a.31.31,0,0,0,.09-.07.27.27,0,0,0,.07-.08l0-.09,0-.1,0-.08a.15.15,0,0,1,0-.06l.18-.1a0,0,0,0,1,0,0s0,0,0,.06a.88.88,0,0,1,0,.2,1.48,1.48,0,0,1-.1.27,2.11,2.11,0,0,1-.18.27,1,1,0,0,1-.25.21.49.49,0,0,1-.24.07.3.3,0,0,1-.17-.08.37.37,0,0,1-.12-.19,1.15,1.15,0,0,1-.06-.28v-.29c0-.12,0-.23,0-.35a2.53,2.53,0,0,1,.12-.33,1.12,1.12,0,0,1,.18-.28.79.79,0,0,1,.24-.21.56.56,0,0,1,.25-.08.36.36,0,0,1,.18.07.4.4,0,0,1,.1.15.5.5,0,0,1,0,.16.22.22,0,0,1,0,.08l0,.05-.18.11s0,0,0,0l0,0,0-.06s0,0,0,0h-.07a.28.28,0,0,0-.09.05.23.23,0,0,0-.1.07l-.09.13a1.38,1.38,0,0,0-.06.16A.66.66,0,0,0,91.28,133.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.32,132.59a1.87,1.87,0,0,1,0-.4,1.45,1.45,0,0,1,.11-.37,1.33,1.33,0,0,1,.18-.31.79.79,0,0,1,.24-.21.32.32,0,0,1,.23-.07.27.27,0,0,1,.18.1.51.51,0,0,1,.12.22,1.11,1.11,0,0,1,0,.33V132a.31.31,0,0,1,0,.08.1.1,0,0,1,0,0l-.78.45a.39.39,0,0,0,0,.13.14.14,0,0,0,.06.07.13.13,0,0,0,.09,0l.1,0,.12-.09.08-.1a.43.43,0,0,1,0-.07l0,0,.19-.11s0,0,0,0,0,0,0,.06a.64.64,0,0,1,0,.15,1.43,1.43,0,0,1-.11.21,1.6,1.6,0,0,1-.16.23,1,1,0,0,1-.23.18.41.41,0,0,1-.24.07.31.31,0,0,1-.18-.09.53.53,0,0,1-.11-.24A1.43,1.43,0,0,1,92.32,132.59Zm.57-.86a.38.38,0,0,0-.12.09.57.57,0,0,0-.08.13.58.58,0,0,0,0,.14.5.5,0,0,0,0,.12l.53-.3s0-.07,0-.1a.19.19,0,0,0,0-.09.11.11,0,0,0-.08,0S92.94,131.7,92.89,131.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,132.45a.24.24,0,0,1,0,.08l0,.05-.17.1h0a.08.08,0,0,1,0-.06v-2.35a.24.24,0,0,1,0-.08l0-.05L94,130s0,0,0,0a.08.08,0,0,1,0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.64,132.09a.13.13,0,0,1,0,.08.1.1,0,0,1,0,.05l-.18.1a0,0,0,0,1,0,0,.08.08,0,0,1,0-.06v-2.35a.24.24,0,0,1,0-.08s0,0,0-.06l.18-.1s0,0,0,0,0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,131.1a2.71,2.71,0,0,1,0-.4,2.4,2.4,0,0,1,.12-.38,1.92,1.92,0,0,1,.18-.31.79.79,0,0,1,.24-.21.35.35,0,0,1,.23-.06.31.31,0,0,1,.18.09.62.62,0,0,1,.12.23,1.47,1.47,0,0,1,0,.32v.16a.19.19,0,0,1,0,.08.15.15,0,0,1,0,.06l-.78.45a.25.25,0,0,0,0,.13.11.11,0,0,0,.06.07.11.11,0,0,0,.08,0l.11,0,.12-.09.07-.11s0-.05,0-.06l0,0,.19-.11h0a.08.08,0,0,1,0,.06.85.85,0,0,1,0,.15,1,1,0,0,1-.1.21,1.09,1.09,0,0,1-.17.22.79.79,0,0,1-.22.19.49.49,0,0,1-.24.07.27.27,0,0,1-.18-.1.67.67,0,0,1-.12-.24A1.9,1.9,0,0,1,94.9,131.1Zm.58-.87a.4.4,0,0,0-.12.1.57.57,0,0,0-.08.13.63.63,0,0,0-.07.26l.52-.31s0-.06,0-.1a.22.22,0,0,0,0-.08.1.1,0,0,0-.07,0A.21.21,0,0,0,95.48,130.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,130.47a.24.24,0,0,1,0,.08.15.15,0,0,1,0,.06l-.18.1h0a.07.07,0,0,1,0-.06v-.92a.47.47,0,0,0-.07-.3c0-.06-.11-.07-.2,0a.5.5,0,0,0-.19.25.92.92,0,0,0-.07.38V131a.19.19,0,0,1,0,.08s0,.05,0,.06l-.17.1h-.05a.11.11,0,0,1,0-.06v-1.67a.19.19,0,0,1,0-.08.1.1,0,0,1,.05-.06l.17-.1h0a.14.14,0,0,1,0,.06v.08a1.09,1.09,0,0,1,.14-.23.61.61,0,0,1,.19-.17.37.37,0,0,1,.24-.07.24.24,0,0,1,.15.09.56.56,0,0,1,.09.22,2.85,2.85,0,0,1,0,.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15,129.49a.28.28,0,0,0,0,.15s.08,0,.15,0l.14-.09s0,0,0,0,0,0,0,0v.24a.12.12,0,0,1,0,.08.09.09,0,0,1,0,.06l-.17.09c-.15.09-.26.1-.34,0a.58.58,0,0,1-.12-.44v-.77l-.15.09h0s0,0,0-.06v-.24a.13.13,0,0,1,0-.08.1.1,0,0,1,0-.05l.15-.09v-.58a.19.19,0,0,1,0-.08.1.1,0,0,1,0-.06l.17-.1a0,0,0,0,1,0,0,.11.11,0,0,1,0,.06v.59l.3-.18a0,0,0,0,1,0,0,.08.08,0,0,1,0,.05v.24a.24.24,0,0,1,0,.08l0,.05-.3.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,129.15a0,0,0,0,1,0,0,.08.08,0,0,1,0,.06v.32a.31.31,0,0,1,0,.08l0,0-.2.12a0,0,0,0,1,0,0,.08.08,0,0,1,0-.05v-.32a.24.24,0,0,1,0-.08.08.08,0,0,1,0,0Zm0-.34a.31.31,0,0,1,0,.08.12.12,0,0,1,0,.05l-.17.1a0,0,0,0,1,0,0,.08.08,0,0,1,0-.06v-1.59a.24.24,0,0,1,0-.08.12.12,0,0,1,0,0l.17-.11a0,0,0,0,1,0,0,.08.08,0,0,1,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65,128.79h0a.08.08,0,0,1,0,.06v.31a.19.19,0,0,1,0,.08.15.15,0,0,1,0,.06l-.21.11h0a.08.08,0,0,1,0-.06V129a.19.19,0,0,1,0-.08.15.15,0,0,1,0-.06Zm0-.35a.19.19,0,0,1,0,.08s0,0-.05.06l-.17.1h0a.08.08,0,0,1,0-.06V127a.24.24,0,0,1,0-.08.1.1,0,0,1,0-.06l.17-.1a0,0,0,0,1,.05,0,.14.14,0,0,1,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.27,128.42s0,0,0,0a.08.08,0,0,1,0,0v.32a.24.24,0,0,1,0,.08.12.12,0,0,1,0,.05l-.2.12h0a.14.14,0,0,1,0-.06v-.32a.31.31,0,0,1,0-.08l0-.05Zm.06-.34a.24.24,0,0,1,0,.08s0,.05,0,.06l-.17.1s0,0,0,0a.08.08,0,0,1,0-.05v-1.6a.31.31,0,0,1,0-.08.12.12,0,0,1,0,0l.17-.1a0,0,0,0,1,0,0,.08.08,0,0,1,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.9 136.94 73.9 151.01 86.08 143.97 86.08 129.9 73.9 136.94",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.9 136.94 73.9 151.01 86.08 143.97 86.08 129.9 73.9 136.94",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.74,143.45v0a2.42,2.42,0,0,0-1.27-1.85,2.32,2.32,0,0,0-2.12.24l-2.95,1.7a7.51,7.51,0,0,0-3.12,5.09l-.15,1.7.57-.33.11-1.3A7,7,0,0,1,78.67,144l3-1.7a2.12,2.12,0,0,1,1.08-.34,1.26,1.26,0,0,1,.55.12,1.92,1.92,0,0,1,1,1.45l.14,1.46.51-.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.18,142.06a1.48,1.48,0,0,1-.74-.19,2.38,2.38,0,0,1-1-2.17A6.07,6.07,0,0,1,80,134.89a1.82,1.82,0,0,1,1.83-.13,2.39,2.39,0,0,1,1,2.17,6,6,0,0,1-2.53,4.81A2.23,2.23,0,0,1,79.18,142.06Zm1.91-7a1.64,1.64,0,0,0-.82.25A5.49,5.49,0,0,0,78,139.7a1.94,1.94,0,0,0,.7,1.73A1.31,1.31,0,0,0,80,141.3a5.47,5.47,0,0,0,2.28-4.37,1.88,1.88,0,0,0-.71-1.72A.9.9,0,0,0,81.09,135.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.12,129.91c0,.66.48.91,1.08.57l10.12-5.85a2.18,2.18,0,0,0,1-1.78c0-.64-.53-.88-1.13-.53l-10,5.78A2.34,2.34,0,0,0,88.12,129.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.32 120.53 103.34 119.94 103.34 122.31 102.32 122.9 102.32 120.53",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.34 119.94 104.37 119.35 104.37 121.72 103.34 122.31 103.34 119.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.36 119.35 105.39 118.75 105.39 121.13 104.36 121.72 104.36 119.35",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.36 119.35 105.39 118.75 105.39 121.13 104.36 121.72 104.36 119.35",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.12,138.48a.38.38,0,0,1-.33-.18.39.39,0,0,1,.14-.52l30.61-17.67a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51L88.3,138.43A.31.31,0,0,1,88.12,138.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.12,141a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l30.61-17.68a.38.38,0,0,1,.51.14.39.39,0,0,1-.14.52L88.3,140.9A.41.41,0,0,1,88.12,141Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.12,143.41a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51L118.54,125a.37.37,0,0,1,.37.65L88.3,143.36A.41.41,0,0,1,88.12,143.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.83,124.48a.47.47,0,0,1-.25-.07.5.5,0,0,1-.25-.43V100.53a.5.5,0,0,1,.25-.43l52.71-30.44a.5.5,0,0,1,.75.44V93.49a.5.5,0,0,1-.25.44l-52.71,30.48A.43.43,0,0,1,128.83,124.48Zm.5-23.66v22.29L181,93.21V71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51,101.66s0,0,0,0,0,0,0-.06V99.28a.13.13,0,0,1,0-.08.1.1,0,0,1,0,0l.69-.4a.38.38,0,0,1,.25-.07.25.25,0,0,1,.16.08.51.51,0,0,1,.09.18,1.64,1.64,0,0,1,0,.22.65.65,0,0,1,0,.2.85.85,0,0,1,0,.17l-.06.13a.29.29,0,0,1,0,.08.32.32,0,0,1,.13.13.57.57,0,0,1,.06.32,1.5,1.5,0,0,1,0,.29,1.71,1.71,0,0,1-.09.3,2.26,2.26,0,0,1-.16.26.66.66,0,0,1-.22.19Zm.9-2.3a.22.22,0,0,0-.06-.18s-.09,0-.18,0l-.41.24V100l.41-.24a.5.5,0,0,0,.18-.17A.48.48,0,0,0,148.41,99.36Zm-.65,1.71.43-.25a.44.44,0,0,0,.19-.19.58.58,0,0,0,.06-.26.25.25,0,0,0-.06-.19s-.11,0-.19,0l-.43.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,99.89a2.6,2.6,0,0,1,0-.4,2.11,2.11,0,0,1,.12-.38,1.57,1.57,0,0,1,.18-.31.79.79,0,0,1,.24-.21.35.35,0,0,1,.23-.06.31.31,0,0,1,.18.09.57.57,0,0,1,.12.22,1.15,1.15,0,0,1,0,.33v.16a.24.24,0,0,1,0,.08s0,0,0,.06l-.78.44a.52.52,0,0,0,0,.14.13.13,0,0,0,.06.07.13.13,0,0,0,.09,0l.1,0a.4.4,0,0,0,.12-.1.36.36,0,0,0,.07-.1l.05-.06a.08.08,0,0,1,0,0l.19-.11h0a.07.07,0,0,1,0,.06.34.34,0,0,1,0,.15.84.84,0,0,1-.1.22,1.53,1.53,0,0,1-.16.22,1,1,0,0,1-.23.19.49.49,0,0,1-.24.07.27.27,0,0,1-.18-.1.67.67,0,0,1-.12-.24A2,2,0,0,1,149,99.89Zm.57-.87a.4.4,0,0,0-.12.1l-.08.12a.78.78,0,0,0-.05.14.69.69,0,0,0,0,.13l.53-.31s0-.07,0-.1a.29.29,0,0,0,0-.08.09.09,0,0,0-.08,0A.24.24,0,0,0,149.54,99Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.36,98.61a.77.77,0,0,1,0-.19,1.28,1.28,0,0,1,.09-.22,1.37,1.37,0,0,1,.15-.21,1.2,1.2,0,0,1,.21-.17.51.51,0,0,1,.22-.07.18.18,0,0,1,.16,0,.32.32,0,0,1,.11.17,1.26,1.26,0,0,1,0,.3v1.06a.25.25,0,0,1,0,.08s0,0-.05,0l-.17.1h-.05a.08.08,0,0,1,0-.06v-.12a.94.94,0,0,1-.14.26.66.66,0,0,1-.23.21.38.38,0,0,1-.18.06.17.17,0,0,1-.14,0,.28.28,0,0,1-.08-.12.66.66,0,0,1,0-.21.9.9,0,0,1,.12-.46,1.13,1.13,0,0,1,.3-.36l.38-.32c0-.1,0-.16-.06-.17a.17.17,0,0,0-.16,0,.22.22,0,0,0-.09.07l-.06.11a.61.61,0,0,0,0,.06l0,0-.22.13a0,0,0,0,1,0,0S150.36,98.63,150.36,98.61Zm.39.79a.55.55,0,0,0,.14-.12.72.72,0,0,0,.11-.15.58.58,0,0,0,.06-.17.88.88,0,0,0,0-.16v0l-.32.27a.44.44,0,0,0-.13.15.3.3,0,0,0,0,.16.07.07,0,0,0,.06.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.68,97.48a.31.31,0,0,1,0-.08.12.12,0,0,1,.05-.05l.17-.1a0,0,0,0,1,.05,0,.08.08,0,0,1,0,.06v.91a.6.6,0,0,0,.06.31c0,.06.1.07.19,0a.47.47,0,0,0,.19-.24,1.12,1.12,0,0,0,.06-.38V97a.19.19,0,0,1,0-.08.1.1,0,0,1,.05-.06l.17-.1a0,0,0,0,1,.05,0,.08.08,0,0,1,0,.06v1.67a.24.24,0,0,1,0,.08.1.1,0,0,1-.05.06l-.17.1a0,0,0,0,1-.05,0,.14.14,0,0,1,0-.06V98.6a1,1,0,0,1-.13.23.65.65,0,0,1-.19.18.53.53,0,0,1-.23.07.24.24,0,0,1-.15-.1.48.48,0,0,1-.08-.22,1.55,1.55,0,0,1,0-.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,97.51a.22.22,0,0,0,0,.16s.07,0,.14,0l.14-.08h.05a.11.11,0,0,1,0,.06v.24a.25.25,0,0,1,0,.08s0,0-.05,0l-.17.1c-.15.09-.26.09-.34,0s-.12-.21-.12-.43v-.77l-.15.09s0,0,0,0,0,0,0-.05v-.24a.12.12,0,0,1,0-.08.07.07,0,0,1,0,0l.15-.09v-.59a.31.31,0,0,1,0-.08.12.12,0,0,1,0,0l.17-.1a0,0,0,0,1,0,0,.08.08,0,0,1,0,.06v.58l.3-.17a0,0,0,0,1,0,0,.08.08,0,0,1,0,.06v.24a.19.19,0,0,1,0,.07.15.15,0,0,1,0,.06l-.3.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,95.14a0,0,0,0,1,.05,0,.08.08,0,0,1,0,.06v.28a.24.24,0,0,1,0,.08.08.08,0,0,1-.05,0l-.2.12h0a.14.14,0,0,1,0-.06v-.28a.24.24,0,0,1,0-.08.11.11,0,0,1,0,0Zm.05,2.42a.22.22,0,0,1,0,.08s0,0-.05,0l-.17.11s0,0-.05,0a.08.08,0,0,1,0-.05V96.06a.31.31,0,0,1,0-.08.12.12,0,0,1,.05,0l.17-.1a0,0,0,0,1,.05,0s0,0,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.18,95.37l.32-.19s0,0,.05,0a.07.07,0,0,1,0,0v.24a.22.22,0,0,1,0,.08.12.12,0,0,1-.05,0l-.32.19v1.34a.24.24,0,0,1,0,.08.12.12,0,0,1,0,0l-.17.1h-.05a.08.08,0,0,1,0-.06V96l-.15.08h0s0,0,0-.06v-.23a.11.11,0,0,1,0-.08.09.09,0,0,1,0-.06l.15-.09v-.16a1,1,0,0,1,0-.31,1.06,1.06,0,0,1,.09-.25.9.9,0,0,1,.15-.19.94.94,0,0,1,.19-.14l.18-.11h0a.11.11,0,0,1,0,.06v.24a.31.31,0,0,1,0,.08.12.12,0,0,1,0,0l-.16.1a.33.33,0,0,0-.14.12.41.41,0,0,0,0,.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.75,95.14a.19.19,0,0,1,0-.08.15.15,0,0,1,0-.06l.18-.1s0,0,0,0,0,0,0,.06v.91a.58.58,0,0,0,.06.31c0,.07.11.07.2,0a.52.52,0,0,0,.19-.24,1.12,1.12,0,0,0,.06-.38v-.91a.19.19,0,0,1,0-.08.15.15,0,0,1,0-.06l.18-.1a0,0,0,0,1,0,0,.13.13,0,0,1,0,.06v1.67a.19.19,0,0,1,0,.08s0,.05,0,.06l-.18.1h0a.11.11,0,0,1,0-.06v-.08a2.53,2.53,0,0,1-.13.22.54.54,0,0,1-.19.18.45.45,0,0,1-.24.07.22.22,0,0,1-.15-.1.93.93,0,0,1-.08-.22,2.85,2.85,0,0,1,0-.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.49,95.8a.19.19,0,0,1,0,.08.15.15,0,0,1,0,.06l-.18.1h-.05a.11.11,0,0,1,0-.06V93.62a.17.17,0,0,1,0-.07s0,0,.05-.06l.18-.1a0,0,0,0,1,0,0,.08.08,0,0,1,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.61,94l.52.24a.1.1,0,0,1,.05,0,.08.08,0,0,1,0,.07v.31a.14.14,0,0,1,0,.06,0,0,0,0,1,0,0h0l-.81-.38,0,0a.15.15,0,0,1,0-.08v-.15a.3.3,0,0,1,0-.1.41.41,0,0,1,0-.09l.81-1.32,0,0h0a.05.05,0,0,1,0,0V93a.26.26,0,0,1,0,.11.41.41,0,0,1-.05.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59,91.6h0s0,0,0,.06v.25a.15.15,0,0,1,0,.09l0,.08-.34.75a.46.46,0,0,1,.19,0,.26.26,0,0,1,.15.07.35.35,0,0,1,.09.16,1,1,0,0,1,0,.26,1,1,0,0,1-.05.36,1.2,1.2,0,0,1-.13.33,1.35,1.35,0,0,1-.2.27,1.57,1.57,0,0,1-.25.2.79.79,0,0,1-.28.1.31.31,0,0,1-.2,0,.24.24,0,0,1-.12-.14.46.46,0,0,1-.05-.2.11.11,0,0,1,0-.08s0,0,.05-.06l.18-.1s0,0,0,0a.11.11,0,0,1,0,0,.1.1,0,0,0,0,0l.06,0h.1l.14-.06a.69.69,0,0,0,.23-.22.58.58,0,0,0,.09-.3c0-.11,0-.17-.09-.19a.35.35,0,0,0-.23.07l-.19.11a0,0,0,0,1-.05,0,.11.11,0,0,1,0-.06v-.26a.31.31,0,0,1,0-.08.2.2,0,0,1,0-.08l.32-.71-.64.37s0,0,0,0a.08.08,0,0,1,0,0v-.26a.31.31,0,0,1,0-.08l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.05 102.79 133.05 116.86 145.24 109.82 145.24 95.75 133.05 102.79",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.05 102.79 133.05 116.86 145.24 109.82 145.24 95.75 133.05 102.79",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.89,109.3v0a2.42,2.42,0,0,0-1.27-1.85,2.29,2.29,0,0,0-2.12.24l-2.95,1.7a7.49,7.49,0,0,0-3.12,5.09l-.15,1.7.57-.33.11-1.3a7,7,0,0,1,2.86-4.69l3-1.7a2.12,2.12,0,0,1,1.08-.34,1.26,1.26,0,0,1,.55.12,1.92,1.92,0,0,1,1,1.45l.14,1.46.51-.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.33,107.91a1.48,1.48,0,0,1-.74-.19,2.38,2.38,0,0,1-1-2.17,6.07,6.07,0,0,1,2.53-4.81,1.82,1.82,0,0,1,1.83-.13,2.39,2.39,0,0,1,1,2.17,6.06,6.06,0,0,1-2.53,4.81A2.23,2.23,0,0,1,138.33,107.91Zm1.91-7a1.64,1.64,0,0,0-.82.25,5.49,5.49,0,0,0-2.28,4.37,1.94,1.94,0,0,0,.7,1.73,1.31,1.31,0,0,0,1.32-.13,5.49,5.49,0,0,0,2.28-4.37,1.92,1.92,0,0,0-.71-1.73A1,1,0,0,0,140.24,100.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,95.76c0,.66.48.91,1.08.57l10.12-5.85a2.18,2.18,0,0,0,1-1.78c0-.64-.53-.88-1.13-.53l-10,5.78A2.34,2.34,0,0,0,147.27,95.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.47 86.38 162.49 85.79 162.49 88.16 161.47 88.75 161.47 86.38",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.49 85.79 163.52 85.2 163.52 87.57 162.49 88.16 162.49 85.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.51 85.2 164.54 84.61 164.54 86.97 163.51 87.57 163.51 85.2",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.51 85.2 164.54 84.61 164.54 86.97 163.51 87.57 163.51 85.2",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,104.33a.38.38,0,0,1-.33-.18.39.39,0,0,1,.14-.52L177.69,86a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51l-30.61,17.67A.29.29,0,0,1,147.27,104.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,106.8a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l30.61-17.68a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51l-30.61,17.68A.37.37,0,0,1,147.27,106.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,109.26a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l30.61-17.67a.37.37,0,1,1,.37.65l-30.61,17.67A.37.37,0,0,1,147.27,109.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.54,44.15V32.57l-10,5.79a4.8,4.8,0,0,0-2.16,3.75V53.68l10-5.78A4.81,4.81,0,0,0,181.54,44.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,47.19a3.22,3.22,0,0,1,.13-.93,3.4,3.4,0,0,1,.38-.85,1.28,1.28,0,0,1-.36-1,3.34,3.34,0,0,1,.11-.84,4.21,4.21,0,0,1,.32-.79,2.81,2.81,0,0,1,.48-.65,2.27,2.27,0,0,1,.6-.48,1.42,1.42,0,0,1,.6-.22.73.73,0,0,1,.47.11.88.88,0,0,1,.32.42,1.86,1.86,0,0,1,.11.71,3.22,3.22,0,0,1-.09.76,3.7,3.7,0,0,1-.26.7.81.81,0,0,1,.37.42,1.92,1.92,0,0,1,.13.78,3.87,3.87,0,0,1-.11.89A3.46,3.46,0,0,1,174,47a3,3,0,0,1-.52.71,3,3,0,0,1-.68.55,1.78,1.78,0,0,1-.69.24.75.75,0,0,1-.52-.11.86.86,0,0,1-.33-.44A2,2,0,0,1,171.18,47.19Zm.81-.47a.74.74,0,0,0,.07.33.33.33,0,0,0,.19.16.49.49,0,0,0,.27,0,1.2,1.2,0,0,0,.32-.13,1.62,1.62,0,0,0,.31-.24,2,2,0,0,0,.27-.31,1.69,1.69,0,0,0,.19-.38,1.2,1.2,0,0,0,.07-.42.56.56,0,0,0-.07-.32.37.37,0,0,0-.19-.16.49.49,0,0,0-.27,0,1,1,0,0,0-.31.12,1.41,1.41,0,0,0-.32.24,2.08,2.08,0,0,0-.27.32,1.62,1.62,0,0,0-.19.37A1.41,1.41,0,0,0,172,46.72Zm.15-2.83a.6.6,0,0,0,.06.29.29.29,0,0,0,.15.14.36.36,0,0,0,.23,0,.86.86,0,0,0,.26-.1,1.51,1.51,0,0,0,.26-.2,2,2,0,0,0,.22-.27,1.2,1.2,0,0,0,.16-.32,1.34,1.34,0,0,0,.05-.35.72.72,0,0,0-.05-.29.33.33,0,0,0-.16-.15.41.41,0,0,0-.22,0,.7.7,0,0,0-.26.1,1,1,0,0,0-.26.2,1.16,1.16,0,0,0-.23.26,1.87,1.87,0,0,0-.15.32A1.13,1.13,0,0,0,172.14,43.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85,45a.08.08,0,0,1,.11,0,.21.21,0,0,1,0,.15v.9a.46.46,0,0,1,0,.2.27.27,0,0,1-.11.14l-.56.33a.09.09,0,0,1-.11,0,.17.17,0,0,1-.05-.15v-.9a.41.41,0,0,1,.05-.21.33.33,0,0,1,.11-.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,39.56a.51.51,0,0,1,0-.2.43.43,0,0,1,.12-.14l2.26-1.3a.08.08,0,0,1,.11,0,.2.2,0,0,1,.05.14v.66a.46.46,0,0,1-.05.2.27.27,0,0,1-.11.14l-1.69,1-.07,1.22a2.28,2.28,0,0,1,.32-.31l.26-.17a1.64,1.64,0,0,1,.63-.22.71.71,0,0,1,.5.12,1.08,1.08,0,0,1,.33.48,2.51,2.51,0,0,1,.12.85,4.1,4.1,0,0,1-.13,1.08,3.74,3.74,0,0,1-.33.89,2.92,2.92,0,0,1-.5.68,2.73,2.73,0,0,1-.62.48,1.81,1.81,0,0,1-.71.27.78.78,0,0,1-.49-.12.83.83,0,0,1-.29-.41,2,2,0,0,1-.11-.63.34.34,0,0,1,0-.2c0-.07.07-.12.12-.14l.49-.28a.08.08,0,0,1,.1,0,.18.18,0,0,1,.07.12.56.56,0,0,0,.11.28.32.32,0,0,0,.18.11.47.47,0,0,0,.23,0,1.51,1.51,0,0,0,.26-.12,1.45,1.45,0,0,0,.56-.61,1.93,1.93,0,0,0,.21-.9.69.69,0,0,0-.21-.58.51.51,0,0,0-.56,0,1.35,1.35,0,0,0-.28.2,1.4,1.4,0,0,0-.17.2c-.05.06-.08.12-.12.17a.87.87,0,0,1-.14.12l-.55.32a.09.09,0,0,1-.11,0,.17.17,0,0,1,0-.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.67,88.14a4.25,4.25,0,0,0-1.78,3.4c0,1.31.79,1.92,1.78,1.35a4.27,4.27,0,0,0,1.78-3.4C135.45,88.18,134.65,87.57,133.67,88.14Zm0,4.47c-.87.5-1.58,0-1.58-1.19a3.77,3.77,0,0,1,1.58-3c.86-.5,1.57,0,1.57,1.19A3.79,3.79,0,0,1,133.67,92.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77,85.46s-.08,0-.11.07a6,6,0,0,0-.77,3.31c0,.08.05.12.1.08l.62-.35V91.2c0,.08,0,.11.11.08a.23.23,0,0,0,.1-.2V85.55S136.8,85.47,136.77,85.46Zm-.67,3.12a6.79,6.79,0,0,1,.34-2.14,4.61,4.61,0,0,1,.17-.44v2.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56,88.45a.26.26,0,0,0-.1.2v1.74a.08.08,0,0,1,0,.07l-.25.15V88.82c0-.08,0-.12-.11-.08a.23.23,0,0,0-.1.2v1.79l-.26.15s0,0,0,0V89.11c0-.08,0-.12-.11-.08a.23.23,0,0,0-.1.2V91c0,.18.11.26.24.19L131,91v3.45c0,.08,0,.12.1.08a.24.24,0,0,0,.11-.2V90.89l.25-.15a.59.59,0,0,0,.25-.47V88.53C131.67,88.45,131.62,88.41,131.56,88.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87,67.47l-5.2,3V68.85a.57.57,0,0,1,.24-.45c.12-.07.22,0,.24.15l-.19.29a.18.18,0,0,0,0,.21s.05,0,.09,0a.14.14,0,0,0,.06-.07l.6-.93c.05-.08.06-.18,0-.22s-.1,0-.15.06l-.22.35a.27.27,0,0,0-.43-.14,1.08,1.08,0,0,0-.46.87v2.74c0,.61.38.9.84.63l0,0L168,73c-.05.08-.05.18,0,.21h.07a.24.24,0,0,0,.08-.09l.49-.94,3.15-1.82.49.38a.08.08,0,0,0,.08,0,.19.19,0,0,0,.07-.08c0-.09,0-.18,0-.21l-.33-.26,0,0a2,2,0,0,0,.84-1.6v-1C173,67.47,172.93,67.44,172.87,67.47Zm-.11,1.18a1.5,1.5,0,0,1-.62,1.19l-3.85,2.22c-.34.2-.62,0-.62-.47v-.83l5.09-2.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.18,69.34s.1,0,.14-.08,0-.16,0-.19-.19.05-.19.05S168.14,69.31,168.18,69.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.83,68.87s-.19,0-.19,0,0,.2.05.23.11,0,.14-.08S168.87,68.9,168.83,68.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,69.54s0,.2.05.23.11,0,.14-.09,0-.15,0-.18S168.64,69.54,168.64,69.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.32,68.92c0-.07,0-.16,0-.19s-.19,0-.19,0,0,.19.05.22S169.29,69,169.32,68.92Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.75,68.57s.1,0,.14-.08,0-.16,0-.19-.2,0-.2,0S168.71,68.54,168.75,68.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.93,76.82a.6.6,0,0,1,.48-.1.73.73,0,0,0,.59-.12,1.88,1.88,0,0,0,.59-.56,1.4,1.4,0,0,1,.48-.45.62.62,0,0,1,.49-.1.75.75,0,0,0,.59-.13,2,2,0,0,0,.59-.55,1.42,1.42,0,0,1,.48-.46.6.6,0,0,1,.48-.1.77.77,0,0,0,.59-.12,2,2,0,0,0,.59-.56,1.52,1.52,0,0,1,.48-.46.27.27,0,0,0,.11-.21c0-.09-.05-.12-.11-.09a1.88,1.88,0,0,0-.59.56,1.52,1.52,0,0,1-.48.46.75.75,0,0,1-.27.1h0V70.2a1,1,0,0,1,.4-.76.24.24,0,0,1,.37.09c0,.06.09.06.15,0a.26.26,0,0,0,.05-.23.37.37,0,0,0-.57-.15,1.5,1.5,0,0,0-.62,1.19v.94l-1.25.72v-.93a1,1,0,0,1,.4-.77.23.23,0,0,1,.36.1c0,.06.09,0,.15,0a.25.25,0,0,0,0-.23A.36.36,0,0,0,162,70a1.5,1.5,0,0,0-.63,1.2v3.75a1.09,1.09,0,0,1-.17.13.6.6,0,0,1-.49.09.79.79,0,0,0-.59.13,1.88,1.88,0,0,0-.59.56,1.4,1.4,0,0,1-.48.45.6.6,0,0,1-.48.1.77.77,0,0,0-.59.12.3.3,0,0,0-.11.22C157.82,76.82,157.87,76.86,157.93,76.82Zm4.87-5.25v1.08l-1.25.73V72.29Zm-1.25,2.11L162.8,73v1a.76.76,0,0,0-.58.13,1.78,1.78,0,0,0-.59.56l-.08.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,74.62a1.78,1.78,0,0,0-.59.56,1.4,1.4,0,0,1-.48.45.6.6,0,0,1-.48.1.74.74,0,0,0-.59.13,1.76,1.76,0,0,0-.59.55,1.52,1.52,0,0,1-.48.46.62.62,0,0,1-.49.1.77.77,0,0,0-.59.12,2,2,0,0,0-.59.56,1.52,1.52,0,0,1-.48.46.6.6,0,0,1-.48.1.73.73,0,0,0-.59.12.27.27,0,0,0-.11.21c0,.09.05.12.11.09a.6.6,0,0,1,.48-.1.77.77,0,0,0,.59-.12,1.88,1.88,0,0,0,.59-.56,1.52,1.52,0,0,1,.48-.46.62.62,0,0,1,.49-.1.73.73,0,0,0,.59-.12,2,2,0,0,0,.59-.56,1.52,1.52,0,0,1,.48-.46.58.58,0,0,1,.48-.09.79.79,0,0,0,.59-.13,1.78,1.78,0,0,0,.59-.56,1.4,1.4,0,0,1,.48-.45.3.3,0,0,0,.11-.22C164.47,74.62,164.42,74.58,164.36,74.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.14,79.82l-5.24,3a.24.24,0,0,0-.11.2v4.74c0,.08.05.11.11.08l1.95-1.12-.15.8-.32.19a.24.24,0,0,0-.11.2c0,.08,0,.11.11.08l.4-.23,1.48-.86h0l.4-.23a.24.24,0,0,0,.11-.2c0-.08-.05-.11-.11-.08l-.32.18-.15-.63,1.95-1.12a.26.26,0,0,0,.1-.2V79.9C146.24,79.82,146.2,79.79,146.14,79.82Zm-.11.34V84l-5,2.9v-3.8Zm-3.12,7.27.16-.81.9-.52.15.63Zm1.14-1.66-1.06.62-2,1.14v-.38l5-2.9v.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,62.1l-.74.42.5-.94c0-.07,0-.16,0-.19s-.11,0-.15.08L180,62.69l-.49.29a.91.91,0,0,0-.22-.57l.24-.46.66-.38a.26.26,0,0,0,.11-.2c0-.08-.05-.11-.11-.08l-.46.27.64-1.22c0-.07,0-.16,0-.19s-.11,0-.15.08l-.63,1.21v-.61c0-.07,0-.11-.11-.08a.3.3,0,0,0-.1.2v.89l-.24.45a.6.6,0,0,0-.52,0v-.66l.64-1.22c0-.08,0-.17,0-.2s-.11,0-.15.09l-.49.94v-1c0-.07,0-.11-.1-.08a.27.27,0,0,0-.11.2v1L177.9,61s-.11,0-.15.08a.18.18,0,0,0,0,.2l.64.48v.66a1.87,1.87,0,0,0-.52.59l-.24-.18V62c0-.07,0-.11-.1-.08a.27.27,0,0,0-.11.2v.61l-.63-.48s-.11,0-.15.09,0,.16,0,.19l.64.48-.46.27a.24.24,0,0,0-.11.2c0,.07,0,.11.11.08l.66-.39.24.18a2.44,2.44,0,0,0-.22.82l-.49.29-.64-.48s-.11,0-.15.08,0,.17,0,.2l.5.37L176,65a.27.27,0,0,0-.11.2c0,.08,0,.11.11.08l.74-.42-.5.93c0,.08,0,.17,0,.2s.05,0,.08,0l.07-.08.64-1.22.49-.29a.91.91,0,0,0,.22.57l-.24.46-.66.38a.26.26,0,0,0-.11.2c0,.08,0,.11.11.08l.46-.27L176.64,67c0,.07,0,.16,0,.19s.05,0,.07,0a.2.2,0,0,0,.08-.08l.63-1.21v.61c0,.07.05.11.11.07a.26.26,0,0,0,.1-.19v-.89l.24-.46a.56.56,0,0,0,.52,0v.66L177.75,67c0,.08,0,.17,0,.2s.11,0,.15-.09l.49-.94v1c0,.07.05.11.11.07a.26.26,0,0,0,.1-.19V66l.49.37a0,0,0,0,0,.07,0,.15.15,0,0,0,.08-.08c0-.08,0-.17,0-.2l-.64-.48V65a1.87,1.87,0,0,0,.52-.59l.24.18v.89c0,.07,0,.11.1.08a.27.27,0,0,0,.11-.2V64.7l.63.48a.08.08,0,0,0,.08,0,.19.19,0,0,0,.07-.08c0-.08,0-.16,0-.19l-.64-.48.46-.27a.24.24,0,0,0,.11-.2c0-.07-.05-.11-.11-.08l-.66.39-.24-.18a2.44,2.44,0,0,0,.22-.82L180,63l.64.48a0,0,0,0,0,.07,0,.15.15,0,0,0,.08-.08c0-.08,0-.17,0-.2l-.5-.37.74-.43a.24.24,0,0,0,.11-.19C181.12,62.1,181.07,62.06,181,62.1Zm-2.51,2.64c-.44.25-.79,0-.79-.59a1.87,1.87,0,0,1,.79-1.51c.43-.26.79,0,.79.59A1.91,1.91,0,0,1,178.5,64.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,82.5c-.31.18-.56,0-.56-.43A1.34,1.34,0,0,1,152,81c.31-.18.56,0,.56.43A1.34,1.34,0,0,1,152,82.5Zm0-1.22a.84.84,0,0,0-.35.67c0,.26.16.38.35.27a.83.83,0,0,0,.36-.67C152.34,81.29,152.18,81.17,152,81.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,80.71s-.05,0-.07,0-.05-.1,0-.19a6.93,6.93,0,0,1,2.6-3.18,2,2,0,0,1,2.6.18.17.17,0,0,1,0,.2c0,.08-.11.11-.14.07a1.83,1.83,0,0,0-2.44-.18,6.47,6.47,0,0,0-2.43,3A.21.21,0,0,1,149.47,80.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.46,81.42h-.06s-.06-.1,0-.18a4.15,4.15,0,0,1,1.6-2.08,1.14,1.14,0,0,1,1.61.21.21.21,0,0,1,0,.21c-.05.07-.11.09-.15,0a1,1,0,0,0-1.43-.19,3.72,3.72,0,0,0-1.43,1.86A.2.2,0,0,1,150.46,81.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,78.73s-.07,0-.09,0a1.43,1.43,0,0,0-1.94-.18A5.07,5.07,0,0,0,150.05,81c0,.08-.1.13-.15.11s-.06-.1,0-.18a5.58,5.58,0,0,1,2.1-2.63,1.55,1.55,0,0,1,2.11.2.23.23,0,0,1,0,.21S154,78.72,154,78.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,81.78h-.05s-.07-.08,0-.16a2.77,2.77,0,0,1,1.1-1.54.72.72,0,0,1,1.11.26.21.21,0,0,1,0,.21c-.05.07-.12.08-.14,0a.61.61,0,0,0-.93-.22,2.33,2.33,0,0,0-.92,1.29A.22.22,0,0,1,151,81.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.46,100.54,154.19,115.7a2.4,2.4,0,0,0-1.08,1.88v6.88c0,.69.48,1,1.08.63l26.27-15.17a2.4,2.4,0,0,0,1.08-1.88v-6.88C181.54,100.47,181.06,100.19,180.46,100.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.25,122.07a.06.06,0,0,1-.08,0,.12.12,0,0,1,0-.1v-4.3a.23.23,0,0,1,0-.14.17.17,0,0,1,.08-.1l1.39-.81a.88.88,0,0,1,.49-.15.42.42,0,0,1,.31.13.72.72,0,0,1,.17.35,1.7,1.7,0,0,1,.06.46,1.83,1.83,0,0,1,0,.35,1.77,1.77,0,0,1-.07.29,1,1,0,0,1-.08.21l-.07.14a.43.43,0,0,1,.24.28,1.78,1.78,0,0,1,.07.53,3.75,3.75,0,0,1,0,.56,2.81,2.81,0,0,1-.18.56,2.29,2.29,0,0,1-.3.5,1.61,1.61,0,0,1-.47.39Zm1.61-4.18a.33.33,0,0,0-.06-.23c-.05,0-.11,0-.2,0l-.67.38v.76l.67-.39a.51.51,0,0,0,.2-.21A.83.83,0,0,0,156.86,117.89Zm-.93,2.75.71-.41a.52.52,0,0,0,.21-.23.81.81,0,0,0,.08-.34.33.33,0,0,0-.08-.24s-.12,0-.21,0l-.71.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21,117.44a4,4,0,0,1,.11-.76,3.51,3.51,0,0,1,.26-.73,3.75,3.75,0,0,1,.42-.62,2.09,2.09,0,0,1,.56-.47,1.17,1.17,0,0,1,.56-.18.66.66,0,0,1,.42.14,1,1,0,0,1,.26.42,2.44,2.44,0,0,1,.11.64c0,.19,0,.39,0,.6s0,.4,0,.59a4.1,4.1,0,0,1-.11.76,3.73,3.73,0,0,1-.26.73,3.22,3.22,0,0,1-.42.62,2.3,2.3,0,0,1-.56.47,1.17,1.17,0,0,1-.56.18.64.64,0,0,1-.42-.15.87.87,0,0,1-.26-.42,2.37,2.37,0,0,1-.11-.64v-1.18Zm1.9,0a2.62,2.62,0,0,1,0-.27v-.59a2.26,2.26,0,0,1,0-.25,1.08,1.08,0,0,0-.05-.28.32.32,0,0,0-.1-.18.21.21,0,0,0-.17-.07.49.49,0,0,0-.23.07.9.9,0,0,0-.23.2,1.17,1.17,0,0,0-.17.26,1.32,1.32,0,0,0-.1.3,1.88,1.88,0,0,0-.05.33c0,.08,0,.17,0,.26v.6c0,.09,0,.18,0,.26a.7.7,0,0,0,.15.46c.09.1.22.09.4,0a.93.93,0,0,0,.4-.45A2.14,2.14,0,0,0,160.11,117.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.42,115.59a3.41,3.41,0,0,1,.11-.77,3.64,3.64,0,0,1,.26-.72,3.17,3.17,0,0,1,.41-.62,2.14,2.14,0,0,1,.57-.47,1.14,1.14,0,0,1,.56-.18.64.64,0,0,1,.41.14.9.9,0,0,1,.27.42,2.1,2.1,0,0,1,.1.64c0,.19,0,.39,0,.6s0,.4,0,.59a3.38,3.38,0,0,1-.1.76,3.49,3.49,0,0,1-.68,1.35,2.22,2.22,0,0,1-.56.46,1.13,1.13,0,0,1-.57.19.59.59,0,0,1-.41-.15,1,1,0,0,1-.26-.42,2,2,0,0,1-.11-.64c0-.18,0-.37,0-.58S161.41,115.78,161.42,115.59Zm1.9,0v-.27c0-.1,0-.2,0-.3a2.71,2.71,0,0,0,0-.29v-.25a1.78,1.78,0,0,0,0-.28.67.67,0,0,0-.1-.19A.25.25,0,0,0,163,114a.46.46,0,0,0-.23.07.91.91,0,0,0-.24.2,1.13,1.13,0,0,0-.16.26,1.33,1.33,0,0,0-.11.3c0,.11,0,.22,0,.33a2.17,2.17,0,0,0,0,.26v.6a2.17,2.17,0,0,0,0,.26.7.7,0,0,0,.15.46c.09.1.22.09.4,0a.86.86,0,0,0,.39-.45A1.88,1.88,0,0,0,163.32,115.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.28,114.9a.1.1,0,0,1,0,.07.26.26,0,0,1,0,.11.22.22,0,0,1-.07.09l-.68.39a.1.1,0,0,1-.1,0,.17.17,0,0,1-.08-.07l-.82-1.11V116a.39.39,0,0,1,0,.14.21.21,0,0,1-.08.1l-.57.33a.05.05,0,0,1-.08,0,.13.13,0,0,1,0-.1v-4.3a.39.39,0,0,1,0-.14.21.21,0,0,1,.08-.1l.57-.33a.06.06,0,0,1,.08,0,.13.13,0,0,1,0,.1v1.41l.76-1.88a.67.67,0,0,0,.06-.12.23.23,0,0,1,.12-.12l.67-.39s.05,0,.07,0a.12.12,0,0,1,0,.09.19.19,0,0,1,0,.08l-1.06,2.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.68,113.16a.11.11,0,0,1-.12,0l-.06-.06-1-1.7v2.24a.28.28,0,0,1,0,.15.21.21,0,0,1-.08.1l-.57.32a.06.06,0,0,1-.08,0,.16.16,0,0,1,0-.11v-4.29a.4.4,0,0,1,0-.15.27.27,0,0,1,.08-.1l.45-.26c.05,0,.09,0,.12,0l.06,0,1,1.71v-2.25a.4.4,0,0,1,0-.15s.05-.08.09-.1l.56-.32a.06.06,0,0,1,.08,0,.14.14,0,0,1,0,.11v4.29a.28.28,0,0,1,0,.15.21.21,0,0,1-.08.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.86,109.56a3.32,3.32,0,0,1,.11-.76,3,3,0,0,1,.26-.73,3.17,3.17,0,0,1,.41-.62,2.34,2.34,0,0,1,.57-.47,1.14,1.14,0,0,1,.56-.18.59.59,0,0,1,.41.15.81.81,0,0,1,.27.42,2.32,2.32,0,0,1,.1.64c0,.18,0,.38,0,.59s0,.4,0,.59a4,4,0,0,1-.1.76,3,3,0,0,1-.27.73,2.67,2.67,0,0,1-.41.62,2.26,2.26,0,0,1-.56.47,1.2,1.2,0,0,1-.57.18.64.64,0,0,1-.41-.14.87.87,0,0,1-.26-.43,2,2,0,0,1-.11-.64c0-.18,0-.37,0-.58S171.85,109.75,171.86,109.56Zm1.89.06a2.35,2.35,0,0,0,0-.27c0-.1,0-.2,0-.31a2.81,2.81,0,0,0,0-.29,1.93,1.93,0,0,0,0-.25,1.11,1.11,0,0,0,0-.28.5.5,0,0,0-.1-.18.26.26,0,0,0-.17-.07.38.38,0,0,0-.23.08.88.88,0,0,0-.24.19,1.13,1.13,0,0,0-.16.26,1.33,1.33,0,0,0-.11.3,1.86,1.86,0,0,0,0,.33,2.26,2.26,0,0,0,0,.27V110a2.09,2.09,0,0,0,0,.26.75.75,0,0,0,.15.47c.09.09.22.09.4,0a.93.93,0,0,0,.39-.44A1.72,1.72,0,0,0,173.75,109.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.22,107.16l.28-2.41a.31.31,0,0,1,.05-.17.24.24,0,0,1,.08-.09l.56-.32a.06.06,0,0,1,.07,0,.12.12,0,0,1,0,.09.18.18,0,0,1,0,.06l-.55,4.52a.74.74,0,0,1-.07.21.34.34,0,0,1-.15.16l-.36.21a.12.12,0,0,1-.14,0,.23.23,0,0,1-.07-.13l-.33-1.31-.32,1.69a.86.86,0,0,1-.07.21.38.38,0,0,1-.14.16l-.36.21c-.06,0-.11,0-.15,0a.17.17,0,0,1-.07-.13l-.56-3.88v0a.27.27,0,0,1,0-.12A.27.27,0,0,1,175,106l.56-.32a.08.08,0,0,1,.08,0s0,0,.06.11l.27,2.09.26-1.35a.49.49,0,0,1,0-.15.24.24,0,0,1,.11-.13l.41-.24a.08.08,0,0,1,.11,0,.22.22,0,0,1,0,.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.56,106.43a.27.27,0,0,1,0,.14.21.21,0,0,1-.08.1l-.54.31a.06.06,0,0,1-.08,0,.12.12,0,0,1,0-.11V104a.28.28,0,0,1,0-.15.21.21,0,0,1,.08-.1l.54-.31a.05.05,0,0,1,.08,0,.11.11,0,0,1,0,.1Zm0,1.42a.28.28,0,0,1,0,.15.21.21,0,0,1-.08.1l-.54.31a.06.06,0,0,1-.08,0,.12.12,0,0,1,0-.11v-.67a.28.28,0,0,1,0-.15.27.27,0,0,1,.08-.1l.54-.31a.05.05,0,0,1,.08,0,.11.11,0,0,1,0,.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.33,164.39c0-1.92-1.27-2.74-2.82-1.85a6.45,6.45,0,0,0-2.82,5.1v.44c0,1.47,1.67,3.19,2.44,3.9a.38.38,0,0,0,.6-.12c.66-1.35,2.6-5.45,2.6-7Zm-2.82,3c-.78.45-1.41.08-1.41-.82a3.11,3.11,0,0,1,1.41-2.44c.77-.45,1.41-.08,1.41.82A3.15,3.15,0,0,1,72.51,167.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.39,158.91l28.16-16.26c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59L80.42,163.62c-1.2.69-2.17.2-2.18-1.1A4.61,4.61,0,0,1,80.39,158.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,166.89a.39.39,0,0,1-.33-.19.37.37,0,0,1,.14-.51l20.31-11.73a.38.38,0,0,1,.51.13.39.39,0,0,1-.14.52l-20.3,11.73A.45.45,0,0,1,79.3,166.89Z",
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Backpack--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410,165.15c-.65,1.16-2.59.06-6-1.12s-2.5-16.05-2.5-16.05,5.31-.13,6.42,4.79S410,165.15,410,165.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,165.15c-.65,1.16-2.59.06-6-1.12s-2.5-16.05-2.5-16.05,5.31-.13,6.42,4.79S410,165.15,410,165.15Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.56,140.06c-3.14.05-9.95,3.88-11,6.35s-4.14,37.35-1.37,40.5c3.48,4,20.2,11.4,27.42,11,5.95-.38,11.45-6,12.3-7.64,1.41-2.66-1.57-38.23-3.55-41.18C402.17,144.27,385.55,140,381.56,140.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.56,140.06c-3.14.05-9.95,3.88-11,6.35s-4.14,37.35-1.37,40.5c3.48,4,20.2,11.4,27.42,11,5.95-.38,11.45-6,12.3-7.64,1.41-2.66-1.57-38.23-3.55-41.18C402.17,144.27,385.55,140,381.56,140.06Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.56,140.06c-3.14.05-9.95,3.88-11,6.35s-4.14,37.35-1.37,40.5c3.48,4,20.2,11.4,27.42,11,5.95-.38,11.45-6,12.3-7.64,1.41-2.66-1.57-38.23-3.55-41.18C402.17,144.27,385.55,140,381.56,140.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,167.05c-.14-1.49-.29-3-.44-4.39-.07-.56-.13-1.12-.19-1.68-.13-1.1-.26-2.16-.39-3.17-.07-.5-.13-1-.2-1.46-.1-.72-.2-1.39-.3-2s-.21-1.23-.31-1.77c0-.18-.07-.35-.1-.52a10.55,10.55,0,0,0-.88-3c-.09-.13-.2-.27-.31-.4a1.34,1.34,0,0,1-.11-.14l-.25-.27a1.21,1.21,0,0,1-.16-.16l-.27-.25-.18-.16c-.14-.13-.29-.25-.44-.37l-.3-.23-.21-.16-.36-.25-.18-.12-.41-.27c-2.77,1.25-5.4,2.45-5.48,2.5a6.82,6.82,0,0,0-2.69,6.3l.56,17.7.06,1.68c.11,2.35-1.24,24.07,5.36,22.62l.26-.05c4.41-1.72,8-5.51,8.66-6.79a3.79,3.79,0,0,0,.26-1.19c0-.24,0-.49.06-.78,0-.14,0-.29,0-.44,0-.46,0-1,0-1.54v-.58c0-3-.21-7.09-.52-11.49-.07-.88-.13-1.77-.2-2.66l-.15-1.8c0-.3-.05-.6-.08-.9C408.31,168.24,408.25,167.64,408.2,167.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,151a6.86,6.86,0,0,0-.65-2c-3.22-4.77-19.84-9-23.83-9-3.14.05-9.95,3.88-11,6.35a18.57,18.57,0,0,0-.61,3.21c6.37,3.12,22.76,10,24.41,9.34,2-.81,11.48-7.67,11.65-8Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.72,174c-.19-.09-3-2.05-3.33-2.2-.57-.26-8.5,5.54-9.22,6.5-.5.67.55,12.16.9,12.87.12.25,3.21,1.94,3.33,2.2.34.7,8.73-5.2,9.22-6.58S410.56,174.42,409.72,174Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.72,174c-.19-.09-3-2.05-3.33-2.2-.57-.26-8.5,5.54-9.22,6.5-.5.67.55,12.16.9,12.87.12.25,3.21,1.94,3.33,2.2.34.7,8.73-5.2,9.22-6.58S410.56,174.42,409.72,174Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.5,180.52c-.5.67.55,12.17.9,12.88s8.73-5.2,9.22-6.58-.06-12.4-.9-12.79C409.15,173.77,401.22,179.56,400.5,180.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.4,171.84c.32.14,3.13,2.1,3.32,2.19-.57-.26-8.5,5.53-9.22,6.49l-3.33-2.19C397.89,177.36,405.82,171.57,406.4,171.84Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.5,180.52c-.5.67.55,12.17.9,12.88s8.73-5.2,9.22-6.58-.06-12.4-.9-12.79C409.15,173.77,401.22,179.56,400.5,180.52Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17,178.33c.59-.42,2.44.48,3.24,1.12s1.77,3.76,3.81,4.19,4.79-2.35,5.32-4.08,1.11-5.35.09-6.6a3.32,3.32,0,0,0-4.16-1.06C404.07,172.73,397.28,176.75,397.17,178.33Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17,178.33c.59-.42,2.44.48,3.24,1.12s1.77,3.76,3.81,4.19,4.79-2.35,5.32-4.08,1.11-5.35.09-6.6a3.32,3.32,0,0,0-4.16-1.06C404.07,172.73,397.28,176.75,397.17,178.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.31,179.38a1.51,1.51,0,0,0-.65,1.42.61.61,0,0,0,.94.5,1.48,1.48,0,0,0,.65-1.42C407.17,179.34,406.75,179.12,406.31,179.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.16,159a13.06,13.06,0,0,1,5.89-7.31c4.92-3.1,5.11-2.19,6.82.57,1.54,2.48,2.48,11.9,2.58,12.8s1.18.69.8-5.08-1.41-11.27-6.93-14.49c-7.43-4.34-18.77-6.92-24-5.57s-9.9,4.19-9.32,9.7C370,149.62,377.19,158.53,394.16,159Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.16,159a13.06,13.06,0,0,1,5.89-7.31c4.92-3.1,5.11-2.19,6.82.57,1.54,2.48,2.48,11.9,2.58,12.8s1.18.69.8-5.08-1.41-11.27-6.93-14.49c-7.43-4.34-18.77-6.92-24-5.57s-9.9,4.19-9.32,9.7C370,149.62,377.19,158.53,394.16,159Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.13,277.57c-.07-2.37-.62-26.26-.62-26.26l11.1,9c-2.3,13.58-3.15,17.2-3.3,19.48h0a1.81,1.81,0,0,1,0,.58c-.13,2.7-3.24,4-5.7,5.71A44.45,44.45,0,0,1,357,290c-1.76.79-5.28.71-5.66-.42a67.41,67.41,0,0,0,8.87-6.76C361.38,281.63,362.22,280.41,362.13,277.57Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.28,292.22a2.35,2.35,0,0,0,.33,2.35,9.92,9.92,0,0,0,7.19,2,12.76,12.76,0,0,0,7.14-2.47c1.49-1.15,3.6-2.76,5.24-3a9.88,9.88,0,0,0,3.72-1.33c.51-.44.53-2.53.53-2.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.36,279.11a.57.57,0,0,1,.53.51c.08.58.13,2.25.32,3.21a16.76,16.76,0,0,1,.12,5.07c-.24,1.06-2.75,1.69-4.36,2.22a20,20,0,0,0-5.26,3A14.83,14.83,0,0,1,353,295.6c-3.59-.11-5.88-1.19-6.53-2.51-.82-1.64-.08-2.53,4.13-4.25.8-.33,3.62-1.83,4.58-2.37,2.6-1.48,5.21-3.58,6.5-6.34a1.55,1.55,0,0,1,.63-.84,1.32,1.32,0,0,1,.81,0,6.64,6.64,0,0,1,2,.69c.54.28,1.31.63,1.27,1.34a2.58,2.58,0,0,1-.19.71c-.06.14-.11.33,0,.42s.27,0,.39-.09a9.51,9.51,0,0,0,1.17-1.28,4.5,4.5,0,0,1,.68-.63c.23-.17.52-.24.73-.43S369.34,279.44,369.36,279.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.89,289.12c5.18.6,6.67,3.88,6.8,5.88a12,12,0,0,1-3.72.6c-3.59-.11-6-1.19-6.68-2.52C345.52,291.54,346.14,290.35,349.89,289.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,289.53a.22.22,0,0,0,.16,0,.25.25,0,0,0,.06-.35,6.13,6.13,0,0,0-4.62-2.07.26.26,0,0,0-.24.27.25.25,0,0,0,.27.23,5.7,5.7,0,0,1,4.18,1.87A.26.26,0,0,0,357.68,289.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,288.33a.24.24,0,0,0,.16-.05.25.25,0,0,0,.05-.36,6.05,6.05,0,0,0-4.61-2.06.25.25,0,0,0-.24.27.26.26,0,0,0,.27.23,5.66,5.66,0,0,1,4.18,1.87A.24.24,0,0,0,360,288.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.12,286.93a.18.18,0,0,0,.16-.05.25.25,0,0,0,.06-.35,6.15,6.15,0,0,0-4.62-2.07.26.26,0,0,0-.24.27.26.26,0,0,0,.27.24,5.66,5.66,0,0,1,4.18,1.86A.23.23,0,0,0,362.12,286.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.22,285.54a.24.24,0,0,0,.16-.05.25.25,0,0,0,.06-.35,6.22,6.22,0,0,0-5.05-2.12.26.26,0,0,0,0,.51,5.81,5.81,0,0,1,4.61,1.9A.25.25,0,0,0,364.22,285.54Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.51,260.57l11.43-1c.33,7.65-.33,16.21-.06,23.38.05,1.36.72,10.48.39,13.29-.49,4.22-5.48,4-5.9,1.5s-.54-13.17-.63-14.27c-.26-4.6-2.92-12.22-4.59-20.39C386.07,262.71,385.59,261,385.51,260.57Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.62,299.64a11.32,11.32,0,0,0,1.2,5.57,3.6,3.6,0,0,0,4.12,1.61c1.68-.36,3.84-1.41,4.4-3.51a13.45,13.45,0,0,0,.2-5.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.85,282.12c.69.07.77,3.37,1,6.68.3,3.55,1.31,5.05,1.58,8,.32,3.33.09,4.8-1.14,6.76s-5.4,3.78-7.33.84c-1.56-2.39-1.54-5-1.27-8.28s.49-5.81.44-8.41-.13-4.89.47-5.15c0,.37.07.83.1,1.19s.05,1.62.43,1.65a4.9,4.9,0,0,0,0-.94,1.15,1.15,0,0,1,.22-.79,1.24,1.24,0,0,1,.77-.31,20.12,20.12,0,0,1,2.05-.25,8.85,8.85,0,0,1,1,0,2.55,2.55,0,0,1,.86.15.62.62,0,0,1,.36.35,1,1,0,0,1,0,.38,3.07,3.07,0,0,0,.06.68c0,.1.09.22.19.2s.11-.11.12-.2c0-.39,0-.69,0-1.15,0-.22,0-.51,0-.73S396.86,282.33,396.85,282.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6,298.69a8.14,8.14,0,0,1-1.08,5c-1.23,2-5.73,3.77-7.66.83a9.46,9.46,0,0,1-1.24-4.88C390.91,297.47,397.76,296.74,399.6,298.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.5,296.1l.09,0a10,10,0,0,1,5.92-.4.26.26,0,0,0,.32-.18.26.26,0,0,0-.18-.31,10.29,10.29,0,0,0-6.27.43.24.24,0,0,0-.13.33A.25.25,0,0,0,391.5,296.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,293.21a.27.27,0,0,0,.23-.17.25.25,0,0,0-.15-.32,8.69,8.69,0,0,0-6.26.37.24.24,0,0,0-.11.33.24.24,0,0,0,.33.12,8.4,8.4,0,0,1,5.86-.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.34,290.87a.25.25,0,0,0,.22-.15.27.27,0,0,0-.14-.34,7.9,7.9,0,0,0-6.38.35.25.25,0,1,0,.25.44,7.52,7.52,0,0,1,5.94-.31A.21.21,0,0,0,397.34,290.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.22,288.25a.24.24,0,0,0,.22-.15.25.25,0,0,0-.14-.33,8.21,8.21,0,0,0-6.42.41.26.26,0,1,0,.24.45,7.83,7.83,0,0,1,6-.4A.15.15,0,0,0,397.22,288.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.19,183.81c2,5.09,4.25,8.68,4.2,18.13-.1,20.1-.83,34.59-.83,34.59.07,1.78.88,4.41,1.76,13.57a164.94,164.94,0,0,1,.11,19.43s-5.21,2.52-9.88.43c-1.66-6.6-4.42-23.77-6.17-32.58-1.59-8-3-19.69-3-19.69l-3.68,19.56s.29,7.89-.14,12.53c-.5,5.38-3.54,20.43-3.54,20.43s-5.33,2.12-9.29-1c0,0-1.06-27.23-.87-33.74.36-12.75.64-39.64,3.33-52.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.75,267.64c-2,1.14-8.13,1.72-10.72.65l.64,3.11s1.16.88,4.78.81,5.09-1.54,5.09-1.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.63,267.59c-2.1.88-7.8.69-10.23-.71l.23,3.17s.81,1.21,4.43,1.4,5-.87,5-.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.35,217.69l-1.69-14.26s-8.43-1.3-11.41-4.36c0,0,3.69,5.61,9.4,6.7l2,11.85-2,19.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.48,124.75c1.57,2.1,2.35,4.95,1.67,11.63-.63,6.18,3.08,9.89,5,12.25,3.86,4.76,4.08,12.56-3.76,16.1s-23.11,2.31-27.6-10c-3.15-8.65,0-11.72,3.73-16.79S391.48,124.75,391.48,124.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.52,146.68c-3.19-.14-5.45.57-7.36,3-3,3.77-8.39,13.63-11.73,19.53l-12.08-2.7,3.43,9.63a91.12,91.12,0,0,0,9.89,2.82c3.25.54,4.27,0,6.17-2.74,1.64-2.37,6.09-10.43,6.09-10.43Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.43,169.19c1.61.36,4.19,1.81,4.56,3.43,0,0,.06-2.66-4-4.46Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.55,162.56h0l.67-.62h0a.8.8,0,0,1,.71-.11l7.57,1.74a2.78,2.78,0,0,1,1.75,1.5l6,15.34a.69.69,0,0,1-.07.79h0l-.69.64h0a.76.76,0,0,1-.72.11l-7.57-1.73a2.78,2.78,0,0,1-1.74-1.51l-6-15.33C334.3,163,334.35,162.72,334.55,162.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.64,164.6a2.62,2.62,0,0,1,.92,1.11l6,15.33a.74.74,0,0,1,0,.78l.64-.6h0a.71.71,0,0,0,.07-.8l-6-15.33a2.62,2.62,0,0,0-.85-1.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.57,181l-6-15.33a2.79,2.79,0,0,0-1.75-1.51l-7.57-1.74c-.7-.16-1.06.26-.79.93l6,15.33a2.78,2.78,0,0,0,1.74,1.51l7.57,1.73C350.47,182.12,350.83,181.71,350.57,181Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.18,167.82a3.69,3.69,0,0,0-2.29,3.79c.44,3.5,2.55,9.09,8.12,7,2.84-1.08,3.44-4.89.83-5.64C338.25,171.6,337,170,337,170Z",
    style: {
      fill: "#9e6767"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.9,168.45c.15,3.35-.49,14.26-.49,14.26,10.26,6.93,28,1.28,28,1.28-.89-2.52-1.68-4.36-1.48-6.71l2.19-13.45a27.88,27.88,0,0,1-3.09-15.9l-7.49-1.12-7.2-.13-4,.1c-1.58,1.35-4.06,4.86-6.41,8.84C362.07,160.48,362,165.09,364.9,168.45Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.66,187.73c-2-5.48-3-7.35-3.17-10s1.66-12.22,1.66-12.22,0-.08-.36,0a18.33,18.33,0,0,1-3.4-3,23.76,23.76,0,0,1-2.87-4.14,68.85,68.85,0,0,1,1.93-10.6l-1.91-.34s-1.7,3.82-3.2,7.6c-7.79,2.41-14,.77-15.2-.64a35.09,35.09,0,0,1,4.08-7.55l-1.7-.08s-4.91,6.32-6.13,8.49-3.59,7.73-.4,12.65l-2.13,26.74s1.85,3.38,10.6,4.51,15.31-7,15.31-7,3.8,5.4,9.21,5.86A40.89,40.89,0,0,0,394.66,187.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.66,187.73c-2-5.48-3-7.35-3.17-10s1.66-12.22,1.66-12.22,0-.08-.36,0a18.33,18.33,0,0,1-3.4-3,23.76,23.76,0,0,1-2.87-4.14,68.85,68.85,0,0,1,1.93-10.6l-1.91-.34s-1.7,3.82-3.2,7.6c-7.79,2.41-14,.77-15.2-.64a35.09,35.09,0,0,1,4.08-7.55l-1.7-.08s-4.91,6.32-6.13,8.49-3.59,7.73-.4,12.65l-2.13,26.74s1.85,3.38,10.6,4.51,15.31-7,15.31-7,3.8,5.4,9.21,5.86A40.89,40.89,0,0,0,394.66,187.73Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,147.26s-4.63,4.36-5,13.61c-.94,23.41,14.49,28.94,14.49,28.94a61,61,0,0,1-1-7.45s-8.45-7.72-8-19.67c.32-8.53,4.18-13.74,6.31-14.4A24.64,24.64,0,0,0,386.5,147.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,147.26s-4.63,4.36-5,13.61c-.94,23.41,14.49,28.94,14.49,28.94a61,61,0,0,1-1-7.45s-8.45-7.72-8-19.67c.32-8.53,4.18-13.74,6.31-14.4A24.64,24.64,0,0,0,386.5,147.26Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.24,146.68c-2.88,1.37-8.95,6.13-11,11,0,0,1.06-6.89,6.34-11C371.15,145.61,373.84,146,374.24,146.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.24,146.68c-2.88,1.37-8.95,6.13-11,11,0,0,1.06-6.89,6.34-11C371.15,145.61,373.84,146,374.24,146.68Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.67,143.47c.91-1.67,2.22-2.61,4.53-5.11,3.21-3.47,5.62-13.39-.07-15.43-2.77-9.13-10.72-9-16.64-6.94-9.63,3.36-10.64,8.68-6.41,14.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.11,132.21a2,2,0,0,0-3.29-.12c-.3.39-.5.84-.8,1.23a1.52,1.52,0,0,1-1.22.71,1.12,1.12,0,0,1-.94-.53,3.88,3.88,0,0,1-.23-1.39c-.67-6.62-4.47-11.86-10.8-7.74-1.55-1.73-3.14-1.74-4-1.37-.57.23-2.67,1.88-2.67,9,0,6.78,1.55,9.7,3.44,10.66a9,9,0,0,0,4.82.72l-.17,3.85a5.27,5.27,0,0,0-1.69,5.95,23.07,23.07,0,0,0,6.39-1.52c4.57-2,5.75-4.1,5.75-4.1l-.05-10.18a2.56,2.56,0,0,0,3.84.47C390.48,136.46,391.39,133.82,390.11,132.21Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.14,131.78a1,1,0,0,0,.85,1.15,1,1,0,0,0,1.13-.81,1,1,0,0,0-.85-1.15A1,1,0,0,0,375.14,131.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.13,128.63l2.19-1a1.16,1.16,0,0,0-1.54-.64A1.25,1.25,0,0,0,367.13,128.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,127.8l2.07,1.21a1.17,1.17,0,0,0-.39-1.63A1.26,1.26,0,0,0,376,127.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.81,137l-3.43,1a1.79,1.79,0,0,0,2.37,1.17A1.68,1.68,0,0,0,376.81,137Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.77,139.24a1.87,1.87,0,0,1,1.93-1.61l.18,0a1.6,1.6,0,0,1-1.13,1.51A2.07,2.07,0,0,1,374.77,139.24Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.69,131.37a1,1,0,0,0,.82,1.11.93.93,0,0,0,1.09-.78,1,1,0,0,0-.82-1.12A.93.93,0,0,0,367.69,131.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39,143.4c2.4-.24,7.52-1.29,8.48-3.12a5.57,5.57,0,0,1-2.07,2.59c-1.58,1.08-6.47,1.89-6.47,1.89Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,130.17l-.35,6.21-3-.73A41,41,0,0,1,373,130.17Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.25,128.72a.42.42,0,0,0-.2-.1l-.47-.08a13.83,13.83,0,0,0-4.58,0c-1.46.36-2,.81-2.78.79s-1.24-.53-2.6-1a12.39,12.39,0,0,0-4.29-.31l-.43,0c-.23,0-.49.38-.46.77a1.71,1.71,0,0,0,.39.94.85.85,0,0,1,.16.33,15,15,0,0,0,.53,2.51,2.75,2.75,0,0,0,2.65,1.82,4.4,4.4,0,0,0,.92-.05l.07,0a2.58,2.58,0,0,0,.74-.27l.05,0s0,0,.06,0l.08-.05.08-.06.08-.06.08-.07.15-.14a3.3,3.3,0,0,0,.61-.94c.41-.86.33-2.09,1-2.22h.15c.87,0,.75,1.36,1.21,2.32a3.23,3.23,0,0,0,3.13,2H377a2.14,2.14,0,0,0,.45-.05l.15,0a.31.31,0,0,1,.13,0l.09,0a3,3,0,0,0,.51-.23l.18-.11a3.73,3.73,0,0,0,.3-.26,2.87,2.87,0,0,0,.58-.87,14.23,14.23,0,0,0,.56-2.46,1.57,1.57,0,0,1,.16-.36l.1-.14,6.54,2a2.16,2.16,0,0,1,1.91-.83Zm-9.61,3a4.19,4.19,0,0,1-.14.49s0,0,0,0a.08.08,0,0,0,0,.05l0,0,0,.06a.61.61,0,0,1-.05.12l-.06.1a.06.06,0,0,1,0,0l-.05.06a.25.25,0,0,1,0,.07h0a2.18,2.18,0,0,1-2.1.9,2.36,2.36,0,0,1-1-.27,3,3,0,0,1-1.32-2.17c-.14-.66-.31-2,0-2.23a1,1,0,0,1,.34-.21h0l.15-.07.09,0h.23a1.64,1.64,0,0,1,.32,0l.18,0h.56c.21,0,.42,0,.65.08a4,4,0,0,1,2.29,1.06A3.29,3.29,0,0,1,370.64,131.76Zm8.5.06,0,0a.13.13,0,0,1,0,.06c0,.07,0,.16-.06.26a1,1,0,0,1-.05.16h0c0,.09-.06.18-.1.27l0,.1a.21.21,0,0,1-.05.12.43.43,0,0,0,0,.07.25.25,0,0,0,0,.09.27.27,0,0,1-.07.08.2.2,0,0,1-.06.09,2.2,2.2,0,0,1-2,.89,2.67,2.67,0,0,1-2.05-.83,2.89,2.89,0,0,1-.65-1.34,2.93,2.93,0,0,1,.05-2,1.07,1.07,0,0,1,.42-.32l.07-.05h0a1,1,0,0,1,.21-.1l.19-.07a3.48,3.48,0,0,1,.62-.18l.25-.06c.21,0,.42-.06.63-.08h.16a3.72,3.72,0,0,1,2.58.55C379.46,129.87,379.28,131.17,379.14,131.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.25,128.72a.42.42,0,0,0-.2-.1l-.47-.08a13.83,13.83,0,0,0-4.58,0c-1.46.36-2,.81-2.78.79s-1.24-.53-2.6-1a12.39,12.39,0,0,0-4.29-.31l-.43,0c-.23,0-.49.38-.46.77a1.71,1.71,0,0,0,.39.94.85.85,0,0,1,.16.33,15,15,0,0,0,.53,2.51,2.75,2.75,0,0,0,2.65,1.82,4.4,4.4,0,0,0,.92-.05l.07,0a2.58,2.58,0,0,0,.74-.27l.05,0s0,0,.06,0l.08-.05.08-.06.08-.06.08-.07.15-.14a3.3,3.3,0,0,0,.61-.94c.41-.86.33-2.09,1-2.22h.15c.87,0,.75,1.36,1.21,2.32a3.23,3.23,0,0,0,3.13,2H377a2.14,2.14,0,0,0,.45-.05l.15,0a.31.31,0,0,1,.13,0l.09,0a3,3,0,0,0,.51-.23l.18-.11a3.73,3.73,0,0,0,.3-.26,2.87,2.87,0,0,0,.58-.87,14.23,14.23,0,0,0,.56-2.46,1.57,1.57,0,0,1,.16-.36l.1-.14,6.54,2a2.16,2.16,0,0,1,1.91-.83Zm-9.61,3a4.19,4.19,0,0,1-.14.49s0,0,0,0a.08.08,0,0,0,0,.05l0,0,0,.06a.61.61,0,0,1-.05.12l-.06.1a.06.06,0,0,1,0,0l-.05.06a.25.25,0,0,1,0,.07h0a2.18,2.18,0,0,1-2.1.9,2.36,2.36,0,0,1-1-.27,3,3,0,0,1-1.32-2.17c-.14-.66-.31-2,0-2.23a1,1,0,0,1,.34-.21h0l.15-.07.09,0h.23a1.64,1.64,0,0,1,.32,0l.18,0h.56c.21,0,.42,0,.65.08a4,4,0,0,1,2.29,1.06A3.29,3.29,0,0,1,370.64,131.76Zm8.5.06,0,0a.13.13,0,0,1,0,.06c0,.07,0,.16-.06.26a1,1,0,0,1-.05.16h0c0,.09-.06.18-.1.27l0,.1a.21.21,0,0,1-.05.12.43.43,0,0,0,0,.07.25.25,0,0,0,0,.09.27.27,0,0,1-.07.08.2.2,0,0,1-.06.09,2.2,2.2,0,0,1-2,.89,2.67,2.67,0,0,1-2.05-.83,2.89,2.89,0,0,1-.65-1.34,2.93,2.93,0,0,1,.05-2,1.07,1.07,0,0,1,.42-.32l.07-.05h0a1,1,0,0,1,.21-.1l.19-.07a3.48,3.48,0,0,1,.62-.18l.25-.06c.21,0,.42-.06.63-.08h.16a3.72,3.72,0,0,1,2.58.55C379.46,129.87,379.28,131.17,379.14,131.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.14,131.82l0,0a.13.13,0,0,1,0,.06c0,.07,0,.16-.06.26a1,1,0,0,1-.05.16h0c0,.09-.06.18-.1.27l0,.1a.21.21,0,0,1-.05.12.43.43,0,0,0,0,.07.25.25,0,0,0,0,.09.27.27,0,0,1-.07.08.2.2,0,0,1-.06.09,2.2,2.2,0,0,1-2,.89,2.67,2.67,0,0,1-2.05-.83,2.89,2.89,0,0,1-.65-1.34,2.93,2.93,0,0,1,.05-2,1.07,1.07,0,0,1,.42-.32l.07-.05h0a1,1,0,0,1,.21-.1l.19-.07a3.48,3.48,0,0,1,.62-.18l.25-.06c.21,0,.42-.06.63-.08h.16a3.72,3.72,0,0,1,2.58.55C379.46,129.87,379.28,131.17,379.14,131.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,131.76a4.19,4.19,0,0,1-.14.49s0,0,0,0a.08.08,0,0,0,0,.05l0,0,0,.06a.61.61,0,0,1-.05.12l-.06.1a.06.06,0,0,1,0,0l-.05.06a.25.25,0,0,1,0,.07h0a2.18,2.18,0,0,1-2.1.9,2.36,2.36,0,0,1-1-.27,3,3,0,0,1-1.32-2.17c-.14-.66-.31-2,0-2.23a1,1,0,0,1,.34-.21h0l.15-.07.09,0h.23a1.64,1.64,0,0,1,.32,0l.18,0h.56c.21,0,.42,0,.65.08a4,4,0,0,1,2.29,1.06A3.29,3.29,0,0,1,370.64,131.76Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--backpack--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.48,179.89c-.77,1.08-2.58-.22-5.8-1.76s-.76-16.22-.76-16.22,5.29.43,5.87,5.45S469.48,179.89,469.48,179.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.48,179.89c-.77,1.08-2.58-.22-5.8-1.76s-.76-16.22-.76-16.22,5.29.43,5.87,5.45S469.48,179.89,469.48,179.89Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.92,151.89c-3.12-.3-10.3,2.78-11.58,5.12s-8.14,36.69-5.72,40.12c3,4.31,18.85,13.51,26.08,13.84,5.95.27,12-4.75,13.05-6.27,1.69-2.49,2.56-38.18.9-41.32C464,158.29,447.9,152.26,443.92,151.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.92,151.89c-3.12-.3-10.3,2.78-11.58,5.12s-8.14,36.69-5.72,40.12c3,4.31,18.85,13.51,26.08,13.84,5.95.27,12-4.75,13.05-6.27,1.69-2.49,2.56-38.18.9-41.32C464,158.29,447.9,152.26,443.92,151.89Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.92,151.89c-3.12-.3-10.3,2.78-11.58,5.12s-8.14,36.69-5.72,40.12c3,4.31,18.85,13.51,26.08,13.84,5.95.27,12-4.75,13.05-6.27,1.69-2.49,2.56-38.18.9-41.32C464,158.29,447.9,152.26,443.92,151.89Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.51,181.58c0-1.5,0-3,0-4.4,0-.58,0-1.14,0-1.7,0-1.11,0-2.18,0-3.19,0-.51,0-1,0-1.48,0-.72-.05-1.4-.09-2s-.07-1.24-.11-1.79c0-.18,0-.36-.05-.53a10.35,10.35,0,0,0-.55-3.07,3.37,3.37,0,0,0-.26-.44l-.1-.14-.22-.3-.14-.18-.24-.28-.16-.18-.4-.41-.28-.26-.19-.18-.32-.29-.17-.14-.38-.32c-2.89,1-5.63,1.86-5.71,1.91a6.77,6.77,0,0,0-3.36,6l-1.34,17.66-.13,1.68c-.14,2.34-3.82,23.79,2.89,23.06l.27,0c4.56-1.23,8.53-4.61,9.34-5.81a3.56,3.56,0,0,0,.38-1.16c.05-.23.1-.48.14-.77s.05-.28.07-.43c.07-.46.14-1,.2-1.53l.06-.58c.31-3,.56-7.07.72-11.47,0-.88.06-1.78.09-2.68,0-.6,0-1.2,0-1.8,0-.3,0-.6,0-.9C467.49,182.78,467.5,182.18,467.51,181.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.09,165.39a6.82,6.82,0,0,0-.44-2c-2.68-5.09-18.75-11.12-22.73-11.49-3.12-.3-10.3,2.78-11.58,5.12a19.45,19.45,0,0,0-.95,3.13c6,3.79,21.55,12.38,23.26,11.91,2.09-.59,12.24-6.38,12.44-6.66Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.27,188.69c-.18-.11-2.77-2.36-3.07-2.55-.54-.32-9.06,4.59-9.87,5.47-.57.61-.48,10.7-.21,11.44.09.26,3,2.27,3.07,2.54.27.74,9.24-4.23,9.87-5.54S469.06,189.16,468.27,188.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.27,188.69c-.18-.11-2.77-2.36-3.07-2.55-.54-.32-9.06,4.59-9.87,5.47-.57.61-.48,10.7-.21,11.44.09.26,3,2.27,3.07,2.54.27.74,9.24-4.23,9.87-5.54S469.06,189.16,468.27,188.69Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.4,194.15c-.57.61-.48,10.7-.21,11.44s9.24-4.23,9.87-5.54,1-10.89.21-11.36C467.73,188.36,459.22,193.27,458.4,194.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.2,186.15c.3.18,2.89,2.43,3.07,2.54-.54-.33-9,4.58-9.87,5.46l-3.07-2.54C456.14,190.73,464.66,185.82,465.2,186.15Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.4,194.15c-.57.61-.48,10.7-.21,11.44s9.24-4.23,9.87-5.54,1-10.89.21-11.36C467.73,188.36,459.22,193.27,458.4,194.15Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.33,191.61c.63-.35,2.37.74,3.1,1.46s1.36,3.93,3.34,4.58,5-1.83,5.72-3.49,1.68-5.2.8-6.55a3.33,3.33,0,0,0-4-1.5C462.79,186.78,455.61,190.05,455.33,191.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.33,191.61c.63-.35,2.37.74,3.1,1.46s1.36,3.93,3.34,4.58,5-1.83,5.72-3.49,1.68-5.2.8-6.55a3.33,3.33,0,0,0-4-1.5C462.79,186.78,455.61,190.05,455.33,191.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.3,193.64a1.52,1.52,0,0,0-.8,1.34.6.6,0,0,0,.88.59,1.43,1.43,0,0,0,.8-1.33C465.16,193.69,464.76,193.43,464.3,193.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.42,172.07a13,13,0,0,1,6.64-6.63c5.23-2.56,5.31-1.63,6.72,1.29,1.27,2.63,1.18,12.1,1.19,13s1.09.82,1.33-5-.18-11.36-5.32-15.16c-6.92-5.11-17.92-8.9-23.29-8.12s-10.29,3.1-10.3,8.64C431.39,160.14,437.6,169.77,454.42,172.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.42,172.07a13,13,0,0,1,6.64-6.63c5.23-2.56,5.31-1.63,6.72,1.29,1.27,2.63,1.18,12.1,1.19,13s1.09.82,1.33-5-.18-11.36-5.32-15.16c-6.92-5.11-17.92-8.9-23.29-8.12s-10.29,3.1-10.3,8.64C431.39,160.14,437.6,169.77,454.42,172.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.28,158.48s-2,1-2.22,2.28-1,4.24-.54,5.1,2,1.07,2.29.5.68-4.17,1.08-5.09a7.12,7.12,0,0,1,2-2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.16,162.08s-2,.88-2.2,2.14-1,4.11-.56,5,2.05,1.07,2.29.5.68-4.17,1.08-5.09a5.57,5.57,0,0,1,2-1.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.28,158.48s-2,1-2.22,2.28-1,4.24-.54,5.1,2,1.07,2.29.5.68-4.17,1.08-5.09a7.12,7.12,0,0,1,2-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.16,162.08s-2,.88-2.2,2.14-1,4.11-.56,5,2.05,1.07,2.29.5.68-4.17,1.08-5.09a5.57,5.57,0,0,1,2-1.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.45,141h0c-1.14-.39-2.53,0-3.9,1.19a12.64,12.64,0,0,0-3.65,10.85c.38,1.88,1.33,3,2.55,3.35h0l31.42,9.49,5.25-15.31-8.85-1.35L458,148.17l-10.91-3.45-1.51-.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.11,151.74a12.64,12.64,0,0,0-3.65,10.85c.72,3.58,3.53,4.53,6.27,2.11a12.64,12.64,0,0,0,3.65-10.85C471.66,150.27,468.85,149.32,466.11,151.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.2,144.39s-6.61,3.85-5.92,14.09l2.59.78s-.76-9.86,6.49-13.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,148.17s-6.61,3.64-5.92,13.87l2.59.79s-.67-9.62,6.58-13.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.06,151.51a18.55,18.55,0,0,0-.78,7l2.59.78a19.42,19.42,0,0,1,.91-6.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M452.7,155.68a18.47,18.47,0,0,0-.6,6.36l2.59.79a19.07,19.07,0,0,1,.81-6.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M470.25,155.26c-1.05-.68-2.17.23-2.69,1.13a4.88,4.88,0,0,0-.51,2.53,2,2,0,0,0,.21,1.06c.19.27.51.4.75.12.09-.11,0-.45-.18-.42s-.11.09-.15,0,0-.25,0-.34a5.59,5.59,0,0,1,.13-1,4.46,4.46,0,0,1,.45-1.48,3,3,0,0,1,.94-1c.34-.21.85-.29,1,.18a4.93,4.93,0,0,1-.48,2.46,8.73,8.73,0,0,1-1.49,2.89c-.38.46-1.45,1.48-2.13,1.07s-.62-1.7-.63-2.3a8.5,8.5,0,0,1,.52-2.91,8.91,8.91,0,0,1,1.56-3,2.54,2.54,0,0,1,1.08-.72c.34-.12,1.12-.36,1.25.11,0,.12.27.35.38.18.39-.6-.19-1.1-.77-1.24a3,3,0,0,0-2.6.64,8,8,0,0,0-2.11,3.54,9.4,9.4,0,0,0-.61,4.1c.1,1.08.45,2.45,1.68,2.72s2.69-.67,3.43-1.68a10.2,10.2,0,0,0,1.6-4C471,157.07,471.12,155.81,470.25,155.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.71,305.82c-2.23,1.2-6.12,1.14-8.83-.31L439,280.62l11.94-.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.11,303.85a6.86,6.86,0,0,1,.6,3.59c-.1,1.08-.8,2.45-.6,4.89s.73,3.23.92,5a8.83,8.83,0,0,1-1,5.63c-1.07,1.6-2.94,3.16-7.31,2.86-4.93-.33-5.77-3-5.77-5.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.07,300.48a.89.89,0,0,1,.5.35c.35.47.23,1.19.35,1.75l.12.64c.28,1.64-.13,3.31-.16,5a27.46,27.46,0,0,0,.8,5.83c.67,3.47.66,5.64-2.44,7.92a8.84,8.84,0,0,1-5.47,1.67c-1.53,0-3.8-.72-4.56-1.55a5.27,5.27,0,0,1-1.41-2.56c0-3.67,1.58-7.74,2-11.39.2-1.81.27-3.79.37-5.62a.69.69,0,0,1,.11-.4.56.56,0,0,1,.3-.17c2.42-.82,5.47-.38,7.95.12.21,0,.45.11.53.31a.61.61,0,0,1,0,.27,7.06,7.06,0,0,0,.14,1.45c0,.12.08.27.2.27s.31-1,.32-1.15l0-2.75A.91.91,0,0,1,451.07,300.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.8,319.5a4.23,4.23,0,0,1,.37-2.09c1.7-3.34,11.32-2.73,13.87.78-.08,2.12-.34,3.3-2.15,4.77-1.48,1.21-4.53,1.54-6.43,1.35a7.17,7.17,0,0,1-4.18-1.74A3.89,3.89,0,0,1,438.8,319.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.27,301.75c-1.88,4.07-6.59,3.1-10.42.49l-1.28-27.09,13.1,3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.38,312.14a2.91,2.91,0,0,0,.12,2.12c.3.62,3.54,2.45,7.91,2.15a18.07,18.07,0,0,0,9-3.16c1.67-1.1,4.7-1.54,6.86-1.66s5-1.21,5.49-2.22a4.83,4.83,0,0,0-.08-2.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.59,300.5c-1,1.86-3.15,2.81-4.89,3.77-.77.42-1.65.79-2.45,1.18-1.05.52-2.17.71-3.25,1.13a18.6,18.6,0,0,0-3.47,1.7,3.15,3.15,0,0,0,0,5.21c1.69,1,6.13,2.06,10.78.74,2.54-.71,6.64-3.66,10-3.92,2.11-.16,6.12-.76,7.48-2.36.43-2.34-.17-3-.72-4.93-.27-.93-.28-1.89-.5-2.81a1,1,0,0,0-.39-.74,2.3,2.3,0,0,0-.74-.33l-.06,1.06s-.15.49-1.33,1.17a5.12,5.12,0,0,0-1.9,1.88,2,2,0,0,1-.44.63.56.56,0,0,1-.71,0,.8.8,0,0,1-.13-.73,17.93,17.93,0,0,0,.12-1.79.63.63,0,0,0-.05-.31.55.55,0,0,0-.2-.2c-1.35-1-4.36-1.06-6-1.26a1,1,0,0,0-.62.07,1.13,1.13,0,0,0-.38.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,301.6a13.27,13.27,0,0,0,.31,1.42c.55,2,1.15,2.59.72,4.93-1,1.23-3.65,1.87-5.76,2.17C422.29,306.12,424.8,303.13,427.74,301.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,308.13a15.81,15.81,0,0,1,3.09-1.35,7.47,7.47,0,0,1,6.91,7.68,14.32,14.32,0,0,1-9.94-.85C398.54,312.46,398.73,309.28,400.44,308.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.3,197.79c.52,15.78,1.48,26.83,1.41,55.87a129.52,129.52,0,0,1,1.53,15.88c.2,7.27-.16,26.28-.16,26.28s-5.69,2-10.81,0c0,0-4.92-27.91-6.48-38-1.38-8.91-3.19-24.07-3.19-24.07L429,254.48a62.38,62.38,0,0,1,.86,14.9c-.33,4.76-2.68,25.5-2.68,25.5a16.65,16.65,0,0,1-11.9-1s-2.27-35.64-2.35-40c-.09-4.92,1.45-60.32,1.45-60.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.6,233.73l-1.88-16.85s-6.22-.78-9.8-4.39c0,0,0,3.66,7.53,6.46l2.63,13.58L429,254.48Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.06,155.79c-7.66,0-8.91,3.3-10.6,7.86S410,186.16,410,186.16L394,196.9l-2.45,7.95s19.68-6.29,24.53-8.49c3.21-1.45,4-4.07,4.76-8.84C422.25,179,424.06,155.79,424.06,155.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.33,155.68c-3.63-.07-6.63.41-8.71,2.8s-2.88,4.42-3.58,9c-.59,3.87-1.85,14.55-1.85,14.55s4,3.39,12.14,1.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,168.14c.71-5.14,2-12.1,10-12.41l9.71-.47c2.53.66,15.92,5.26,15.92,5.26l-2.81,25.57s.71,10.55,1,19.15c-7.37,4.68-27.45,3.09-35.24-1.6C413.21,196.52,414.21,173.24,414.92,168.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,123.75c.82-.12,1.65-.25,2.48-.32a14,14,0,0,1,7.21,1,10,10,0,0,1,5.29,6.48c4.69,3,.24,14-4.91,19l-5.9-4.47-9.89-7.5c-2.05-1.54-4.05-3.16-5.06-5.62a6.74,6.74,0,0,1-.32-4.36,1.17,1.17,0,0,1,.53-.8,1.26,1.26,0,0,1,.72,0l1.2.17a2.94,2.94,0,0,1-.73-2,2.22,2.22,0,0,1,.27-1.46,1.65,1.65,0,0,1,.52-.5,2.28,2.28,0,0,1,1.84.19C422.47,124.36,424.7,124.07,427,123.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,132.45a6.11,6.11,0,0,0,4.49,4.06,15.52,15.52,0,0,0-.12,5.13,2.86,2.86,0,0,0,.39,1,1.28,1.28,0,0,0,.9.57c.5,0,.7-.26.86-.65a11.58,11.58,0,0,1,.75-1.44,2.5,2.5,0,0,1,4.46.27c1.07,2.46-.9,5.71-2.7,6.22-3.1.86-3.3-1.31-3.3-1.31l-.27,10.5c-2.74,2.86-12.55,2.48-10.76,0l0-3.36a18.83,18.83,0,0,1-4.05.07c-2.24-.42-3.35-2.33-4-4.79-1-4-.81-9.15-.59-12.13a23.67,23.67,0,0,1,1.42-5.74C421.26,134.64,430.2,133.67,432,132.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.68,153.47c-.46.08,5.12-.85,6.95-1.74a5.68,5.68,0,0,0,2.51-2.33,8,8,0,0,1-1.47,2.8c-1.34,1.6-8,2.63-8,2.63Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.15,140.62a1,1,0,1,0,1-1A1,1,0,0,0,428.15,140.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.9,137.28l2.19,1.27a1.32,1.32,0,0,0-.48-1.77A1.23,1.23,0,0,0,428.9,137.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,146.28l-3.43,1.6a2,2,0,0,0,2.59.93A1.86,1.86,0,0,0,428.57,146.28Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7,148.69a1.27,1.27,0,0,0,0,.28,1.94,1.94,0,0,0,1-.16,1.84,1.84,0,0,0,1-1.84l-.31,0A1.75,1.75,0,0,0,426.7,148.69Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.11,138l2.19-1.16a1.19,1.19,0,0,0-1.64-.51A1.27,1.27,0,0,0,419.11,138Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.71,140.17a1,1,0,1,0,1-1A1,1,0,0,0,419.71,140.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.1,138.84l-.36,6.76L420.9,145A25.92,25.92,0,0,1,425.1,138.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.19,157s-5,5.1-5.4,14.35c-.94,23.41,14,29.2,14,29.2a72.74,72.74,0,0,0-.45-7.72s-8.45-7.71-8-19.67c.32-8.52,4.18-13.73,6.31-14.4C446.61,158.78,443.1,156.87,440.19,157Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.19,157s-5,5.1-5.4,14.35c-.94,23.41,14,29.2,14,29.2a72.74,72.74,0,0,0-.45-7.72s-8.45-7.71-8-19.67c.32-8.52,4.18-13.73,6.31-14.4C446.61,158.78,443.1,156.87,440.19,157Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.15,200.37c-2-.45-4.31-2-7.12-4.61a83.53,83.53,0,0,1-8.21-8.59c-.45-.53-1.82-2-2.34-2.5a20.42,20.42,0,0,1-2.46-3,8.75,8.75,0,0,1-1.75-6.69c.34-3.49.5-5.88,1.59-7.39a1.94,1.94,0,0,1,1.46-.51c-.17.63-.22,1.31-.33,1.93a4.64,4.64,0,0,0,1.42,3.07c1.43,1.65,2.48,2.62,2.64,2.26s-.35-1.44-.19-3.21.64-2.42,1.18-2.56c.86-.23.86.71,1.23,2.12.45,1.68,1.19,2.6,1.3,5.09.1,2.18,0,3.06,1,4.31a37.13,37.13,0,0,0,3.57,2.85s-1.3-4-2.59-8c-2.53-7.84-1.54-14.85,1.56-16.06,4.42.2,7.14,2,9.17,8.37,2.16,6.8,2.9,9.68,4.67,23C461.27,200.17,457.54,201.12,454.15,200.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.15,183c2.81,2,8.93,5,9.75,8.28,0,0-.13-2.63-3.84-5.74a45.43,45.43,0,0,0-6.61-4.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.12,158.88a7.72,7.72,0,0,1,6.32,2.16c2.22,2,3.37,5.89,4.46,9.4s2.85,12.77,2.85,12.77a32.34,32.34,0,0,1-9.36,1.83s-2.5-1.58-3.73-2.45c0,0-2.53-8.06-3.25-10.11S441.7,160.37,446.12,158.88Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.17,173c-8.73-18.87-9.54-22-13.7-24a8.94,8.94,0,0,0-2.15-.72c-4.27,1.71-7.36,10.16-2.18,15.21,0,0,5.88,8.81,8.54,13.52-.54,4.86-1.37,12.07-2.94,15.44a4,4,0,0,1-1.87,1.76c-1.85.93-2,1.84-3.53,2.9-1.19.83-2.13.91-2,1.26a2,2,0,0,0,2.16,1.17,8.85,8.85,0,0,0,2.33-.68,15.05,15.05,0,0,1-3.13,3.43c-2.88,2.39-3.21,4.14,1.91,5.16,3.2.64,6-.71,9.19-6.78a48.88,48.88,0,0,0,3.15-6.91c1.47-4.46,3.72-10.1,4.84-15.21A7.25,7.25,0,0,0,409.17,173Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.13,196.91c2.82.58-.31,5.21-3,6.22a5.22,5.22,0,0,1-2.61.29l-.59.78c-.51-.44.33-3,1.33-4.45C391.37,198.09,393.58,196.58,395.13,196.91Z",
    style: {
      fill: "#ffa8a7"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelI);
export default __webpack_public_path__ + "static/media/travelI.d93e99a4599d0001bc0bef781b35c905.svg";
export { ForwardRef as ReactComponent };